// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/notosansjp/NotoSansJP-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/notosansjp/NotoSansJP-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/notosansjp/NotoSansJP-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/851Gkktt_005.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/Ab-j_choki.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/ethnocentric/Ethnocentric.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/ethnocentric/Ethnocentric Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/Hiragino Sans.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../icons/publish.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../icons/publish_up_arrow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../icons/edit.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../icons/settings_icon_hover.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../icons/detail_more.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../icons/detail_more_hover.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../icons/arrow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../icons/uncheck.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../icons/check.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../icons/dropdown.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../icons/copy.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../icons/plus.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../icons/minus.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../icons/grey_minus.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../icons/pink-plus.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../icons/random-plus.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../icons/random-plus-hover.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../icons/random-plus-disable.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../icons/left-arrow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../icons/left-arrow-filled.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../images/user-solid.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../images/lock-solid.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("../images/btn-hover.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Width of the scrollbar */
::-webkit-scrollbar {
  width: 5px;
}

/* Track (background) */
::-webkit-scrollbar-track {
  border-radius: 5px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 5px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Firefox */
html {
  scrollbar-color: #888; /* thumb */
  scrollbar-width: thin;
}

/* Internet Explorer & Old Edge (Optional: Only works in older versions) */
body {
  scrollbar-face-color: #888;
}

/** bootstrap custom config ****
/*
    color => ~/src/assets/scss/bootstrap/color.scss
    margin,padding and spacing => ~/src/assets/scss/bootstrap/spacer.scss
    width and height => ~/src/assets/scss/bootstrap/width_height.scss
*/
/** Generate custom font sizes */
/**
    Example Usage (you can use within 1px to 50 px)
    eg. fs-1-px, fs-20-px ...... fs-50-px
*/
.fs-1-px {
  font-size: 1px !important;
}

.fs-2-px {
  font-size: 2px !important;
}

.fs-3-px {
  font-size: 3px !important;
}

.fs-4-px {
  font-size: 4px !important;
}

.fs-5-px {
  font-size: 5px !important;
}

.fs-6-px {
  font-size: 6px !important;
}

.fs-7-px {
  font-size: 7px !important;
}

.fs-8-px {
  font-size: 8px !important;
}

.fs-9-px {
  font-size: 9px !important;
}

.fs-10-px {
  font-size: 10px !important;
}

.fs-11-px {
  font-size: 11px !important;
}

.fs-12-px {
  font-size: 12px !important;
}

.fs-13-px {
  font-size: 13px !important;
}

.fs-14-px {
  font-size: 14px !important;
}

.fs-15-px {
  font-size: 15px !important;
}

.fs-16-px {
  font-size: 16px !important;
}

.fs-17-px {
  font-size: 17px !important;
}

.fs-18-px {
  font-size: 18px !important;
}

.fs-19-px {
  font-size: 19px !important;
}

.fs-20-px {
  font-size: 20px !important;
}

.fs-21-px {
  font-size: 21px !important;
}

.fs-22-px {
  font-size: 22px !important;
}

.fs-23-px {
  font-size: 23px !important;
}

.fs-24-px {
  font-size: 24px !important;
}

.fs-25-px {
  font-size: 25px !important;
}

.fs-26-px {
  font-size: 26px !important;
}

.fs-27-px {
  font-size: 27px !important;
}

.fs-28-px {
  font-size: 28px !important;
}

.fs-29-px {
  font-size: 29px !important;
}

.fs-30-px {
  font-size: 30px !important;
}

.fs-31-px {
  font-size: 31px !important;
}

.fs-32-px {
  font-size: 32px !important;
}

.fs-33-px {
  font-size: 33px !important;
}

.fs-34-px {
  font-size: 34px !important;
}

.fs-35-px {
  font-size: 35px !important;
}

.fs-36-px {
  font-size: 36px !important;
}

.fs-37-px {
  font-size: 37px !important;
}

.fs-38-px {
  font-size: 38px !important;
}

.fs-39-px {
  font-size: 39px !important;
}

.fs-40-px {
  font-size: 40px !important;
}

.fs-41-px {
  font-size: 41px !important;
}

.fs-42-px {
  font-size: 42px !important;
}

.fs-43-px {
  font-size: 43px !important;
}

.fs-44-px {
  font-size: 44px !important;
}

.fs-45-px {
  font-size: 45px !important;
}

.fs-46-px {
  font-size: 46px !important;
}

.fs-47-px {
  font-size: 47px !important;
}

.fs-48-px {
  font-size: 48px !important;
}

.fs-49-px {
  font-size: 49px !important;
}

.fs-50-px {
  font-size: 50px !important;
}

.hover\\:fs-1-px:hover {
  font-size: 1px !important;
}

.hover\\:fs-2-px:hover {
  font-size: 2px !important;
}

.hover\\:fs-3-px:hover {
  font-size: 3px !important;
}

.hover\\:fs-4-px:hover {
  font-size: 4px !important;
}

.hover\\:fs-5-px:hover {
  font-size: 5px !important;
}

.hover\\:fs-6-px:hover {
  font-size: 6px !important;
}

.hover\\:fs-7-px:hover {
  font-size: 7px !important;
}

.hover\\:fs-8-px:hover {
  font-size: 8px !important;
}

.hover\\:fs-9-px:hover {
  font-size: 9px !important;
}

.hover\\:fs-10-px:hover {
  font-size: 10px !important;
}

.hover\\:fs-11-px:hover {
  font-size: 11px !important;
}

.hover\\:fs-12-px:hover {
  font-size: 12px !important;
}

.hover\\:fs-13-px:hover {
  font-size: 13px !important;
}

.hover\\:fs-14-px:hover {
  font-size: 14px !important;
}

.hover\\:fs-15-px:hover {
  font-size: 15px !important;
}

.hover\\:fs-16-px:hover {
  font-size: 16px !important;
}

.hover\\:fs-17-px:hover {
  font-size: 17px !important;
}

.hover\\:fs-18-px:hover {
  font-size: 18px !important;
}

.hover\\:fs-19-px:hover {
  font-size: 19px !important;
}

.hover\\:fs-20-px:hover {
  font-size: 20px !important;
}

.hover\\:fs-21-px:hover {
  font-size: 21px !important;
}

.hover\\:fs-22-px:hover {
  font-size: 22px !important;
}

.hover\\:fs-23-px:hover {
  font-size: 23px !important;
}

.hover\\:fs-24-px:hover {
  font-size: 24px !important;
}

.hover\\:fs-25-px:hover {
  font-size: 25px !important;
}

.hover\\:fs-26-px:hover {
  font-size: 26px !important;
}

.hover\\:fs-27-px:hover {
  font-size: 27px !important;
}

.hover\\:fs-28-px:hover {
  font-size: 28px !important;
}

.hover\\:fs-29-px:hover {
  font-size: 29px !important;
}

.hover\\:fs-30-px:hover {
  font-size: 30px !important;
}

.hover\\:fs-31-px:hover {
  font-size: 31px !important;
}

.hover\\:fs-32-px:hover {
  font-size: 32px !important;
}

.hover\\:fs-33-px:hover {
  font-size: 33px !important;
}

.hover\\:fs-34-px:hover {
  font-size: 34px !important;
}

.hover\\:fs-35-px:hover {
  font-size: 35px !important;
}

.hover\\:fs-36-px:hover {
  font-size: 36px !important;
}

.hover\\:fs-37-px:hover {
  font-size: 37px !important;
}

.hover\\:fs-38-px:hover {
  font-size: 38px !important;
}

.hover\\:fs-39-px:hover {
  font-size: 39px !important;
}

.hover\\:fs-40-px:hover {
  font-size: 40px !important;
}

.hover\\:fs-41-px:hover {
  font-size: 41px !important;
}

.hover\\:fs-42-px:hover {
  font-size: 42px !important;
}

.hover\\:fs-43-px:hover {
  font-size: 43px !important;
}

.hover\\:fs-44-px:hover {
  font-size: 44px !important;
}

.hover\\:fs-45-px:hover {
  font-size: 45px !important;
}

.hover\\:fs-46-px:hover {
  font-size: 46px !important;
}

.hover\\:fs-47-px:hover {
  font-size: 47px !important;
}

.hover\\:fs-48-px:hover {
  font-size: 48px !important;
}

.hover\\:fs-49-px:hover {
  font-size: 49px !important;
}

.hover\\:fs-50-px:hover {
  font-size: 50px !important;
}

.p-0-px {
  padding: 0px !important;
}

.pl-0-px {
  padding-left: 0px !important;
}

.pr-0-px {
  padding-right: 0px !important;
}

.pt-0-px {
  padding-top: 0px !important;
}

.pb-0-px {
  padding-bottom: 0px !important;
}

.px-0-px {
  padding-inline: 0px !important;
}

.py-0-px {
  padding-block: 0px !important;
}

.m-0-px {
  margin: 0px !important;
}

.ml-0-px {
  margin-left: 0px !important;
}

.mr-0-px {
  margin-right: 0px !important;
}

.mt-0-px {
  margin-top: 0px !important;
}

.mb-0-px {
  margin-bottom: 0px !important;
}

.mx-0-px {
  margin-inline: 0px !important;
}

.my-0-px {
  margin-block: 0px !important;
}

.p-1-px {
  padding: 1px !important;
}

.pl-1-px {
  padding-left: 1px !important;
}

.pr-1-px {
  padding-right: 1px !important;
}

.pt-1-px {
  padding-top: 1px !important;
}

.pb-1-px {
  padding-bottom: 1px !important;
}

.px-1-px {
  padding-inline: 1px !important;
}

.py-1-px {
  padding-block: 1px !important;
}

.m-1-px {
  margin: 1px !important;
}

.ml-1-px {
  margin-left: 1px !important;
}

.mr-1-px {
  margin-right: 1px !important;
}

.mt-1-px {
  margin-top: 1px !important;
}

.mb-1-px {
  margin-bottom: 1px !important;
}

.mx-1-px {
  margin-inline: 1px !important;
}

.my-1-px {
  margin-block: 1px !important;
}

.p-2-px {
  padding: 2px !important;
}

.pl-2-px {
  padding-left: 2px !important;
}

.pr-2-px {
  padding-right: 2px !important;
}

.pt-2-px {
  padding-top: 2px !important;
}

.pb-2-px {
  padding-bottom: 2px !important;
}

.px-2-px {
  padding-inline: 2px !important;
}

.py-2-px {
  padding-block: 2px !important;
}

.m-2-px {
  margin: 2px !important;
}

.ml-2-px {
  margin-left: 2px !important;
}

.mr-2-px {
  margin-right: 2px !important;
}

.mt-2-px {
  margin-top: 2px !important;
}

.mb-2-px {
  margin-bottom: 2px !important;
}

.mx-2-px {
  margin-inline: 2px !important;
}

.my-2-px {
  margin-block: 2px !important;
}

.p-3-px {
  padding: 3px !important;
}

.pl-3-px {
  padding-left: 3px !important;
}

.pr-3-px {
  padding-right: 3px !important;
}

.pt-3-px {
  padding-top: 3px !important;
}

.pb-3-px {
  padding-bottom: 3px !important;
}

.px-3-px {
  padding-inline: 3px !important;
}

.py-3-px {
  padding-block: 3px !important;
}

.m-3-px {
  margin: 3px !important;
}

.ml-3-px {
  margin-left: 3px !important;
}

.mr-3-px {
  margin-right: 3px !important;
}

.mt-3-px {
  margin-top: 3px !important;
}

.mb-3-px {
  margin-bottom: 3px !important;
}

.mx-3-px {
  margin-inline: 3px !important;
}

.my-3-px {
  margin-block: 3px !important;
}

.p-4-px {
  padding: 4px !important;
}

.pl-4-px {
  padding-left: 4px !important;
}

.pr-4-px {
  padding-right: 4px !important;
}

.pt-4-px {
  padding-top: 4px !important;
}

.pb-4-px {
  padding-bottom: 4px !important;
}

.px-4-px {
  padding-inline: 4px !important;
}

.py-4-px {
  padding-block: 4px !important;
}

.m-4-px {
  margin: 4px !important;
}

.ml-4-px {
  margin-left: 4px !important;
}

.mr-4-px {
  margin-right: 4px !important;
}

.mt-4-px {
  margin-top: 4px !important;
}

.mb-4-px {
  margin-bottom: 4px !important;
}

.mx-4-px {
  margin-inline: 4px !important;
}

.my-4-px {
  margin-block: 4px !important;
}

.p-5-px {
  padding: 5px !important;
}

.pl-5-px {
  padding-left: 5px !important;
}

.pr-5-px {
  padding-right: 5px !important;
}

.pt-5-px {
  padding-top: 5px !important;
}

.pb-5-px {
  padding-bottom: 5px !important;
}

.px-5-px {
  padding-inline: 5px !important;
}

.py-5-px {
  padding-block: 5px !important;
}

.m-5-px {
  margin: 5px !important;
}

.ml-5-px {
  margin-left: 5px !important;
}

.mr-5-px {
  margin-right: 5px !important;
}

.mt-5-px {
  margin-top: 5px !important;
}

.mb-5-px {
  margin-bottom: 5px !important;
}

.mx-5-px {
  margin-inline: 5px !important;
}

.my-5-px {
  margin-block: 5px !important;
}

.p-6-px {
  padding: 6px !important;
}

.pl-6-px {
  padding-left: 6px !important;
}

.pr-6-px {
  padding-right: 6px !important;
}

.pt-6-px {
  padding-top: 6px !important;
}

.pb-6-px {
  padding-bottom: 6px !important;
}

.px-6-px {
  padding-inline: 6px !important;
}

.py-6-px {
  padding-block: 6px !important;
}

.m-6-px {
  margin: 6px !important;
}

.ml-6-px {
  margin-left: 6px !important;
}

.mr-6-px {
  margin-right: 6px !important;
}

.mt-6-px {
  margin-top: 6px !important;
}

.mb-6-px {
  margin-bottom: 6px !important;
}

.mx-6-px {
  margin-inline: 6px !important;
}

.my-6-px {
  margin-block: 6px !important;
}

.p-7-px {
  padding: 7px !important;
}

.pl-7-px {
  padding-left: 7px !important;
}

.pr-7-px {
  padding-right: 7px !important;
}

.pt-7-px {
  padding-top: 7px !important;
}

.pb-7-px {
  padding-bottom: 7px !important;
}

.px-7-px {
  padding-inline: 7px !important;
}

.py-7-px {
  padding-block: 7px !important;
}

.m-7-px {
  margin: 7px !important;
}

.ml-7-px {
  margin-left: 7px !important;
}

.mr-7-px {
  margin-right: 7px !important;
}

.mt-7-px {
  margin-top: 7px !important;
}

.mb-7-px {
  margin-bottom: 7px !important;
}

.mx-7-px {
  margin-inline: 7px !important;
}

.my-7-px {
  margin-block: 7px !important;
}

.p-8-px {
  padding: 8px !important;
}

.pl-8-px {
  padding-left: 8px !important;
}

.pr-8-px {
  padding-right: 8px !important;
}

.pt-8-px {
  padding-top: 8px !important;
}

.pb-8-px {
  padding-bottom: 8px !important;
}

.px-8-px {
  padding-inline: 8px !important;
}

.py-8-px {
  padding-block: 8px !important;
}

.m-8-px {
  margin: 8px !important;
}

.ml-8-px {
  margin-left: 8px !important;
}

.mr-8-px {
  margin-right: 8px !important;
}

.mt-8-px {
  margin-top: 8px !important;
}

.mb-8-px {
  margin-bottom: 8px !important;
}

.mx-8-px {
  margin-inline: 8px !important;
}

.my-8-px {
  margin-block: 8px !important;
}

.p-9-px {
  padding: 9px !important;
}

.pl-9-px {
  padding-left: 9px !important;
}

.pr-9-px {
  padding-right: 9px !important;
}

.pt-9-px {
  padding-top: 9px !important;
}

.pb-9-px {
  padding-bottom: 9px !important;
}

.px-9-px {
  padding-inline: 9px !important;
}

.py-9-px {
  padding-block: 9px !important;
}

.m-9-px {
  margin: 9px !important;
}

.ml-9-px {
  margin-left: 9px !important;
}

.mr-9-px {
  margin-right: 9px !important;
}

.mt-9-px {
  margin-top: 9px !important;
}

.mb-9-px {
  margin-bottom: 9px !important;
}

.mx-9-px {
  margin-inline: 9px !important;
}

.my-9-px {
  margin-block: 9px !important;
}

.p-10-px {
  padding: 10px !important;
}

.pl-10-px {
  padding-left: 10px !important;
}

.pr-10-px {
  padding-right: 10px !important;
}

.pt-10-px {
  padding-top: 10px !important;
}

.pb-10-px {
  padding-bottom: 10px !important;
}

.px-10-px {
  padding-inline: 10px !important;
}

.py-10-px {
  padding-block: 10px !important;
}

.m-10-px {
  margin: 10px !important;
}

.ml-10-px {
  margin-left: 10px !important;
}

.mr-10-px {
  margin-right: 10px !important;
}

.mt-10-px {
  margin-top: 10px !important;
}

.mb-10-px {
  margin-bottom: 10px !important;
}

.mx-10-px {
  margin-inline: 10px !important;
}

.my-10-px {
  margin-block: 10px !important;
}

.p-11-px {
  padding: 11px !important;
}

.pl-11-px {
  padding-left: 11px !important;
}

.pr-11-px {
  padding-right: 11px !important;
}

.pt-11-px {
  padding-top: 11px !important;
}

.pb-11-px {
  padding-bottom: 11px !important;
}

.px-11-px {
  padding-inline: 11px !important;
}

.py-11-px {
  padding-block: 11px !important;
}

.m-11-px {
  margin: 11px !important;
}

.ml-11-px {
  margin-left: 11px !important;
}

.mr-11-px {
  margin-right: 11px !important;
}

.mt-11-px {
  margin-top: 11px !important;
}

.mb-11-px {
  margin-bottom: 11px !important;
}

.mx-11-px {
  margin-inline: 11px !important;
}

.my-11-px {
  margin-block: 11px !important;
}

.p-12-px {
  padding: 12px !important;
}

.pl-12-px {
  padding-left: 12px !important;
}

.pr-12-px {
  padding-right: 12px !important;
}

.pt-12-px {
  padding-top: 12px !important;
}

.pb-12-px {
  padding-bottom: 12px !important;
}

.px-12-px {
  padding-inline: 12px !important;
}

.py-12-px {
  padding-block: 12px !important;
}

.m-12-px {
  margin: 12px !important;
}

.ml-12-px {
  margin-left: 12px !important;
}

.mr-12-px {
  margin-right: 12px !important;
}

.mt-12-px {
  margin-top: 12px !important;
}

.mb-12-px {
  margin-bottom: 12px !important;
}

.mx-12-px {
  margin-inline: 12px !important;
}

.my-12-px {
  margin-block: 12px !important;
}

.p-13-px {
  padding: 13px !important;
}

.pl-13-px {
  padding-left: 13px !important;
}

.pr-13-px {
  padding-right: 13px !important;
}

.pt-13-px {
  padding-top: 13px !important;
}

.pb-13-px {
  padding-bottom: 13px !important;
}

.px-13-px {
  padding-inline: 13px !important;
}

.py-13-px {
  padding-block: 13px !important;
}

.m-13-px {
  margin: 13px !important;
}

.ml-13-px {
  margin-left: 13px !important;
}

.mr-13-px {
  margin-right: 13px !important;
}

.mt-13-px {
  margin-top: 13px !important;
}

.mb-13-px {
  margin-bottom: 13px !important;
}

.mx-13-px {
  margin-inline: 13px !important;
}

.my-13-px {
  margin-block: 13px !important;
}

.p-14-px {
  padding: 14px !important;
}

.pl-14-px {
  padding-left: 14px !important;
}

.pr-14-px {
  padding-right: 14px !important;
}

.pt-14-px {
  padding-top: 14px !important;
}

.pb-14-px {
  padding-bottom: 14px !important;
}

.px-14-px {
  padding-inline: 14px !important;
}

.py-14-px {
  padding-block: 14px !important;
}

.m-14-px {
  margin: 14px !important;
}

.ml-14-px {
  margin-left: 14px !important;
}

.mr-14-px {
  margin-right: 14px !important;
}

.mt-14-px {
  margin-top: 14px !important;
}

.mb-14-px {
  margin-bottom: 14px !important;
}

.mx-14-px {
  margin-inline: 14px !important;
}

.my-14-px {
  margin-block: 14px !important;
}

.p-15-px {
  padding: 15px !important;
}

.pl-15-px {
  padding-left: 15px !important;
}

.pr-15-px {
  padding-right: 15px !important;
}

.pt-15-px {
  padding-top: 15px !important;
}

.pb-15-px {
  padding-bottom: 15px !important;
}

.px-15-px {
  padding-inline: 15px !important;
}

.py-15-px {
  padding-block: 15px !important;
}

.m-15-px {
  margin: 15px !important;
}

.ml-15-px {
  margin-left: 15px !important;
}

.mr-15-px {
  margin-right: 15px !important;
}

.mt-15-px {
  margin-top: 15px !important;
}

.mb-15-px {
  margin-bottom: 15px !important;
}

.mx-15-px {
  margin-inline: 15px !important;
}

.my-15-px {
  margin-block: 15px !important;
}

.p-16-px {
  padding: 16px !important;
}

.pl-16-px {
  padding-left: 16px !important;
}

.pr-16-px {
  padding-right: 16px !important;
}

.pt-16-px {
  padding-top: 16px !important;
}

.pb-16-px {
  padding-bottom: 16px !important;
}

.px-16-px {
  padding-inline: 16px !important;
}

.py-16-px {
  padding-block: 16px !important;
}

.m-16-px {
  margin: 16px !important;
}

.ml-16-px {
  margin-left: 16px !important;
}

.mr-16-px {
  margin-right: 16px !important;
}

.mt-16-px {
  margin-top: 16px !important;
}

.mb-16-px {
  margin-bottom: 16px !important;
}

.mx-16-px {
  margin-inline: 16px !important;
}

.my-16-px {
  margin-block: 16px !important;
}

.p-17-px {
  padding: 17px !important;
}

.pl-17-px {
  padding-left: 17px !important;
}

.pr-17-px {
  padding-right: 17px !important;
}

.pt-17-px {
  padding-top: 17px !important;
}

.pb-17-px {
  padding-bottom: 17px !important;
}

.px-17-px {
  padding-inline: 17px !important;
}

.py-17-px {
  padding-block: 17px !important;
}

.m-17-px {
  margin: 17px !important;
}

.ml-17-px {
  margin-left: 17px !important;
}

.mr-17-px {
  margin-right: 17px !important;
}

.mt-17-px {
  margin-top: 17px !important;
}

.mb-17-px {
  margin-bottom: 17px !important;
}

.mx-17-px {
  margin-inline: 17px !important;
}

.my-17-px {
  margin-block: 17px !important;
}

.p-18-px {
  padding: 18px !important;
}

.pl-18-px {
  padding-left: 18px !important;
}

.pr-18-px {
  padding-right: 18px !important;
}

.pt-18-px {
  padding-top: 18px !important;
}

.pb-18-px {
  padding-bottom: 18px !important;
}

.px-18-px {
  padding-inline: 18px !important;
}

.py-18-px {
  padding-block: 18px !important;
}

.m-18-px {
  margin: 18px !important;
}

.ml-18-px {
  margin-left: 18px !important;
}

.mr-18-px {
  margin-right: 18px !important;
}

.mt-18-px {
  margin-top: 18px !important;
}

.mb-18-px {
  margin-bottom: 18px !important;
}

.mx-18-px {
  margin-inline: 18px !important;
}

.my-18-px {
  margin-block: 18px !important;
}

.p-19-px {
  padding: 19px !important;
}

.pl-19-px {
  padding-left: 19px !important;
}

.pr-19-px {
  padding-right: 19px !important;
}

.pt-19-px {
  padding-top: 19px !important;
}

.pb-19-px {
  padding-bottom: 19px !important;
}

.px-19-px {
  padding-inline: 19px !important;
}

.py-19-px {
  padding-block: 19px !important;
}

.m-19-px {
  margin: 19px !important;
}

.ml-19-px {
  margin-left: 19px !important;
}

.mr-19-px {
  margin-right: 19px !important;
}

.mt-19-px {
  margin-top: 19px !important;
}

.mb-19-px {
  margin-bottom: 19px !important;
}

.mx-19-px {
  margin-inline: 19px !important;
}

.my-19-px {
  margin-block: 19px !important;
}

.p-20-px {
  padding: 20px !important;
}

.pl-20-px {
  padding-left: 20px !important;
}

.pr-20-px {
  padding-right: 20px !important;
}

.pt-20-px {
  padding-top: 20px !important;
}

.pb-20-px {
  padding-bottom: 20px !important;
}

.px-20-px {
  padding-inline: 20px !important;
}

.py-20-px {
  padding-block: 20px !important;
}

.m-20-px {
  margin: 20px !important;
}

.ml-20-px {
  margin-left: 20px !important;
}

.mr-20-px {
  margin-right: 20px !important;
}

.mt-20-px {
  margin-top: 20px !important;
}

.mb-20-px {
  margin-bottom: 20px !important;
}

.mx-20-px {
  margin-inline: 20px !important;
}

.my-20-px {
  margin-block: 20px !important;
}

.p-21-px {
  padding: 21px !important;
}

.pl-21-px {
  padding-left: 21px !important;
}

.pr-21-px {
  padding-right: 21px !important;
}

.pt-21-px {
  padding-top: 21px !important;
}

.pb-21-px {
  padding-bottom: 21px !important;
}

.px-21-px {
  padding-inline: 21px !important;
}

.py-21-px {
  padding-block: 21px !important;
}

.m-21-px {
  margin: 21px !important;
}

.ml-21-px {
  margin-left: 21px !important;
}

.mr-21-px {
  margin-right: 21px !important;
}

.mt-21-px {
  margin-top: 21px !important;
}

.mb-21-px {
  margin-bottom: 21px !important;
}

.mx-21-px {
  margin-inline: 21px !important;
}

.my-21-px {
  margin-block: 21px !important;
}

.p-22-px {
  padding: 22px !important;
}

.pl-22-px {
  padding-left: 22px !important;
}

.pr-22-px {
  padding-right: 22px !important;
}

.pt-22-px {
  padding-top: 22px !important;
}

.pb-22-px {
  padding-bottom: 22px !important;
}

.px-22-px {
  padding-inline: 22px !important;
}

.py-22-px {
  padding-block: 22px !important;
}

.m-22-px {
  margin: 22px !important;
}

.ml-22-px {
  margin-left: 22px !important;
}

.mr-22-px {
  margin-right: 22px !important;
}

.mt-22-px {
  margin-top: 22px !important;
}

.mb-22-px {
  margin-bottom: 22px !important;
}

.mx-22-px {
  margin-inline: 22px !important;
}

.my-22-px {
  margin-block: 22px !important;
}

.p-23-px {
  padding: 23px !important;
}

.pl-23-px {
  padding-left: 23px !important;
}

.pr-23-px {
  padding-right: 23px !important;
}

.pt-23-px {
  padding-top: 23px !important;
}

.pb-23-px {
  padding-bottom: 23px !important;
}

.px-23-px {
  padding-inline: 23px !important;
}

.py-23-px {
  padding-block: 23px !important;
}

.m-23-px {
  margin: 23px !important;
}

.ml-23-px {
  margin-left: 23px !important;
}

.mr-23-px {
  margin-right: 23px !important;
}

.mt-23-px {
  margin-top: 23px !important;
}

.mb-23-px {
  margin-bottom: 23px !important;
}

.mx-23-px {
  margin-inline: 23px !important;
}

.my-23-px {
  margin-block: 23px !important;
}

.p-24-px {
  padding: 24px !important;
}

.pl-24-px {
  padding-left: 24px !important;
}

.pr-24-px {
  padding-right: 24px !important;
}

.pt-24-px {
  padding-top: 24px !important;
}

.pb-24-px {
  padding-bottom: 24px !important;
}

.px-24-px {
  padding-inline: 24px !important;
}

.py-24-px {
  padding-block: 24px !important;
}

.m-24-px {
  margin: 24px !important;
}

.ml-24-px {
  margin-left: 24px !important;
}

.mr-24-px {
  margin-right: 24px !important;
}

.mt-24-px {
  margin-top: 24px !important;
}

.mb-24-px {
  margin-bottom: 24px !important;
}

.mx-24-px {
  margin-inline: 24px !important;
}

.my-24-px {
  margin-block: 24px !important;
}

.p-25-px {
  padding: 25px !important;
}

.pl-25-px {
  padding-left: 25px !important;
}

.pr-25-px {
  padding-right: 25px !important;
}

.pt-25-px {
  padding-top: 25px !important;
}

.pb-25-px {
  padding-bottom: 25px !important;
}

.px-25-px {
  padding-inline: 25px !important;
}

.py-25-px {
  padding-block: 25px !important;
}

.m-25-px {
  margin: 25px !important;
}

.ml-25-px {
  margin-left: 25px !important;
}

.mr-25-px {
  margin-right: 25px !important;
}

.mt-25-px {
  margin-top: 25px !important;
}

.mb-25-px {
  margin-bottom: 25px !important;
}

.mx-25-px {
  margin-inline: 25px !important;
}

.my-25-px {
  margin-block: 25px !important;
}

.p-26-px {
  padding: 26px !important;
}

.pl-26-px {
  padding-left: 26px !important;
}

.pr-26-px {
  padding-right: 26px !important;
}

.pt-26-px {
  padding-top: 26px !important;
}

.pb-26-px {
  padding-bottom: 26px !important;
}

.px-26-px {
  padding-inline: 26px !important;
}

.py-26-px {
  padding-block: 26px !important;
}

.m-26-px {
  margin: 26px !important;
}

.ml-26-px {
  margin-left: 26px !important;
}

.mr-26-px {
  margin-right: 26px !important;
}

.mt-26-px {
  margin-top: 26px !important;
}

.mb-26-px {
  margin-bottom: 26px !important;
}

.mx-26-px {
  margin-inline: 26px !important;
}

.my-26-px {
  margin-block: 26px !important;
}

.p-27-px {
  padding: 27px !important;
}

.pl-27-px {
  padding-left: 27px !important;
}

.pr-27-px {
  padding-right: 27px !important;
}

.pt-27-px {
  padding-top: 27px !important;
}

.pb-27-px {
  padding-bottom: 27px !important;
}

.px-27-px {
  padding-inline: 27px !important;
}

.py-27-px {
  padding-block: 27px !important;
}

.m-27-px {
  margin: 27px !important;
}

.ml-27-px {
  margin-left: 27px !important;
}

.mr-27-px {
  margin-right: 27px !important;
}

.mt-27-px {
  margin-top: 27px !important;
}

.mb-27-px {
  margin-bottom: 27px !important;
}

.mx-27-px {
  margin-inline: 27px !important;
}

.my-27-px {
  margin-block: 27px !important;
}

.p-28-px {
  padding: 28px !important;
}

.pl-28-px {
  padding-left: 28px !important;
}

.pr-28-px {
  padding-right: 28px !important;
}

.pt-28-px {
  padding-top: 28px !important;
}

.pb-28-px {
  padding-bottom: 28px !important;
}

.px-28-px {
  padding-inline: 28px !important;
}

.py-28-px {
  padding-block: 28px !important;
}

.m-28-px {
  margin: 28px !important;
}

.ml-28-px {
  margin-left: 28px !important;
}

.mr-28-px {
  margin-right: 28px !important;
}

.mt-28-px {
  margin-top: 28px !important;
}

.mb-28-px {
  margin-bottom: 28px !important;
}

.mx-28-px {
  margin-inline: 28px !important;
}

.my-28-px {
  margin-block: 28px !important;
}

.p-29-px {
  padding: 29px !important;
}

.pl-29-px {
  padding-left: 29px !important;
}

.pr-29-px {
  padding-right: 29px !important;
}

.pt-29-px {
  padding-top: 29px !important;
}

.pb-29-px {
  padding-bottom: 29px !important;
}

.px-29-px {
  padding-inline: 29px !important;
}

.py-29-px {
  padding-block: 29px !important;
}

.m-29-px {
  margin: 29px !important;
}

.ml-29-px {
  margin-left: 29px !important;
}

.mr-29-px {
  margin-right: 29px !important;
}

.mt-29-px {
  margin-top: 29px !important;
}

.mb-29-px {
  margin-bottom: 29px !important;
}

.mx-29-px {
  margin-inline: 29px !important;
}

.my-29-px {
  margin-block: 29px !important;
}

.p-30-px {
  padding: 30px !important;
}

.pl-30-px {
  padding-left: 30px !important;
}

.pr-30-px {
  padding-right: 30px !important;
}

.pt-30-px {
  padding-top: 30px !important;
}

.pb-30-px {
  padding-bottom: 30px !important;
}

.px-30-px {
  padding-inline: 30px !important;
}

.py-30-px {
  padding-block: 30px !important;
}

.m-30-px {
  margin: 30px !important;
}

.ml-30-px {
  margin-left: 30px !important;
}

.mr-30-px {
  margin-right: 30px !important;
}

.mt-30-px {
  margin-top: 30px !important;
}

.mb-30-px {
  margin-bottom: 30px !important;
}

.mx-30-px {
  margin-inline: 30px !important;
}

.my-30-px {
  margin-block: 30px !important;
}

.p-31-px {
  padding: 31px !important;
}

.pl-31-px {
  padding-left: 31px !important;
}

.pr-31-px {
  padding-right: 31px !important;
}

.pt-31-px {
  padding-top: 31px !important;
}

.pb-31-px {
  padding-bottom: 31px !important;
}

.px-31-px {
  padding-inline: 31px !important;
}

.py-31-px {
  padding-block: 31px !important;
}

.m-31-px {
  margin: 31px !important;
}

.ml-31-px {
  margin-left: 31px !important;
}

.mr-31-px {
  margin-right: 31px !important;
}

.mt-31-px {
  margin-top: 31px !important;
}

.mb-31-px {
  margin-bottom: 31px !important;
}

.mx-31-px {
  margin-inline: 31px !important;
}

.my-31-px {
  margin-block: 31px !important;
}

.p-32-px {
  padding: 32px !important;
}

.pl-32-px {
  padding-left: 32px !important;
}

.pr-32-px {
  padding-right: 32px !important;
}

.pt-32-px {
  padding-top: 32px !important;
}

.pb-32-px {
  padding-bottom: 32px !important;
}

.px-32-px {
  padding-inline: 32px !important;
}

.py-32-px {
  padding-block: 32px !important;
}

.m-32-px {
  margin: 32px !important;
}

.ml-32-px {
  margin-left: 32px !important;
}

.mr-32-px {
  margin-right: 32px !important;
}

.mt-32-px {
  margin-top: 32px !important;
}

.mb-32-px {
  margin-bottom: 32px !important;
}

.mx-32-px {
  margin-inline: 32px !important;
}

.my-32-px {
  margin-block: 32px !important;
}

.p-33-px {
  padding: 33px !important;
}

.pl-33-px {
  padding-left: 33px !important;
}

.pr-33-px {
  padding-right: 33px !important;
}

.pt-33-px {
  padding-top: 33px !important;
}

.pb-33-px {
  padding-bottom: 33px !important;
}

.px-33-px {
  padding-inline: 33px !important;
}

.py-33-px {
  padding-block: 33px !important;
}

.m-33-px {
  margin: 33px !important;
}

.ml-33-px {
  margin-left: 33px !important;
}

.mr-33-px {
  margin-right: 33px !important;
}

.mt-33-px {
  margin-top: 33px !important;
}

.mb-33-px {
  margin-bottom: 33px !important;
}

.mx-33-px {
  margin-inline: 33px !important;
}

.my-33-px {
  margin-block: 33px !important;
}

.p-34-px {
  padding: 34px !important;
}

.pl-34-px {
  padding-left: 34px !important;
}

.pr-34-px {
  padding-right: 34px !important;
}

.pt-34-px {
  padding-top: 34px !important;
}

.pb-34-px {
  padding-bottom: 34px !important;
}

.px-34-px {
  padding-inline: 34px !important;
}

.py-34-px {
  padding-block: 34px !important;
}

.m-34-px {
  margin: 34px !important;
}

.ml-34-px {
  margin-left: 34px !important;
}

.mr-34-px {
  margin-right: 34px !important;
}

.mt-34-px {
  margin-top: 34px !important;
}

.mb-34-px {
  margin-bottom: 34px !important;
}

.mx-34-px {
  margin-inline: 34px !important;
}

.my-34-px {
  margin-block: 34px !important;
}

.p-35-px {
  padding: 35px !important;
}

.pl-35-px {
  padding-left: 35px !important;
}

.pr-35-px {
  padding-right: 35px !important;
}

.pt-35-px {
  padding-top: 35px !important;
}

.pb-35-px {
  padding-bottom: 35px !important;
}

.px-35-px {
  padding-inline: 35px !important;
}

.py-35-px {
  padding-block: 35px !important;
}

.m-35-px {
  margin: 35px !important;
}

.ml-35-px {
  margin-left: 35px !important;
}

.mr-35-px {
  margin-right: 35px !important;
}

.mt-35-px {
  margin-top: 35px !important;
}

.mb-35-px {
  margin-bottom: 35px !important;
}

.mx-35-px {
  margin-inline: 35px !important;
}

.my-35-px {
  margin-block: 35px !important;
}

.p-36-px {
  padding: 36px !important;
}

.pl-36-px {
  padding-left: 36px !important;
}

.pr-36-px {
  padding-right: 36px !important;
}

.pt-36-px {
  padding-top: 36px !important;
}

.pb-36-px {
  padding-bottom: 36px !important;
}

.px-36-px {
  padding-inline: 36px !important;
}

.py-36-px {
  padding-block: 36px !important;
}

.m-36-px {
  margin: 36px !important;
}

.ml-36-px {
  margin-left: 36px !important;
}

.mr-36-px {
  margin-right: 36px !important;
}

.mt-36-px {
  margin-top: 36px !important;
}

.mb-36-px {
  margin-bottom: 36px !important;
}

.mx-36-px {
  margin-inline: 36px !important;
}

.my-36-px {
  margin-block: 36px !important;
}

.p-37-px {
  padding: 37px !important;
}

.pl-37-px {
  padding-left: 37px !important;
}

.pr-37-px {
  padding-right: 37px !important;
}

.pt-37-px {
  padding-top: 37px !important;
}

.pb-37-px {
  padding-bottom: 37px !important;
}

.px-37-px {
  padding-inline: 37px !important;
}

.py-37-px {
  padding-block: 37px !important;
}

.m-37-px {
  margin: 37px !important;
}

.ml-37-px {
  margin-left: 37px !important;
}

.mr-37-px {
  margin-right: 37px !important;
}

.mt-37-px {
  margin-top: 37px !important;
}

.mb-37-px {
  margin-bottom: 37px !important;
}

.mx-37-px {
  margin-inline: 37px !important;
}

.my-37-px {
  margin-block: 37px !important;
}

.p-38-px {
  padding: 38px !important;
}

.pl-38-px {
  padding-left: 38px !important;
}

.pr-38-px {
  padding-right: 38px !important;
}

.pt-38-px {
  padding-top: 38px !important;
}

.pb-38-px {
  padding-bottom: 38px !important;
}

.px-38-px {
  padding-inline: 38px !important;
}

.py-38-px {
  padding-block: 38px !important;
}

.m-38-px {
  margin: 38px !important;
}

.ml-38-px {
  margin-left: 38px !important;
}

.mr-38-px {
  margin-right: 38px !important;
}

.mt-38-px {
  margin-top: 38px !important;
}

.mb-38-px {
  margin-bottom: 38px !important;
}

.mx-38-px {
  margin-inline: 38px !important;
}

.my-38-px {
  margin-block: 38px !important;
}

.p-39-px {
  padding: 39px !important;
}

.pl-39-px {
  padding-left: 39px !important;
}

.pr-39-px {
  padding-right: 39px !important;
}

.pt-39-px {
  padding-top: 39px !important;
}

.pb-39-px {
  padding-bottom: 39px !important;
}

.px-39-px {
  padding-inline: 39px !important;
}

.py-39-px {
  padding-block: 39px !important;
}

.m-39-px {
  margin: 39px !important;
}

.ml-39-px {
  margin-left: 39px !important;
}

.mr-39-px {
  margin-right: 39px !important;
}

.mt-39-px {
  margin-top: 39px !important;
}

.mb-39-px {
  margin-bottom: 39px !important;
}

.mx-39-px {
  margin-inline: 39px !important;
}

.my-39-px {
  margin-block: 39px !important;
}

.p-40-px {
  padding: 40px !important;
}

.pl-40-px {
  padding-left: 40px !important;
}

.pr-40-px {
  padding-right: 40px !important;
}

.pt-40-px {
  padding-top: 40px !important;
}

.pb-40-px {
  padding-bottom: 40px !important;
}

.px-40-px {
  padding-inline: 40px !important;
}

.py-40-px {
  padding-block: 40px !important;
}

.m-40-px {
  margin: 40px !important;
}

.ml-40-px {
  margin-left: 40px !important;
}

.mr-40-px {
  margin-right: 40px !important;
}

.mt-40-px {
  margin-top: 40px !important;
}

.mb-40-px {
  margin-bottom: 40px !important;
}

.mx-40-px {
  margin-inline: 40px !important;
}

.my-40-px {
  margin-block: 40px !important;
}

.p-41-px {
  padding: 41px !important;
}

.pl-41-px {
  padding-left: 41px !important;
}

.pr-41-px {
  padding-right: 41px !important;
}

.pt-41-px {
  padding-top: 41px !important;
}

.pb-41-px {
  padding-bottom: 41px !important;
}

.px-41-px {
  padding-inline: 41px !important;
}

.py-41-px {
  padding-block: 41px !important;
}

.m-41-px {
  margin: 41px !important;
}

.ml-41-px {
  margin-left: 41px !important;
}

.mr-41-px {
  margin-right: 41px !important;
}

.mt-41-px {
  margin-top: 41px !important;
}

.mb-41-px {
  margin-bottom: 41px !important;
}

.mx-41-px {
  margin-inline: 41px !important;
}

.my-41-px {
  margin-block: 41px !important;
}

.p-42-px {
  padding: 42px !important;
}

.pl-42-px {
  padding-left: 42px !important;
}

.pr-42-px {
  padding-right: 42px !important;
}

.pt-42-px {
  padding-top: 42px !important;
}

.pb-42-px {
  padding-bottom: 42px !important;
}

.px-42-px {
  padding-inline: 42px !important;
}

.py-42-px {
  padding-block: 42px !important;
}

.m-42-px {
  margin: 42px !important;
}

.ml-42-px {
  margin-left: 42px !important;
}

.mr-42-px {
  margin-right: 42px !important;
}

.mt-42-px {
  margin-top: 42px !important;
}

.mb-42-px {
  margin-bottom: 42px !important;
}

.mx-42-px {
  margin-inline: 42px !important;
}

.my-42-px {
  margin-block: 42px !important;
}

.p-43-px {
  padding: 43px !important;
}

.pl-43-px {
  padding-left: 43px !important;
}

.pr-43-px {
  padding-right: 43px !important;
}

.pt-43-px {
  padding-top: 43px !important;
}

.pb-43-px {
  padding-bottom: 43px !important;
}

.px-43-px {
  padding-inline: 43px !important;
}

.py-43-px {
  padding-block: 43px !important;
}

.m-43-px {
  margin: 43px !important;
}

.ml-43-px {
  margin-left: 43px !important;
}

.mr-43-px {
  margin-right: 43px !important;
}

.mt-43-px {
  margin-top: 43px !important;
}

.mb-43-px {
  margin-bottom: 43px !important;
}

.mx-43-px {
  margin-inline: 43px !important;
}

.my-43-px {
  margin-block: 43px !important;
}

.p-44-px {
  padding: 44px !important;
}

.pl-44-px {
  padding-left: 44px !important;
}

.pr-44-px {
  padding-right: 44px !important;
}

.pt-44-px {
  padding-top: 44px !important;
}

.pb-44-px {
  padding-bottom: 44px !important;
}

.px-44-px {
  padding-inline: 44px !important;
}

.py-44-px {
  padding-block: 44px !important;
}

.m-44-px {
  margin: 44px !important;
}

.ml-44-px {
  margin-left: 44px !important;
}

.mr-44-px {
  margin-right: 44px !important;
}

.mt-44-px {
  margin-top: 44px !important;
}

.mb-44-px {
  margin-bottom: 44px !important;
}

.mx-44-px {
  margin-inline: 44px !important;
}

.my-44-px {
  margin-block: 44px !important;
}

.p-45-px {
  padding: 45px !important;
}

.pl-45-px {
  padding-left: 45px !important;
}

.pr-45-px {
  padding-right: 45px !important;
}

.pt-45-px {
  padding-top: 45px !important;
}

.pb-45-px {
  padding-bottom: 45px !important;
}

.px-45-px {
  padding-inline: 45px !important;
}

.py-45-px {
  padding-block: 45px !important;
}

.m-45-px {
  margin: 45px !important;
}

.ml-45-px {
  margin-left: 45px !important;
}

.mr-45-px {
  margin-right: 45px !important;
}

.mt-45-px {
  margin-top: 45px !important;
}

.mb-45-px {
  margin-bottom: 45px !important;
}

.mx-45-px {
  margin-inline: 45px !important;
}

.my-45-px {
  margin-block: 45px !important;
}

.p-46-px {
  padding: 46px !important;
}

.pl-46-px {
  padding-left: 46px !important;
}

.pr-46-px {
  padding-right: 46px !important;
}

.pt-46-px {
  padding-top: 46px !important;
}

.pb-46-px {
  padding-bottom: 46px !important;
}

.px-46-px {
  padding-inline: 46px !important;
}

.py-46-px {
  padding-block: 46px !important;
}

.m-46-px {
  margin: 46px !important;
}

.ml-46-px {
  margin-left: 46px !important;
}

.mr-46-px {
  margin-right: 46px !important;
}

.mt-46-px {
  margin-top: 46px !important;
}

.mb-46-px {
  margin-bottom: 46px !important;
}

.mx-46-px {
  margin-inline: 46px !important;
}

.my-46-px {
  margin-block: 46px !important;
}

.p-47-px {
  padding: 47px !important;
}

.pl-47-px {
  padding-left: 47px !important;
}

.pr-47-px {
  padding-right: 47px !important;
}

.pt-47-px {
  padding-top: 47px !important;
}

.pb-47-px {
  padding-bottom: 47px !important;
}

.px-47-px {
  padding-inline: 47px !important;
}

.py-47-px {
  padding-block: 47px !important;
}

.m-47-px {
  margin: 47px !important;
}

.ml-47-px {
  margin-left: 47px !important;
}

.mr-47-px {
  margin-right: 47px !important;
}

.mt-47-px {
  margin-top: 47px !important;
}

.mb-47-px {
  margin-bottom: 47px !important;
}

.mx-47-px {
  margin-inline: 47px !important;
}

.my-47-px {
  margin-block: 47px !important;
}

.p-48-px {
  padding: 48px !important;
}

.pl-48-px {
  padding-left: 48px !important;
}

.pr-48-px {
  padding-right: 48px !important;
}

.pt-48-px {
  padding-top: 48px !important;
}

.pb-48-px {
  padding-bottom: 48px !important;
}

.px-48-px {
  padding-inline: 48px !important;
}

.py-48-px {
  padding-block: 48px !important;
}

.m-48-px {
  margin: 48px !important;
}

.ml-48-px {
  margin-left: 48px !important;
}

.mr-48-px {
  margin-right: 48px !important;
}

.mt-48-px {
  margin-top: 48px !important;
}

.mb-48-px {
  margin-bottom: 48px !important;
}

.mx-48-px {
  margin-inline: 48px !important;
}

.my-48-px {
  margin-block: 48px !important;
}

.p-49-px {
  padding: 49px !important;
}

.pl-49-px {
  padding-left: 49px !important;
}

.pr-49-px {
  padding-right: 49px !important;
}

.pt-49-px {
  padding-top: 49px !important;
}

.pb-49-px {
  padding-bottom: 49px !important;
}

.px-49-px {
  padding-inline: 49px !important;
}

.py-49-px {
  padding-block: 49px !important;
}

.m-49-px {
  margin: 49px !important;
}

.ml-49-px {
  margin-left: 49px !important;
}

.mr-49-px {
  margin-right: 49px !important;
}

.mt-49-px {
  margin-top: 49px !important;
}

.mb-49-px {
  margin-bottom: 49px !important;
}

.mx-49-px {
  margin-inline: 49px !important;
}

.my-49-px {
  margin-block: 49px !important;
}

.p-50-px {
  padding: 50px !important;
}

.pl-50-px {
  padding-left: 50px !important;
}

.pr-50-px {
  padding-right: 50px !important;
}

.pt-50-px {
  padding-top: 50px !important;
}

.pb-50-px {
  padding-bottom: 50px !important;
}

.px-50-px {
  padding-inline: 50px !important;
}

.py-50-px {
  padding-block: 50px !important;
}

.m-50-px {
  margin: 50px !important;
}

.ml-50-px {
  margin-left: 50px !important;
}

.mr-50-px {
  margin-right: 50px !important;
}

.mt-50-px {
  margin-top: 50px !important;
}

.mb-50-px {
  margin-bottom: 50px !important;
}

.mx-50-px {
  margin-inline: 50px !important;
}

.my-50-px {
  margin-block: 50px !important;
}

.ml-150-px {
  margin-left: 150px;
}

.ml-100-px {
  margin-left: 100px;
}

/** End generate custom font sizes */
.pt-1\\/2 {
  padding-top: 0.5px !important;
}

.required-label {
  position: relative;
  right: 0;
  top: 0.2rem;
}

.login-input input, .button-input input,
.button-input textarea, .text-input-white-caret input,
.text-input-white-caret textarea, .text-input-lesser-opacity input,
.text-input-lesser-opacity textarea, .text-input-big-border input,
.text-input-big-border textarea, .text-input-bigger-border input,
.text-input-bigger-border textarea, .text-input-lesser-radius input,
.text-input-lesser-radius textarea, .text-input input,
.text-input textarea {
  outline: none;
  border: none;
  background-image: none;
  background-color: transparent;
  box-shadow: none;
}

/** font family */
@font-face {
  font-family: "NotoSansJP";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: "NotoSansJP-Medium";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: "NotoSansJP-light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.font-notosans-jp {
  font-family: "NotoSansJP" !important;
}

.font-notosans-jp-medium {
  font-family: "NotoSansJP-Medium" !important;
}

.font-notosans-jp-light {
  font-family: "NotoSansJP-light" !important;
}

@font-face {
  font-family: "851ゴチカクット";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.font-gkktt {
  font-family: "851ゴチカクット" !important;
}

@font-face {
  font-family: "Ab-j_choki";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
}
.font-abj-choki {
  font-family: "Ab-j_choki" !important;
}

@font-face {
  font-family: "Ethno";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.font-ethno {
  font-family: "Ethno" !important;
}

@font-face {
  font-family: "ethnocentric";
  src: url("https://use.typekit.net/af/03258e/000000000000000077359660/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n3&v=3") format("woff2"), url("https://use.typekit.net/af/03258e/000000000000000077359660/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n3&v=3") format("woff"), url("https://use.typekit.net/af/03258e/000000000000000077359660/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n3&v=3") format("opentype");
  font-display: auto;
  font-style: normal;
  font-weight: 300;
  font-stretch: normal;
}
.font-ethno-normal {
  font-family: "ethnocentric" !important;
  font-weight: 900;
}

@font-face {
  font-family: "ethno-light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.font-ethno-light {
  font-family: "ethno-light" !important;
  font-weight: 300;
}

.font-ethno-bold {
  font-family: "ethno-light" !important;
  font-weight: 900;
}

@font-face {
  font-family: "Europa";
  src: url("//db.onlinewebfonts.com/t/23c0fcab84d99da0de762de7e220a6e1.eot");
  src: url("//db.onlinewebfonts.com/t/23c0fcab84d99da0de762de7e220a6e1.eot?#iefix") format("embedded-opentype"), url("//db.onlinewebfonts.com/t/23c0fcab84d99da0de762de7e220a6e1.woff2") format("woff2"), url("//db.onlinewebfonts.com/t/23c0fcab84d99da0de762de7e220a6e1.woff") format("woff"), url("//db.onlinewebfonts.com/t/23c0fcab84d99da0de762de7e220a6e1.ttf") format("truetype"), url("//db.onlinewebfonts.com/t/23c0fcab84d99da0de762de7e220a6e1.svg#Europa") format("svg");
}
.font-europa-regular {
  font-family: "Europa" !important;
}

@font-face {
  font-family: "Hiragino Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.font-hiragino-sans {
  font-family: "Hiragino Sans" !important;
}

/** end font family */
.hide-scroll {
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
}
.hide-scroll::-webkit-scrollbar {
  display: none;
}

/** colors */
.text-gray {
  color: #b4b4b4 !important;
}

.text-dark-gray {
  color: #9a9a9a !important;
}

.text-highlight {
  color: #dcc97e !important;
}

.text-light {
  color: #ffffff !important;
}

.text-light-primary {
  color: #ff996a !important;
}

/** end colors */
/** Menu Button Classes */
.menu-button-container {
  gap: 60px;
}

.bottom-menu-container .button-menu-gap {
  gap: 22px;
}
@media (min-width: 1280px) {
  .bottom-menu-container .button-menu-gap {
    gap: 36px;
  }
}

.menu-button {
  --path: 90% 10%, 100% 35%, 100% 70%, 90% 90%, 10% 90%, 0% 70%, 0% 35%, 10% 10%;
  --left-path: polygon(
    79% 9%,
    99% 10%,
    19% 33%,
    18% 69%,
    98% 91%,
    79% 92%,
    0% 69%,
    -1% 32%
  );
  width: 200px;
}
.menu-button .outside {
  position: relative;
  width: 173px;
  height: 55px;
  background: #ed753e;
  clip-path: polygon(var(--path));
}
.menu-button .inside {
  position: absolute;
  top: 1px;
  left: 1px;
  right: 1px;
  bottom: 1px;
  background: #000000;
  clip-path: polygon(var(--path));
}
.menu-button .left {
  width: 20px;
  height: 55px;
  margin-right: -12px;
  background: #ed753e;
  clip-path: var(--left-path);
}
.menu-button .right {
  width: 20px;
  height: 55px;
  margin-left: -12px;
  background: #ed753e;
  clip-path: var(--left-path);
  transform: scaleX(-1);
}
.menu-button .text {
  color: white;
}

.menu-button:hover .outside {
  background: #afafaf;
  cursor: pointer;
}
.menu-button:hover .left {
  background: #afafaf;
}
.menu-button:hover .right {
  background: #afafaf;
}
.menu-button:hover .text {
  color: #afafaf;
}

.outline-btn {
  position: relative;
  min-width: 100px;
  height: 41px;
  width: 230px;
}
.outline-btn .bg {
  position: absolute;
  opacity: 0.8;
  width: 100%;
  height: 100%;
  background-color: rgba(122, 115, 115, 0.5);
  clip-path: polygon(calc(100% - 12px) 100%, 100% calc(100% - 12px), 100% 12px, calc(100% - 12px) 0%, 12px 0%, 0% 12px, 0% calc(100% - 12px), 12px 100%);
}
.outline-btn .bg::after {
  content: "";
  position: absolute;
  background-color: #000000;
  clip-path: polygon(calc(100% - 12px) 100%, 100% calc(100% - 12px), 100% 12px, calc(100% - 12px) 0%, 12px 0%, 0% 12px, 0% calc(100% - 12px), 12px 100%);
  inset: 1.5px;
}
.outline-btn button {
  background-color: transparent;
  border: 0;
  box-sizing: border-box;
  color: #dcc97e;
  font-family: "ethnocentric";
  font-size: 20px;
  text-align: center;
  padding: 0px 35px 0px 20px;
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 2;
}
.outline-btn .right-icon {
  position: absolute;
  right: 10px;
  top: 5px;
}
.outline-btn:hover .bg {
  background-color: #24b8c0;
}
.outline-btn:hover path {
  opacity: 1;
}

/** End Menu Button Classes */
/** content */
.content {
  /* clip path variables */
  /* end clip path variables */
}
.content .content-bg-darker {
  background-color: rgba(0, 0, 0, 0.2);
}
.content .content-border {
  background-color: rgba(242, 122, 67, 0.5);
  min-height: 200px;
  width: 100%;
  height: 100%;
  z-index: -1;
  /* Content Border Path */
  clip-path: polygon(evenodd, 0% 0%, 270px 0%, 315px 46px, calc(100% - 12px) 45px, 100% 57px, 100% calc(100% - 12px), calc(100% - 12px) 100%, calc(100% - (100% - 340px) / 2) 100%, calc(100% - (100% - 340px) / 2 - 25px - 2px) calc(100% - 40px), calc((100% - 340px) / 2 + 25px + 2px) calc(100% - 40px), calc((100% - 340px) / 2) 100%, 12px 100%, 14px calc(100% - 2px), 2px calc(100% - 12px - 2px), 2px 2px, 269px 2px, 314px 47px, calc(100% - 2px - 12px) 47px, calc(100% - 2px) 59px, calc(100% - 2px) calc(100% - 12px - 2px), calc(100% - 12px - 2px) calc(100% - 2px), calc(100% - (100% - 340px) / 2 + 2px) calc(100% - 2px), calc(100% - (100% - 340px) / 2 - 25px) calc(100% - 42px), calc((100% - 340px) / 2 + 25px) calc(100% - 42px), calc((100% - 340px) / 2 - 2px) calc(100% - 2px), 14px calc(100% - 2px), 12px 100%, 0% calc(100% - 12px));
  /*End Content Border Path */
}
.content .content-border-none-bt-space {
  background-color: rgba(242, 122, 67, 0.5);
  min-height: 200px;
  width: 100%;
  height: calc(100% + 3px);
  z-index: -1;
  /* Content Border Path */
  clip-path: polygon(evenodd, 0% 0%, 270px 0%, 315px 46px, calc(100% - 12px) 45px, 100% 57px, 100% calc(100% - 12px), calc(100% - 12px) 100%, 12px 100%, 14px calc(100% - 2px), 2px calc(100% - 12px - 2px), 2px 2px, 269px 2px, 314px 47px, calc(100% - 2px - 12px) 47px, calc(100% - 2px) 59px, calc(100% - 2px) calc(100% - 12px - 2px), calc(100% - 12px - 2px) calc(100% - 2px), 14px calc(100% - 2px), 12px 100%, 0% calc(100% - 12px));
  /*End Content Border Path */
}
.content .title {
  width: 270px;
  font-size: 29px;
  color: white;
  font-family: "851ゴチカクット";
}
.content .title .font-size {
  font-size: 29px;
}
.content .wide-top-space {
  width: calc(100% - 160px) !important;
  height: 45px;
}
.content .top-space {
  width: calc(100% - 270px);
  height: 45px;
}
.content .body .header-font {
  font-size: 20px;
  text-align: center;
}
.content .body .body-font {
  font-size: 18px;
  font-family: "NotoSansJP";
  line-height: 22px;
}
.content .body .publish-icon {
  width: 28px;
  height: 9px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
  margin-top: 4px;
  position: relative;
}
.content .body .publish-icon .publish-up-arrow {
  transition: all 0.5s ease;
}
.content .body .publish-icon:hover .publish-up-arrow1 {
  margin-top: -18px;
}
.content .body .publish-icon:hover .publish-up-arrow2 {
  margin-top: -10px;
}
.content .body .publish-up-arrow2, .content .body .publish-up-arrow1 {
  width: 14px;
  height: 8px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
  position: absolute;
  left: 7px;
  top: 1px;
}
.content .body .edit-icon {
  width: 38px;
  height: 32px;
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  cursor: pointer;
}
.content .body .edit-icon:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}
.content .body .pen-icon {
  width: 50px;
  height: 40px;
  background-repeat: no-repeat;
  cursor: pointer;
}
.content .body .pen-icon:hover .PenToSquareSolid1 {
  transition: 0.3s;
  transform: translate(7px, -62%);
}
.content .body .pen-icon:hover::after {
  z-index: 2;
  opacity: 1;
}
.content .body .detail-more-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-repeat: no-repeat;
  cursor: pointer;
}
.content .body .detail-more-icon:hover {
  transition-delay: 0.2s;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}
.content .body .delete-icon {
  display: inline-block;
  width: 30px;
  height: 40px;
  margin-top: 3px;
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
  position: relative;
}
.content .body .delete-icon::after {
  background-color: #000000;
  content: "削除";
  width: max-content;
  padding: 2px 5px;
  border: 1px solid #f27a43;
  position: absolute;
  color: #ffffff;
  font-size: 11px;
  text-align: center;
  left: -37px;
  bottom: 40px;
  z-index: 0;
  opacity: 0;
  transition: all 0.5s ease-in-out;
}
.content .body .delete-icon:hover .trash-can-solid-2 {
  margin-top: 3px;
  transition: 0.3s;
  transform: matrix(0.829, -0.545, 0.545, 0.829, -1, 0.878);
  fill: #f27a43;
}
.content .body .delete-icon:hover .trash-can-solid {
  fill: #f27a43;
}
.content .body .delete-icon:hover::after {
  z-index: 2;
  opacity: 1;
}
.content .body .parameter-delete-icon {
  cursor: pointer;
  z-index: 1;
  position: relative;
}
.content .body .parameter-delete-icon::after {
  background-color: #000000;
  content: "削除";
  width: max-content;
  padding: 2px 5px;
  border: 1px solid #f27a43;
  position: absolute;
  color: #ffffff;
  font-size: 11px;
  text-align: center;
  left: -20px;
  bottom: 30px;
  z-index: 0;
  opacity: 0;
  transition: all 0.5s ease-in-out;
}
.content .body .parameter-delete-icon:hover .trash-can-solid-2 {
  z-index: 5;
  margin-top: 3px;
  transition: 0.3s;
  transform: matrix(0.829, -0.545, 0.545, 0.829, -1, 0.878);
  fill: #f27a43;
}
.content .body .parameter-delete-icon:hover .trash-can-solid {
  fill: #f27a43;
}
.content .body .parameter-delete-icon:hover::after {
  z-index: 2;
  opacity: 1;
}
.content .body .arrow-icon {
  width: 16px;
  height: 18px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.content .body .uncheck-icon {
  width: 25px;
  height: 25px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.content .body .check-icon {
  width: 25px;
  height: 25px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.content .body .dropdown-icon {
  width: 16px;
  height: 16px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.content .body .copy-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.content .body .plus-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.content .body .minus-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.content .body .close-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
  rotate: 45deg;
}
.content .body .grey-minus-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.content .body .pink-plus-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.content .body .random-plus {
  width: 30px;
  height: 30px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.content .body .random-plus:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}
.content .body .random-plus-disable {
  width: 30px;
  height: 30px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.content .bottom .space-width {
  width: 340px;
}
.content .bottom .font-size {
  font-size: 25px;
}
.content .bottom .left-arrow {
  width: 50px;
  height: 15px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  background-repeat: no-repeat;
  margin-top: 27px;
  cursor: pointer;
}
.content .bottom .left-arrow:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
}
.content .bottom .right-arrow {
  width: 50px;
  height: 15px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  background-repeat: no-repeat;
  transform: scaleX(-1);
  margin-top: 27px;
  cursor: pointer;
}
.content .bottom .right-arrow:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
  transform: scaleX(-1);
}

.marketplace-content {
  /* clip path variables */
  /* end clip path variables */
}
.marketplace-content .content-bg-darker {
  background-color: rgba(0, 0, 0, 0.2);
}
.marketplace-content .content-border {
  background-color: rgba(242, 122, 67, 0.5);
  min-height: 200px;
  width: 100%;
  height: 100%;
  z-index: -1;
  /* Content Border Path */
  clip-path: polygon(evenodd, 0% 0%, 370px 0%, 415px 46px, calc(100% - 12px) 45px, 100% 57px, 100% calc(100% - 12px), calc(100% - 12px) 100%, calc(100% - (100% - 340px) / 2) 100%, calc(100% - (100% - 340px) / 2 - 25px - 2px) calc(100% - 40px), calc((100% - 340px) / 2 + 25px + 2px) calc(100% - 40px), calc((100% - 340px) / 2) 100%, 12px 100%, 14px calc(100% - 2px), 2px calc(100% - 12px - 2px), 2px 2px, 369px 2px, 414px 47px, calc(100% - 2px - 12px) 47px, calc(100% - 2px) 59px, calc(100% - 2px) calc(100% - 12px - 2px), calc(100% - 12px - 2px) calc(100% - 2px), calc(100% - (100% - 340px) / 2 + 2px) calc(100% - 2px), calc(100% - (100% - 340px) / 2 - 25px) calc(100% - 42px), calc((100% - 340px) / 2 + 25px) calc(100% - 42px), calc((100% - 340px) / 2 - 2px) calc(100% - 2px), 14px calc(100% - 2px), 12px 100%, 0% calc(100% - 12px));
  /*End Content Border Path */
}
.marketplace-content .content-border-none-bt-space {
  background-color: rgba(242, 122, 67, 0.5);
  min-height: 200px;
  width: 100%;
  height: calc(100% + 3px);
  z-index: -1;
  /* Content Border Path */
  clip-path: polygon(evenodd, 0% 0%, 370px 0%, 415px 46px, calc(100% - 12px) 45px, 100% 57px, 100% calc(100% - 12px), calc(100% - 12px) 100%, 12px 100%, 14px calc(100% - 2px), 2px calc(100% - 12px - 2px), 2px 2px, 369px 2px, 414px 47px, calc(100% - 2px - 12px) 47px, calc(100% - 2px) 59px, calc(100% - 2px) calc(100% - 12px - 2px), calc(100% - 12px - 2px) calc(100% - 2px), 14px calc(100% - 2px), 12px 100%, 0% calc(100% - 12px));
  /*End Content Border Path */
}
.marketplace-content .title {
  width: 370px;
  font-size: 29px;
  color: white;
  font-family: "851ゴチカクット";
}
.marketplace-content .title .font-size {
  font-size: 29px;
}
.marketplace-content .wide-top-space {
  width: calc(100% - 160px) !important;
  height: 45px;
}
.marketplace-content .top-space {
  width: calc(100% - 370px);
  height: 45px;
}
.marketplace-content .body .header-font {
  font-size: 20px;
  text-align: center;
}
.marketplace-content .body .body-font {
  font-size: 18px;
  font-family: "NotoSansJP";
  line-height: 22px;
}
.marketplace-content .body .publish-icon {
  width: 28px;
  height: 9px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
  margin-top: 4px;
  position: relative;
}
.marketplace-content .body .publish-icon .publish-up-arrow {
  transition: all 0.5s ease;
}
.marketplace-content .body .publish-icon:hover .publish-up-arrow1 {
  margin-top: -18px;
}
.marketplace-content .body .publish-icon:hover .publish-up-arrow2 {
  margin-top: -10px;
}
.marketplace-content .body .publish-up-arrow2, .marketplace-content .body .publish-up-arrow1 {
  width: 14px;
  height: 8px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
  position: absolute;
  left: 7px;
  top: 1px;
}
.marketplace-content .body .edit-icon {
  width: 38px;
  height: 32px;
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  cursor: pointer;
}
.marketplace-content .body .edit-icon:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}
.marketplace-content .body .pen-icon {
  width: 50px;
  height: 40px;
  background-repeat: no-repeat;
  cursor: pointer;
}
.marketplace-content .body .pen-icon:hover .PenToSquareSolid1 {
  transition: 0.3s;
  transform: translate(7px, -62%);
}
.marketplace-content .body .pen-icon:hover::after {
  z-index: 2;
  opacity: 1;
}
.marketplace-content .body .detail-more-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-repeat: no-repeat;
  cursor: pointer;
}
.marketplace-content .body .detail-more-icon:hover {
  transition-delay: 0.2s;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}
.marketplace-content .body .delete-icon {
  display: inline-block;
  width: 30px;
  height: 40px;
  margin-top: 3px;
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
  position: relative;
}
.marketplace-content .body .delete-icon::after {
  background-color: #000000;
  content: "削除";
  width: max-content;
  padding: 2px 5px;
  border: 1px solid #f27a43;
  position: absolute;
  color: #ffffff;
  font-size: 11px;
  text-align: center;
  left: -37px;
  bottom: 40px;
  z-index: 0;
  opacity: 0;
  transition: all 0.5s ease-in-out;
}
.marketplace-content .body .delete-icon:hover .trash-can-solid-2 {
  margin-top: 3px;
  transition: 0.3s;
  transform: matrix(0.829, -0.545, 0.545, 0.829, -1, 0.878);
  fill: #f27a43;
}
.marketplace-content .body .delete-icon:hover .trash-can-solid {
  fill: #f27a43;
}
.marketplace-content .body .delete-icon:hover::after {
  z-index: 2;
  opacity: 1;
}
.marketplace-content .body .parameter-delete-icon {
  cursor: pointer;
  z-index: 1;
  position: relative;
}
.marketplace-content .body .parameter-delete-icon::after {
  background-color: #000000;
  content: "削除";
  width: max-content;
  padding: 2px 5px;
  border: 1px solid #f27a43;
  position: absolute;
  color: #ffffff;
  font-size: 11px;
  text-align: center;
  left: -20px;
  bottom: 30px;
  z-index: 0;
  opacity: 0;
  transition: all 0.5s ease-in-out;
}
.marketplace-content .body .parameter-delete-icon:hover .trash-can-solid-2 {
  z-index: 5;
  margin-top: 3px;
  transition: 0.3s;
  transform: matrix(0.829, -0.545, 0.545, 0.829, -1, 0.878);
  fill: #f27a43;
}
.marketplace-content .body .parameter-delete-icon:hover .trash-can-solid {
  fill: #f27a43;
}
.marketplace-content .body .parameter-delete-icon:hover::after {
  z-index: 2;
  opacity: 1;
}
.marketplace-content .body .arrow-icon {
  width: 16px;
  height: 18px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.marketplace-content .body .uncheck-icon {
  width: 25px;
  height: 25px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.marketplace-content .body .check-icon {
  width: 25px;
  height: 25px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.marketplace-content .body .dropdown-icon {
  width: 16px;
  height: 16px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.marketplace-content .body .copy-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.marketplace-content .body .plus-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.marketplace-content .body .minus-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.marketplace-content .body .close-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
  rotate: 45deg;
}
.marketplace-content .body .grey-minus-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.marketplace-content .body .pink-plus-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.marketplace-content .body .random-plus {
  width: 30px;
  height: 30px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.marketplace-content .body .random-plus:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}
.marketplace-content .body .random-plus-disable {
  width: 30px;
  height: 30px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.marketplace-content .bottom .space-width {
  width: 340px;
}
.marketplace-content .bottom .font-size {
  font-size: 25px;
}
.marketplace-content .bottom .left-arrow {
  width: 50px;
  height: 15px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  background-repeat: no-repeat;
  margin-top: 27px;
  cursor: pointer;
}
.marketplace-content .bottom .left-arrow:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
}
.marketplace-content .bottom .right-arrow {
  width: 50px;
  height: 15px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  background-repeat: no-repeat;
  transform: scaleX(-1);
  margin-top: 27px;
  cursor: pointer;
}
.marketplace-content .bottom .right-arrow:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
  transform: scaleX(-1);
}

.persona-market-content {
  /* clip path variables */
  /* end clip path variables */
}
.persona-market-content .content-bg-darker {
  background-color: rgba(0, 0, 0, 0.2);
}
.persona-market-content .content-border {
  background-color: rgba(242, 122, 67, 0.5);
  min-height: 200px;
  width: 100%;
  height: 100%;
  z-index: -1;
  /* Content Border Path */
  clip-path: polygon(evenodd, 0% 0%, 420px 0%, 465px 46px, calc(100% - 12px) 45px, 100% 57px, 100% calc(100% - 12px), calc(100% - 12px) 100%, calc(100% - (100% - 340px) / 2) 100%, calc(100% - (100% - 340px) / 2 - 25px - 2px) calc(100% - 40px), calc((100% - 340px) / 2 + 25px + 2px) calc(100% - 40px), calc((100% - 340px) / 2) 100%, 12px 100%, 14px calc(100% - 2px), 2px calc(100% - 12px - 2px), 2px 2px, 419px 2px, 464px 47px, calc(100% - 2px - 12px) 47px, calc(100% - 2px) 59px, calc(100% - 2px) calc(100% - 12px - 2px), calc(100% - 12px - 2px) calc(100% - 2px), calc(100% - (100% - 340px) / 2 + 2px) calc(100% - 2px), calc(100% - (100% - 340px) / 2 - 25px) calc(100% - 42px), calc((100% - 340px) / 2 + 25px) calc(100% - 42px), calc((100% - 340px) / 2 - 2px) calc(100% - 2px), 14px calc(100% - 2px), 12px 100%, 0% calc(100% - 12px));
  /*End Content Border Path */
}
.persona-market-content .content-border-none-bt-space {
  background-color: rgba(242, 122, 67, 0.5);
  min-height: 200px;
  width: 100%;
  height: calc(100% + 3px);
  z-index: -1;
  /* Content Border Path */
  clip-path: polygon(evenodd, 0% 0%, 420px 0%, 465px 46px, calc(100% - 12px) 45px, 100% 57px, 100% calc(100% - 12px), calc(100% - 12px) 100%, 12px 100%, 14px calc(100% - 2px), 2px calc(100% - 12px - 2px), 2px 2px, 419px 2px, 464px 47px, calc(100% - 2px - 12px) 47px, calc(100% - 2px) 59px, calc(100% - 2px) calc(100% - 12px - 2px), calc(100% - 12px - 2px) calc(100% - 2px), 14px calc(100% - 2px), 12px 100%, 0% calc(100% - 12px));
  /*End Content Border Path */
}
.persona-market-content .title {
  width: 420px;
  font-size: 29px;
  color: white;
  font-family: "851ゴチカクット";
}
.persona-market-content .title .font-size {
  font-size: 29px;
}
.persona-market-content .wide-top-space {
  width: calc(100% - 160px) !important;
  height: 45px;
}
.persona-market-content .top-space {
  width: calc(100% - 420px);
  height: 45px;
}
.persona-market-content .body .header-font {
  font-size: 20px;
  text-align: center;
}
.persona-market-content .body .body-font {
  font-size: 18px;
  font-family: "NotoSansJP";
  line-height: 22px;
}
.persona-market-content .body .publish-icon {
  width: 28px;
  height: 9px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
  margin-top: 4px;
  position: relative;
}
.persona-market-content .body .publish-icon .publish-up-arrow {
  transition: all 0.5s ease;
}
.persona-market-content .body .publish-icon:hover .publish-up-arrow1 {
  margin-top: -18px;
}
.persona-market-content .body .publish-icon:hover .publish-up-arrow2 {
  margin-top: -10px;
}
.persona-market-content .body .publish-up-arrow2, .persona-market-content .body .publish-up-arrow1 {
  width: 14px;
  height: 8px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
  position: absolute;
  left: 7px;
  top: 1px;
}
.persona-market-content .body .edit-icon {
  width: 38px;
  height: 32px;
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  cursor: pointer;
}
.persona-market-content .body .edit-icon:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}
.persona-market-content .body .pen-icon {
  width: 50px;
  height: 40px;
  background-repeat: no-repeat;
  cursor: pointer;
}
.persona-market-content .body .pen-icon:hover .PenToSquareSolid1 {
  transition: 0.3s;
  transform: translate(7px, -62%);
}
.persona-market-content .body .pen-icon:hover::after {
  z-index: 2;
  opacity: 1;
}
.persona-market-content .body .detail-more-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-repeat: no-repeat;
  cursor: pointer;
}
.persona-market-content .body .detail-more-icon:hover {
  transition-delay: 0.2s;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}
.persona-market-content .body .delete-icon {
  display: inline-block;
  width: 30px;
  height: 40px;
  margin-top: 3px;
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
  position: relative;
}
.persona-market-content .body .delete-icon::after {
  background-color: #000000;
  content: "削除";
  width: max-content;
  padding: 2px 5px;
  border: 1px solid #f27a43;
  position: absolute;
  color: #ffffff;
  font-size: 11px;
  text-align: center;
  left: -37px;
  bottom: 40px;
  z-index: 0;
  opacity: 0;
  transition: all 0.5s ease-in-out;
}
.persona-market-content .body .delete-icon:hover .trash-can-solid-2 {
  margin-top: 3px;
  transition: 0.3s;
  transform: matrix(0.829, -0.545, 0.545, 0.829, -1, 0.878);
  fill: #f27a43;
}
.persona-market-content .body .delete-icon:hover .trash-can-solid {
  fill: #f27a43;
}
.persona-market-content .body .delete-icon:hover::after {
  z-index: 2;
  opacity: 1;
}
.persona-market-content .body .parameter-delete-icon {
  cursor: pointer;
  z-index: 1;
  position: relative;
}
.persona-market-content .body .parameter-delete-icon::after {
  background-color: #000000;
  content: "削除";
  width: max-content;
  padding: 2px 5px;
  border: 1px solid #f27a43;
  position: absolute;
  color: #ffffff;
  font-size: 11px;
  text-align: center;
  left: -20px;
  bottom: 30px;
  z-index: 0;
  opacity: 0;
  transition: all 0.5s ease-in-out;
}
.persona-market-content .body .parameter-delete-icon:hover .trash-can-solid-2 {
  z-index: 5;
  margin-top: 3px;
  transition: 0.3s;
  transform: matrix(0.829, -0.545, 0.545, 0.829, -1, 0.878);
  fill: #f27a43;
}
.persona-market-content .body .parameter-delete-icon:hover .trash-can-solid {
  fill: #f27a43;
}
.persona-market-content .body .parameter-delete-icon:hover::after {
  z-index: 2;
  opacity: 1;
}
.persona-market-content .body .arrow-icon {
  width: 16px;
  height: 18px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.persona-market-content .body .uncheck-icon {
  width: 25px;
  height: 25px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.persona-market-content .body .check-icon {
  width: 25px;
  height: 25px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.persona-market-content .body .dropdown-icon {
  width: 16px;
  height: 16px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.persona-market-content .body .copy-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.persona-market-content .body .plus-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.persona-market-content .body .minus-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.persona-market-content .body .close-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
  rotate: 45deg;
}
.persona-market-content .body .grey-minus-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.persona-market-content .body .pink-plus-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.persona-market-content .body .random-plus {
  width: 30px;
  height: 30px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.persona-market-content .body .random-plus:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}
.persona-market-content .body .random-plus-disable {
  width: 30px;
  height: 30px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.persona-market-content .bottom .space-width {
  width: 340px;
}
.persona-market-content .bottom .font-size {
  font-size: 25px;
}
.persona-market-content .bottom .left-arrow {
  width: 50px;
  height: 15px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  background-repeat: no-repeat;
  margin-top: 27px;
  cursor: pointer;
}
.persona-market-content .bottom .left-arrow:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
}
.persona-market-content .bottom .right-arrow {
  width: 50px;
  height: 15px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  background-repeat: no-repeat;
  transform: scaleX(-1);
  margin-top: 27px;
  cursor: pointer;
}
.persona-market-content .bottom .right-arrow:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
  transform: scaleX(-1);
}

.persona-up-content {
  /* clip path variables */
  /* end clip path variables */
}
.persona-up-content .content-bg-darker {
  background-color: rgba(0, 0, 0, 0.2);
}
.persona-up-content .content-border {
  background-color: rgba(242, 122, 67, 0.5);
  min-height: 200px;
  width: 100%;
  height: 100%;
  z-index: -1;
  /* Content Border Path */
  clip-path: polygon(evenodd, 0% 0%, 310px 0%, 355px 46px, calc(100% - 12px) 45px, 100% 57px, 100% calc(100% - 12px), calc(100% - 12px) 100%, calc(100% - (100% - 340px) / 2) 100%, calc(100% - (100% - 340px) / 2 - 25px - 2px) calc(100% - 40px), calc((100% - 340px) / 2 + 25px + 2px) calc(100% - 40px), calc((100% - 340px) / 2) 100%, 12px 100%, 14px calc(100% - 2px), 2px calc(100% - 12px - 2px), 2px 2px, 309px 2px, 354px 47px, calc(100% - 2px - 12px) 47px, calc(100% - 2px) 59px, calc(100% - 2px) calc(100% - 12px - 2px), calc(100% - 12px - 2px) calc(100% - 2px), calc(100% - (100% - 340px) / 2 + 2px) calc(100% - 2px), calc(100% - (100% - 340px) / 2 - 25px) calc(100% - 42px), calc((100% - 340px) / 2 + 25px) calc(100% - 42px), calc((100% - 340px) / 2 - 2px) calc(100% - 2px), 14px calc(100% - 2px), 12px 100%, 0% calc(100% - 12px));
  /*End Content Border Path */
}
.persona-up-content .content-border-none-bt-space {
  background-color: rgba(242, 122, 67, 0.5);
  min-height: 200px;
  width: 100%;
  height: calc(100% + 3px);
  z-index: -1;
  /* Content Border Path */
  clip-path: polygon(evenodd, 0% 0%, 310px 0%, 355px 46px, calc(100% - 12px) 45px, 100% 57px, 100% calc(100% - 12px), calc(100% - 12px) 100%, 12px 100%, 14px calc(100% - 2px), 2px calc(100% - 12px - 2px), 2px 2px, 309px 2px, 354px 47px, calc(100% - 2px - 12px) 47px, calc(100% - 2px) 59px, calc(100% - 2px) calc(100% - 12px - 2px), calc(100% - 12px - 2px) calc(100% - 2px), 14px calc(100% - 2px), 12px 100%, 0% calc(100% - 12px));
  /*End Content Border Path */
}
.persona-up-content .title {
  width: 310px;
  font-size: 29px;
  color: white;
  font-family: "851ゴチカクット";
}
.persona-up-content .title .font-size {
  font-size: 29px;
}
.persona-up-content .wide-top-space {
  width: calc(100% - 160px) !important;
  height: 45px;
}
.persona-up-content .top-space {
  width: calc(100% - 310px);
  height: 45px;
}
.persona-up-content .body .header-font {
  font-size: 20px;
  text-align: center;
}
.persona-up-content .body .body-font {
  font-size: 18px;
  font-family: "NotoSansJP";
  line-height: 22px;
}
.persona-up-content .body .publish-icon {
  width: 28px;
  height: 9px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
  margin-top: 4px;
  position: relative;
}
.persona-up-content .body .publish-icon .publish-up-arrow {
  transition: all 0.5s ease;
}
.persona-up-content .body .publish-icon:hover .publish-up-arrow1 {
  margin-top: -18px;
}
.persona-up-content .body .publish-icon:hover .publish-up-arrow2 {
  margin-top: -10px;
}
.persona-up-content .body .publish-up-arrow2, .persona-up-content .body .publish-up-arrow1 {
  width: 14px;
  height: 8px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
  position: absolute;
  left: 7px;
  top: 1px;
}
.persona-up-content .body .edit-icon {
  width: 38px;
  height: 32px;
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  cursor: pointer;
}
.persona-up-content .body .edit-icon:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}
.persona-up-content .body .pen-icon {
  width: 50px;
  height: 40px;
  background-repeat: no-repeat;
  cursor: pointer;
}
.persona-up-content .body .pen-icon:hover .PenToSquareSolid1 {
  transition: 0.3s;
  transform: translate(7px, -62%);
}
.persona-up-content .body .pen-icon:hover::after {
  z-index: 2;
  opacity: 1;
}
.persona-up-content .body .detail-more-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-repeat: no-repeat;
  cursor: pointer;
}
.persona-up-content .body .detail-more-icon:hover {
  transition-delay: 0.2s;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}
.persona-up-content .body .delete-icon {
  display: inline-block;
  width: 30px;
  height: 40px;
  margin-top: 3px;
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
  position: relative;
}
.persona-up-content .body .delete-icon::after {
  background-color: #000000;
  content: "削除";
  width: max-content;
  padding: 2px 5px;
  border: 1px solid #f27a43;
  position: absolute;
  color: #ffffff;
  font-size: 11px;
  text-align: center;
  left: -37px;
  bottom: 40px;
  z-index: 0;
  opacity: 0;
  transition: all 0.5s ease-in-out;
}
.persona-up-content .body .delete-icon:hover .trash-can-solid-2 {
  margin-top: 3px;
  transition: 0.3s;
  transform: matrix(0.829, -0.545, 0.545, 0.829, -1, 0.878);
  fill: #f27a43;
}
.persona-up-content .body .delete-icon:hover .trash-can-solid {
  fill: #f27a43;
}
.persona-up-content .body .delete-icon:hover::after {
  z-index: 2;
  opacity: 1;
}
.persona-up-content .body .parameter-delete-icon {
  cursor: pointer;
  z-index: 1;
  position: relative;
}
.persona-up-content .body .parameter-delete-icon::after {
  background-color: #000000;
  content: "削除";
  width: max-content;
  padding: 2px 5px;
  border: 1px solid #f27a43;
  position: absolute;
  color: #ffffff;
  font-size: 11px;
  text-align: center;
  left: -20px;
  bottom: 30px;
  z-index: 0;
  opacity: 0;
  transition: all 0.5s ease-in-out;
}
.persona-up-content .body .parameter-delete-icon:hover .trash-can-solid-2 {
  z-index: 5;
  margin-top: 3px;
  transition: 0.3s;
  transform: matrix(0.829, -0.545, 0.545, 0.829, -1, 0.878);
  fill: #f27a43;
}
.persona-up-content .body .parameter-delete-icon:hover .trash-can-solid {
  fill: #f27a43;
}
.persona-up-content .body .parameter-delete-icon:hover::after {
  z-index: 2;
  opacity: 1;
}
.persona-up-content .body .arrow-icon {
  width: 16px;
  height: 18px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.persona-up-content .body .uncheck-icon {
  width: 25px;
  height: 25px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.persona-up-content .body .check-icon {
  width: 25px;
  height: 25px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.persona-up-content .body .dropdown-icon {
  width: 16px;
  height: 16px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.persona-up-content .body .copy-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.persona-up-content .body .plus-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.persona-up-content .body .minus-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.persona-up-content .body .close-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
  rotate: 45deg;
}
.persona-up-content .body .grey-minus-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.persona-up-content .body .pink-plus-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.persona-up-content .body .random-plus {
  width: 30px;
  height: 30px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.persona-up-content .body .random-plus:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}
.persona-up-content .body .random-plus-disable {
  width: 30px;
  height: 30px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.persona-up-content .bottom .space-width {
  width: 340px;
}
.persona-up-content .bottom .font-size {
  font-size: 25px;
}
.persona-up-content .bottom .left-arrow {
  width: 50px;
  height: 15px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  background-repeat: no-repeat;
  margin-top: 27px;
  cursor: pointer;
}
.persona-up-content .bottom .left-arrow:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
}
.persona-up-content .bottom .right-arrow {
  width: 50px;
  height: 15px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  background-repeat: no-repeat;
  transform: scaleX(-1);
  margin-top: 27px;
  cursor: pointer;
}
.persona-up-content .bottom .right-arrow:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
  transform: scaleX(-1);
}

.drawchain-create-content {
  /* clip path variables */
  /* end clip path variables */
}
.drawchain-create-content .content-bg-darker {
  background-color: rgba(0, 0, 0, 0.2);
}
.drawchain-create-content .content-border {
  background-color: rgba(242, 122, 67, 0.5);
  min-height: 200px;
  width: 100%;
  height: 100%;
  z-index: -1;
  /* Content Border Path */
  clip-path: polygon(evenodd, 0% 0%, 370px 0%, 415px 46px, calc(100% - 12px) 45px, 100% 57px, 100% calc(100% - 12px), calc(100% - 12px) 100%, calc(100% - (100% - 340px) / 2) 100%, calc(100% - (100% - 340px) / 2 - 25px - 2px) calc(100% - 40px), calc((100% - 340px) / 2 + 25px + 2px) calc(100% - 40px), calc((100% - 340px) / 2) 100%, 12px 100%, 14px calc(100% - 2px), 2px calc(100% - 12px - 2px), 2px 2px, 369px 2px, 414px 47px, calc(100% - 2px - 12px) 47px, calc(100% - 2px) 59px, calc(100% - 2px) calc(100% - 12px - 2px), calc(100% - 12px - 2px) calc(100% - 2px), calc(100% - (100% - 340px) / 2 + 2px) calc(100% - 2px), calc(100% - (100% - 340px) / 2 - 25px) calc(100% - 42px), calc((100% - 340px) / 2 + 25px) calc(100% - 42px), calc((100% - 340px) / 2 - 2px) calc(100% - 2px), 14px calc(100% - 2px), 12px 100%, 0% calc(100% - 12px));
  /*End Content Border Path */
}
.drawchain-create-content .content-border-none-bt-space {
  background-color: rgba(242, 122, 67, 0.5);
  min-height: 200px;
  width: 100%;
  height: calc(100% + 3px);
  z-index: -1;
  /* Content Border Path */
  clip-path: polygon(evenodd, 0% 0%, 370px 0%, 415px 46px, calc(100% - 12px) 45px, 100% 57px, 100% calc(100% - 12px), calc(100% - 12px) 100%, 12px 100%, 14px calc(100% - 2px), 2px calc(100% - 12px - 2px), 2px 2px, 369px 2px, 414px 47px, calc(100% - 2px - 12px) 47px, calc(100% - 2px) 59px, calc(100% - 2px) calc(100% - 12px - 2px), calc(100% - 12px - 2px) calc(100% - 2px), 14px calc(100% - 2px), 12px 100%, 0% calc(100% - 12px));
  /*End Content Border Path */
}
.drawchain-create-content .title {
  width: 370px;
  font-size: 29px;
  color: white;
  font-family: "851ゴチカクット";
}
.drawchain-create-content .title .font-size {
  font-size: 29px;
}
.drawchain-create-content .wide-top-space {
  width: calc(100% - 160px) !important;
  height: 45px;
}
.drawchain-create-content .top-space {
  width: calc(100% - 370px);
  height: 45px;
}
.drawchain-create-content .body .header-font {
  font-size: 20px;
  text-align: center;
}
.drawchain-create-content .body .body-font {
  font-size: 18px;
  font-family: "NotoSansJP";
  line-height: 22px;
}
.drawchain-create-content .body .publish-icon {
  width: 28px;
  height: 9px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
  margin-top: 4px;
  position: relative;
}
.drawchain-create-content .body .publish-icon .publish-up-arrow {
  transition: all 0.5s ease;
}
.drawchain-create-content .body .publish-icon:hover .publish-up-arrow1 {
  margin-top: -18px;
}
.drawchain-create-content .body .publish-icon:hover .publish-up-arrow2 {
  margin-top: -10px;
}
.drawchain-create-content .body .publish-up-arrow2, .drawchain-create-content .body .publish-up-arrow1 {
  width: 14px;
  height: 8px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
  position: absolute;
  left: 7px;
  top: 1px;
}
.drawchain-create-content .body .edit-icon {
  width: 38px;
  height: 32px;
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  cursor: pointer;
}
.drawchain-create-content .body .edit-icon:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}
.drawchain-create-content .body .pen-icon {
  width: 50px;
  height: 40px;
  background-repeat: no-repeat;
  cursor: pointer;
}
.drawchain-create-content .body .pen-icon:hover .PenToSquareSolid1 {
  transition: 0.3s;
  transform: translate(7px, -62%);
}
.drawchain-create-content .body .pen-icon:hover::after {
  z-index: 2;
  opacity: 1;
}
.drawchain-create-content .body .detail-more-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-repeat: no-repeat;
  cursor: pointer;
}
.drawchain-create-content .body .detail-more-icon:hover {
  transition-delay: 0.2s;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}
.drawchain-create-content .body .delete-icon {
  display: inline-block;
  width: 30px;
  height: 40px;
  margin-top: 3px;
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
  position: relative;
}
.drawchain-create-content .body .delete-icon::after {
  background-color: #000000;
  content: "削除";
  width: max-content;
  padding: 2px 5px;
  border: 1px solid #f27a43;
  position: absolute;
  color: #ffffff;
  font-size: 11px;
  text-align: center;
  left: -37px;
  bottom: 40px;
  z-index: 0;
  opacity: 0;
  transition: all 0.5s ease-in-out;
}
.drawchain-create-content .body .delete-icon:hover .trash-can-solid-2 {
  margin-top: 3px;
  transition: 0.3s;
  transform: matrix(0.829, -0.545, 0.545, 0.829, -1, 0.878);
  fill: #f27a43;
}
.drawchain-create-content .body .delete-icon:hover .trash-can-solid {
  fill: #f27a43;
}
.drawchain-create-content .body .delete-icon:hover::after {
  z-index: 2;
  opacity: 1;
}
.drawchain-create-content .body .parameter-delete-icon {
  cursor: pointer;
  z-index: 1;
  position: relative;
}
.drawchain-create-content .body .parameter-delete-icon::after {
  background-color: #000000;
  content: "削除";
  width: max-content;
  padding: 2px 5px;
  border: 1px solid #f27a43;
  position: absolute;
  color: #ffffff;
  font-size: 11px;
  text-align: center;
  left: -20px;
  bottom: 30px;
  z-index: 0;
  opacity: 0;
  transition: all 0.5s ease-in-out;
}
.drawchain-create-content .body .parameter-delete-icon:hover .trash-can-solid-2 {
  z-index: 5;
  margin-top: 3px;
  transition: 0.3s;
  transform: matrix(0.829, -0.545, 0.545, 0.829, -1, 0.878);
  fill: #f27a43;
}
.drawchain-create-content .body .parameter-delete-icon:hover .trash-can-solid {
  fill: #f27a43;
}
.drawchain-create-content .body .parameter-delete-icon:hover::after {
  z-index: 2;
  opacity: 1;
}
.drawchain-create-content .body .arrow-icon {
  width: 16px;
  height: 18px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.drawchain-create-content .body .uncheck-icon {
  width: 25px;
  height: 25px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.drawchain-create-content .body .check-icon {
  width: 25px;
  height: 25px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.drawchain-create-content .body .dropdown-icon {
  width: 16px;
  height: 16px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.drawchain-create-content .body .copy-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.drawchain-create-content .body .plus-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.drawchain-create-content .body .minus-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.drawchain-create-content .body .close-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
  rotate: 45deg;
}
.drawchain-create-content .body .grey-minus-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.drawchain-create-content .body .pink-plus-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.drawchain-create-content .body .random-plus {
  width: 30px;
  height: 30px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.drawchain-create-content .body .random-plus:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}
.drawchain-create-content .body .random-plus-disable {
  width: 30px;
  height: 30px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.drawchain-create-content .bottom .space-width {
  width: 340px;
}
.drawchain-create-content .bottom .font-size {
  font-size: 25px;
}
.drawchain-create-content .bottom .left-arrow {
  width: 50px;
  height: 15px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  background-repeat: no-repeat;
  margin-top: 27px;
  cursor: pointer;
}
.drawchain-create-content .bottom .left-arrow:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
}
.drawchain-create-content .bottom .right-arrow {
  width: 50px;
  height: 15px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  background-repeat: no-repeat;
  transform: scaleX(-1);
  margin-top: 27px;
  cursor: pointer;
}
.drawchain-create-content .bottom .right-arrow:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
  transform: scaleX(-1);
}

.content-wide-title {
  /* clip path variables */
  /* end clip path variables */
}
.content-wide-title .content-bg-darker {
  background-color: rgba(0, 0, 0, 0.2);
}
.content-wide-title .content-border {
  background-color: rgba(242, 122, 67, 0.5);
  min-height: 200px;
  width: 100%;
  height: 100%;
  z-index: -1;
  /* Content Border Path */
  clip-path: polygon(evenodd, 0% 0%, 320px 0%, 365px 46px, calc(100% - 12px) 45px, 100% 57px, 100% calc(100% - 12px), calc(100% - 12px) 100%, calc(100% - (100% - 340px) / 2) 100%, calc(100% - (100% - 340px) / 2 - 25px - 2px) calc(100% - 40px), calc((100% - 340px) / 2 + 25px + 2px) calc(100% - 40px), calc((100% - 340px) / 2) 100%, 12px 100%, 14px calc(100% - 2px), 2px calc(100% - 12px - 2px), 2px 2px, 319px 2px, 364px 47px, calc(100% - 2px - 12px) 47px, calc(100% - 2px) 59px, calc(100% - 2px) calc(100% - 12px - 2px), calc(100% - 12px - 2px) calc(100% - 2px), calc(100% - (100% - 340px) / 2 + 2px) calc(100% - 2px), calc(100% - (100% - 340px) / 2 - 25px) calc(100% - 42px), calc((100% - 340px) / 2 + 25px) calc(100% - 42px), calc((100% - 340px) / 2 - 2px) calc(100% - 2px), 14px calc(100% - 2px), 12px 100%, 0% calc(100% - 12px));
  /*End Content Border Path */
}
.content-wide-title .content-border-none-bt-space {
  background-color: rgba(242, 122, 67, 0.5);
  min-height: 200px;
  width: 100%;
  height: calc(100% + 3px);
  z-index: -1;
  /* Content Border Path */
  clip-path: polygon(evenodd, 0% 0%, 320px 0%, 365px 46px, calc(100% - 12px) 45px, 100% 57px, 100% calc(100% - 12px), calc(100% - 12px) 100%, 12px 100%, 14px calc(100% - 2px), 2px calc(100% - 12px - 2px), 2px 2px, 319px 2px, 364px 47px, calc(100% - 2px - 12px) 47px, calc(100% - 2px) 59px, calc(100% - 2px) calc(100% - 12px - 2px), calc(100% - 12px - 2px) calc(100% - 2px), 14px calc(100% - 2px), 12px 100%, 0% calc(100% - 12px));
  /*End Content Border Path */
}
.content-wide-title .title {
  width: 320px;
  font-size: 29px;
  color: white;
  font-family: "851ゴチカクット";
}
.content-wide-title .title .font-size {
  font-size: 29px;
}
.content-wide-title .wide-top-space {
  width: calc(100% - 160px) !important;
  height: 45px;
}
.content-wide-title .top-space {
  width: calc(100% - 320px);
  height: 45px;
}
.content-wide-title .body .header-font {
  font-size: 20px;
  text-align: center;
}
.content-wide-title .body .body-font {
  font-size: 18px;
  font-family: "NotoSansJP";
  line-height: 22px;
}
.content-wide-title .body .publish-icon {
  width: 28px;
  height: 9px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
  margin-top: 4px;
  position: relative;
}
.content-wide-title .body .publish-icon .publish-up-arrow {
  transition: all 0.5s ease;
}
.content-wide-title .body .publish-icon:hover .publish-up-arrow1 {
  margin-top: -18px;
}
.content-wide-title .body .publish-icon:hover .publish-up-arrow2 {
  margin-top: -10px;
}
.content-wide-title .body .publish-up-arrow2, .content-wide-title .body .publish-up-arrow1 {
  width: 14px;
  height: 8px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
  position: absolute;
  left: 7px;
  top: 1px;
}
.content-wide-title .body .edit-icon {
  width: 38px;
  height: 32px;
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  cursor: pointer;
}
.content-wide-title .body .edit-icon:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}
.content-wide-title .body .pen-icon {
  width: 50px;
  height: 40px;
  background-repeat: no-repeat;
  cursor: pointer;
}
.content-wide-title .body .pen-icon:hover .PenToSquareSolid1 {
  transition: 0.3s;
  transform: translate(7px, -62%);
}
.content-wide-title .body .pen-icon:hover::after {
  z-index: 2;
  opacity: 1;
}
.content-wide-title .body .detail-more-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-repeat: no-repeat;
  cursor: pointer;
}
.content-wide-title .body .detail-more-icon:hover {
  transition-delay: 0.2s;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}
.content-wide-title .body .delete-icon {
  display: inline-block;
  width: 30px;
  height: 40px;
  margin-top: 3px;
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
  position: relative;
}
.content-wide-title .body .delete-icon::after {
  background-color: #000000;
  content: "削除";
  width: max-content;
  padding: 2px 5px;
  border: 1px solid #f27a43;
  position: absolute;
  color: #ffffff;
  font-size: 11px;
  text-align: center;
  left: -37px;
  bottom: 40px;
  z-index: 0;
  opacity: 0;
  transition: all 0.5s ease-in-out;
}
.content-wide-title .body .delete-icon:hover .trash-can-solid-2 {
  margin-top: 3px;
  transition: 0.3s;
  transform: matrix(0.829, -0.545, 0.545, 0.829, -1, 0.878);
  fill: #f27a43;
}
.content-wide-title .body .delete-icon:hover .trash-can-solid {
  fill: #f27a43;
}
.content-wide-title .body .delete-icon:hover::after {
  z-index: 2;
  opacity: 1;
}
.content-wide-title .body .parameter-delete-icon {
  cursor: pointer;
  z-index: 1;
  position: relative;
}
.content-wide-title .body .parameter-delete-icon::after {
  background-color: #000000;
  content: "削除";
  width: max-content;
  padding: 2px 5px;
  border: 1px solid #f27a43;
  position: absolute;
  color: #ffffff;
  font-size: 11px;
  text-align: center;
  left: -20px;
  bottom: 30px;
  z-index: 0;
  opacity: 0;
  transition: all 0.5s ease-in-out;
}
.content-wide-title .body .parameter-delete-icon:hover .trash-can-solid-2 {
  z-index: 5;
  margin-top: 3px;
  transition: 0.3s;
  transform: matrix(0.829, -0.545, 0.545, 0.829, -1, 0.878);
  fill: #f27a43;
}
.content-wide-title .body .parameter-delete-icon:hover .trash-can-solid {
  fill: #f27a43;
}
.content-wide-title .body .parameter-delete-icon:hover::after {
  z-index: 2;
  opacity: 1;
}
.content-wide-title .body .arrow-icon {
  width: 16px;
  height: 18px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.content-wide-title .body .uncheck-icon {
  width: 25px;
  height: 25px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.content-wide-title .body .check-icon {
  width: 25px;
  height: 25px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.content-wide-title .body .dropdown-icon {
  width: 16px;
  height: 16px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.content-wide-title .body .copy-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.content-wide-title .body .plus-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.content-wide-title .body .minus-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.content-wide-title .body .close-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
  rotate: 45deg;
}
.content-wide-title .body .grey-minus-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.content-wide-title .body .pink-plus-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.content-wide-title .body .random-plus {
  width: 30px;
  height: 30px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.content-wide-title .body .random-plus:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}
.content-wide-title .body .random-plus-disable {
  width: 30px;
  height: 30px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.content-wide-title .bottom .space-width {
  width: 340px;
}
.content-wide-title .bottom .font-size {
  font-size: 25px;
}
.content-wide-title .bottom .left-arrow {
  width: 50px;
  height: 15px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  background-repeat: no-repeat;
  margin-top: 27px;
  cursor: pointer;
}
.content-wide-title .bottom .left-arrow:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
}
.content-wide-title .bottom .right-arrow {
  width: 50px;
  height: 15px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  background-repeat: no-repeat;
  transform: scaleX(-1);
  margin-top: 27px;
  cursor: pointer;
}
.content-wide-title .bottom .right-arrow:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
  transform: scaleX(-1);
}

.content-wider-title {
  /* clip path variables */
  /* end clip path variables */
}
.content-wider-title .content-bg-darker {
  background-color: rgba(0, 0, 0, 0.2);
}
.content-wider-title .content-border {
  background-color: rgba(242, 122, 67, 0.5);
  min-height: 200px;
  width: 100%;
  height: 100%;
  z-index: -1;
  /* Content Border Path */
  clip-path: polygon(evenodd, 0% 0%, 380px 0%, 425px 46px, calc(100% - 12px) 45px, 100% 57px, 100% calc(100% - 12px), calc(100% - 12px) 100%, calc(100% - (100% - 340px) / 2) 100%, calc(100% - (100% - 340px) / 2 - 25px - 2px) calc(100% - 40px), calc((100% - 340px) / 2 + 25px + 2px) calc(100% - 40px), calc((100% - 340px) / 2) 100%, 12px 100%, 14px calc(100% - 2px), 2px calc(100% - 12px - 2px), 2px 2px, 379px 2px, 424px 47px, calc(100% - 2px - 12px) 47px, calc(100% - 2px) 59px, calc(100% - 2px) calc(100% - 12px - 2px), calc(100% - 12px - 2px) calc(100% - 2px), calc(100% - (100% - 340px) / 2 + 2px) calc(100% - 2px), calc(100% - (100% - 340px) / 2 - 25px) calc(100% - 42px), calc((100% - 340px) / 2 + 25px) calc(100% - 42px), calc((100% - 340px) / 2 - 2px) calc(100% - 2px), 14px calc(100% - 2px), 12px 100%, 0% calc(100% - 12px));
  /*End Content Border Path */
}
.content-wider-title .content-border-none-bt-space {
  background-color: rgba(242, 122, 67, 0.5);
  min-height: 200px;
  width: 100%;
  height: calc(100% + 3px);
  z-index: -1;
  /* Content Border Path */
  clip-path: polygon(evenodd, 0% 0%, 380px 0%, 425px 46px, calc(100% - 12px) 45px, 100% 57px, 100% calc(100% - 12px), calc(100% - 12px) 100%, 12px 100%, 14px calc(100% - 2px), 2px calc(100% - 12px - 2px), 2px 2px, 379px 2px, 424px 47px, calc(100% - 2px - 12px) 47px, calc(100% - 2px) 59px, calc(100% - 2px) calc(100% - 12px - 2px), calc(100% - 12px - 2px) calc(100% - 2px), 14px calc(100% - 2px), 12px 100%, 0% calc(100% - 12px));
  /*End Content Border Path */
}
.content-wider-title .title {
  width: 380px;
  font-size: 29px;
  color: white;
  font-family: "851ゴチカクット";
}
.content-wider-title .title .font-size {
  font-size: 29px;
}
.content-wider-title .wide-top-space {
  width: calc(100% - 160px) !important;
  height: 45px;
}
.content-wider-title .top-space {
  width: calc(100% - 380px);
  height: 45px;
}
.content-wider-title .body .header-font {
  font-size: 20px;
  text-align: center;
}
.content-wider-title .body .body-font {
  font-size: 18px;
  font-family: "NotoSansJP";
  line-height: 22px;
}
.content-wider-title .body .publish-icon {
  width: 28px;
  height: 9px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
  margin-top: 4px;
  position: relative;
}
.content-wider-title .body .publish-icon .publish-up-arrow {
  transition: all 0.5s ease;
}
.content-wider-title .body .publish-icon:hover .publish-up-arrow1 {
  margin-top: -18px;
}
.content-wider-title .body .publish-icon:hover .publish-up-arrow2 {
  margin-top: -10px;
}
.content-wider-title .body .publish-up-arrow2, .content-wider-title .body .publish-up-arrow1 {
  width: 14px;
  height: 8px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
  position: absolute;
  left: 7px;
  top: 1px;
}
.content-wider-title .body .edit-icon {
  width: 38px;
  height: 32px;
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  cursor: pointer;
}
.content-wider-title .body .edit-icon:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}
.content-wider-title .body .pen-icon {
  width: 50px;
  height: 40px;
  background-repeat: no-repeat;
  cursor: pointer;
}
.content-wider-title .body .pen-icon:hover .PenToSquareSolid1 {
  transition: 0.3s;
  transform: translate(7px, -62%);
}
.content-wider-title .body .pen-icon:hover::after {
  z-index: 2;
  opacity: 1;
}
.content-wider-title .body .detail-more-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-repeat: no-repeat;
  cursor: pointer;
}
.content-wider-title .body .detail-more-icon:hover {
  transition-delay: 0.2s;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}
.content-wider-title .body .delete-icon {
  display: inline-block;
  width: 30px;
  height: 40px;
  margin-top: 3px;
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
  position: relative;
}
.content-wider-title .body .delete-icon::after {
  background-color: #000000;
  content: "削除";
  width: max-content;
  padding: 2px 5px;
  border: 1px solid #f27a43;
  position: absolute;
  color: #ffffff;
  font-size: 11px;
  text-align: center;
  left: -37px;
  bottom: 40px;
  z-index: 0;
  opacity: 0;
  transition: all 0.5s ease-in-out;
}
.content-wider-title .body .delete-icon:hover .trash-can-solid-2 {
  margin-top: 3px;
  transition: 0.3s;
  transform: matrix(0.829, -0.545, 0.545, 0.829, -1, 0.878);
  fill: #f27a43;
}
.content-wider-title .body .delete-icon:hover .trash-can-solid {
  fill: #f27a43;
}
.content-wider-title .body .delete-icon:hover::after {
  z-index: 2;
  opacity: 1;
}
.content-wider-title .body .parameter-delete-icon {
  cursor: pointer;
  z-index: 1;
  position: relative;
}
.content-wider-title .body .parameter-delete-icon::after {
  background-color: #000000;
  content: "削除";
  width: max-content;
  padding: 2px 5px;
  border: 1px solid #f27a43;
  position: absolute;
  color: #ffffff;
  font-size: 11px;
  text-align: center;
  left: -20px;
  bottom: 30px;
  z-index: 0;
  opacity: 0;
  transition: all 0.5s ease-in-out;
}
.content-wider-title .body .parameter-delete-icon:hover .trash-can-solid-2 {
  z-index: 5;
  margin-top: 3px;
  transition: 0.3s;
  transform: matrix(0.829, -0.545, 0.545, 0.829, -1, 0.878);
  fill: #f27a43;
}
.content-wider-title .body .parameter-delete-icon:hover .trash-can-solid {
  fill: #f27a43;
}
.content-wider-title .body .parameter-delete-icon:hover::after {
  z-index: 2;
  opacity: 1;
}
.content-wider-title .body .arrow-icon {
  width: 16px;
  height: 18px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.content-wider-title .body .uncheck-icon {
  width: 25px;
  height: 25px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.content-wider-title .body .check-icon {
  width: 25px;
  height: 25px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.content-wider-title .body .dropdown-icon {
  width: 16px;
  height: 16px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.content-wider-title .body .copy-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.content-wider-title .body .plus-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.content-wider-title .body .minus-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.content-wider-title .body .close-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
  rotate: 45deg;
}
.content-wider-title .body .grey-minus-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.content-wider-title .body .pink-plus-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.content-wider-title .body .random-plus {
  width: 30px;
  height: 30px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.content-wider-title .body .random-plus:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}
.content-wider-title .body .random-plus-disable {
  width: 30px;
  height: 30px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.content-wider-title .bottom .space-width {
  width: 340px;
}
.content-wider-title .bottom .font-size {
  font-size: 25px;
}
.content-wider-title .bottom .left-arrow {
  width: 50px;
  height: 15px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  background-repeat: no-repeat;
  margin-top: 27px;
  cursor: pointer;
}
.content-wider-title .bottom .left-arrow:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
}
.content-wider-title .bottom .right-arrow {
  width: 50px;
  height: 15px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  background-repeat: no-repeat;
  transform: scaleX(-1);
  margin-top: 27px;
  cursor: pointer;
}
.content-wider-title .bottom .right-arrow:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
  transform: scaleX(-1);
}

.update-history-content {
  /* clip path variables */
  /* end clip path variables */
}
.update-history-content .content-bg-darker {
  background-color: rgba(0, 0, 0, 0.2);
}
.update-history-content .content-border {
  background-color: rgba(242, 122, 67, 0.5);
  min-height: 200px;
  width: 100%;
  height: 100%;
  z-index: -1;
  /* Content Border Path */
  clip-path: polygon(evenodd, 0% 0%, 264.12px 0%, 309.12px 46px, calc(100% - 12px) 45px, 100% 57px, 100% calc(100% - 12px), calc(100% - 12px) 100%, calc(100% - (100% - 340px) / 2) 100%, calc(100% - (100% - 340px) / 2 - 25px - 2px) calc(100% - 40px), calc((100% - 340px) / 2 + 25px + 2px) calc(100% - 40px), calc((100% - 340px) / 2) 100%, 12px 100%, 14px calc(100% - 2px), 2px calc(100% - 12px - 2px), 2px 2px, 263.12px 2px, 308.12px 47px, calc(100% - 2px - 12px) 47px, calc(100% - 2px) 59px, calc(100% - 2px) calc(100% - 12px - 2px), calc(100% - 12px - 2px) calc(100% - 2px), calc(100% - (100% - 340px) / 2 + 2px) calc(100% - 2px), calc(100% - (100% - 340px) / 2 - 25px) calc(100% - 42px), calc((100% - 340px) / 2 + 25px) calc(100% - 42px), calc((100% - 340px) / 2 - 2px) calc(100% - 2px), 14px calc(100% - 2px), 12px 100%, 0% calc(100% - 12px));
  /*End Content Border Path */
}
.update-history-content .content-border-none-bt-space {
  background-color: rgba(242, 122, 67, 0.5);
  min-height: 200px;
  width: 100%;
  height: calc(100% + 3px);
  z-index: -1;
  /* Content Border Path */
  clip-path: polygon(evenodd, 0% 0%, 264.12px 0%, 309.12px 46px, calc(100% - 12px) 45px, 100% 57px, 100% calc(100% - 12px), calc(100% - 12px) 100%, 12px 100%, 14px calc(100% - 2px), 2px calc(100% - 12px - 2px), 2px 2px, 263.12px 2px, 308.12px 47px, calc(100% - 2px - 12px) 47px, calc(100% - 2px) 59px, calc(100% - 2px) calc(100% - 12px - 2px), calc(100% - 12px - 2px) calc(100% - 2px), 14px calc(100% - 2px), 12px 100%, 0% calc(100% - 12px));
  /*End Content Border Path */
}
.update-history-content .title {
  width: 264.12px;
  font-size: 29px;
  color: white;
  font-family: "851ゴチカクット";
}
.update-history-content .title .font-size {
  font-size: 29px;
}
.update-history-content .wide-top-space {
  width: calc(100% - 160px) !important;
  height: 45px;
}
.update-history-content .top-space {
  width: calc(100% - 264.12px);
  height: 45px;
}
.update-history-content .body .header-font {
  font-size: 20px;
  text-align: center;
}
.update-history-content .body .body-font {
  font-size: 18px;
  font-family: "NotoSansJP";
  line-height: 22px;
}
.update-history-content .body .publish-icon {
  width: 28px;
  height: 9px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
  margin-top: 4px;
  position: relative;
}
.update-history-content .body .publish-icon .publish-up-arrow {
  transition: all 0.5s ease;
}
.update-history-content .body .publish-icon:hover .publish-up-arrow1 {
  margin-top: -18px;
}
.update-history-content .body .publish-icon:hover .publish-up-arrow2 {
  margin-top: -10px;
}
.update-history-content .body .publish-up-arrow2, .update-history-content .body .publish-up-arrow1 {
  width: 14px;
  height: 8px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
  position: absolute;
  left: 7px;
  top: 1px;
}
.update-history-content .body .edit-icon {
  width: 38px;
  height: 32px;
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  cursor: pointer;
}
.update-history-content .body .edit-icon:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}
.update-history-content .body .pen-icon {
  width: 50px;
  height: 40px;
  background-repeat: no-repeat;
  cursor: pointer;
}
.update-history-content .body .pen-icon:hover .PenToSquareSolid1 {
  transition: 0.3s;
  transform: translate(7px, -62%);
}
.update-history-content .body .pen-icon:hover::after {
  z-index: 2;
  opacity: 1;
}
.update-history-content .body .detail-more-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-repeat: no-repeat;
  cursor: pointer;
}
.update-history-content .body .detail-more-icon:hover {
  transition-delay: 0.2s;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}
.update-history-content .body .delete-icon {
  display: inline-block;
  width: 30px;
  height: 40px;
  margin-top: 3px;
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
  position: relative;
}
.update-history-content .body .delete-icon::after {
  background-color: #000000;
  content: "削除";
  width: max-content;
  padding: 2px 5px;
  border: 1px solid #f27a43;
  position: absolute;
  color: #ffffff;
  font-size: 11px;
  text-align: center;
  left: -37px;
  bottom: 40px;
  z-index: 0;
  opacity: 0;
  transition: all 0.5s ease-in-out;
}
.update-history-content .body .delete-icon:hover .trash-can-solid-2 {
  margin-top: 3px;
  transition: 0.3s;
  transform: matrix(0.829, -0.545, 0.545, 0.829, -1, 0.878);
  fill: #f27a43;
}
.update-history-content .body .delete-icon:hover .trash-can-solid {
  fill: #f27a43;
}
.update-history-content .body .delete-icon:hover::after {
  z-index: 2;
  opacity: 1;
}
.update-history-content .body .parameter-delete-icon {
  cursor: pointer;
  z-index: 1;
  position: relative;
}
.update-history-content .body .parameter-delete-icon::after {
  background-color: #000000;
  content: "削除";
  width: max-content;
  padding: 2px 5px;
  border: 1px solid #f27a43;
  position: absolute;
  color: #ffffff;
  font-size: 11px;
  text-align: center;
  left: -20px;
  bottom: 30px;
  z-index: 0;
  opacity: 0;
  transition: all 0.5s ease-in-out;
}
.update-history-content .body .parameter-delete-icon:hover .trash-can-solid-2 {
  z-index: 5;
  margin-top: 3px;
  transition: 0.3s;
  transform: matrix(0.829, -0.545, 0.545, 0.829, -1, 0.878);
  fill: #f27a43;
}
.update-history-content .body .parameter-delete-icon:hover .trash-can-solid {
  fill: #f27a43;
}
.update-history-content .body .parameter-delete-icon:hover::after {
  z-index: 2;
  opacity: 1;
}
.update-history-content .body .arrow-icon {
  width: 16px;
  height: 18px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.update-history-content .body .uncheck-icon {
  width: 25px;
  height: 25px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.update-history-content .body .check-icon {
  width: 25px;
  height: 25px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.update-history-content .body .dropdown-icon {
  width: 16px;
  height: 16px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.update-history-content .body .copy-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.update-history-content .body .plus-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.update-history-content .body .minus-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.update-history-content .body .close-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
  rotate: 45deg;
}
.update-history-content .body .grey-minus-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.update-history-content .body .pink-plus-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.update-history-content .body .random-plus {
  width: 30px;
  height: 30px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.update-history-content .body .random-plus:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}
.update-history-content .body .random-plus-disable {
  width: 30px;
  height: 30px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.update-history-content .bottom .space-width {
  width: 340px;
}
.update-history-content .bottom .font-size {
  font-size: 25px;
}
.update-history-content .bottom .left-arrow {
  width: 50px;
  height: 15px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  background-repeat: no-repeat;
  margin-top: 27px;
  cursor: pointer;
}
.update-history-content .bottom .left-arrow:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
}
.update-history-content .bottom .right-arrow {
  width: 50px;
  height: 15px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  background-repeat: no-repeat;
  transform: scaleX(-1);
  margin-top: 27px;
  cursor: pointer;
}
.update-history-content .bottom .right-arrow:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
  transform: scaleX(-1);
}

.users-content {
  /* clip path variables */
  /* end clip path variables */
}
.users-content .content-bg-darker {
  background-color: rgba(0, 0, 0, 0.2);
}
.users-content .content-border {
  background-color: rgba(242, 122, 67, 0.5);
  min-height: 200px;
  width: 100%;
  height: 100%;
  z-index: -1;
  /* Content Border Path */
  clip-path: polygon(evenodd, 0% 0%, 275.56px 0%, 320.56px 46px, calc(100% - 12px) 45px, 100% 57px, 100% calc(100% - 12px), calc(100% - 12px) 100%, calc(100% - (100% - 340px) / 2) 100%, calc(100% - (100% - 340px) / 2 - 25px - 2px) calc(100% - 40px), calc((100% - 340px) / 2 + 25px + 2px) calc(100% - 40px), calc((100% - 340px) / 2) 100%, 12px 100%, 14px calc(100% - 2px), 2px calc(100% - 12px - 2px), 2px 2px, 274.56px 2px, 319.56px 47px, calc(100% - 2px - 12px) 47px, calc(100% - 2px) 59px, calc(100% - 2px) calc(100% - 12px - 2px), calc(100% - 12px - 2px) calc(100% - 2px), calc(100% - (100% - 340px) / 2 + 2px) calc(100% - 2px), calc(100% - (100% - 340px) / 2 - 25px) calc(100% - 42px), calc((100% - 340px) / 2 + 25px) calc(100% - 42px), calc((100% - 340px) / 2 - 2px) calc(100% - 2px), 14px calc(100% - 2px), 12px 100%, 0% calc(100% - 12px));
  /*End Content Border Path */
}
.users-content .content-border-none-bt-space {
  background-color: rgba(242, 122, 67, 0.5);
  min-height: 200px;
  width: 100%;
  height: calc(100% + 3px);
  z-index: -1;
  /* Content Border Path */
  clip-path: polygon(evenodd, 0% 0%, 275.56px 0%, 320.56px 46px, calc(100% - 12px) 45px, 100% 57px, 100% calc(100% - 12px), calc(100% - 12px) 100%, 12px 100%, 14px calc(100% - 2px), 2px calc(100% - 12px - 2px), 2px 2px, 274.56px 2px, 319.56px 47px, calc(100% - 2px - 12px) 47px, calc(100% - 2px) 59px, calc(100% - 2px) calc(100% - 12px - 2px), calc(100% - 12px - 2px) calc(100% - 2px), 14px calc(100% - 2px), 12px 100%, 0% calc(100% - 12px));
  /*End Content Border Path */
}
.users-content .title {
  width: 275.56px;
  font-size: 29px;
  color: white;
  font-family: "851ゴチカクット";
}
.users-content .title .font-size {
  font-size: 29px;
}
.users-content .wide-top-space {
  width: calc(100% - 160px) !important;
  height: 45px;
}
.users-content .top-space {
  width: calc(100% - 275.56px);
  height: 45px;
}
.users-content .body .header-font {
  font-size: 20px;
  text-align: center;
}
.users-content .body .body-font {
  font-size: 18px;
  font-family: "NotoSansJP";
  line-height: 22px;
}
.users-content .body .publish-icon {
  width: 28px;
  height: 9px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
  margin-top: 4px;
  position: relative;
}
.users-content .body .publish-icon .publish-up-arrow {
  transition: all 0.5s ease;
}
.users-content .body .publish-icon:hover .publish-up-arrow1 {
  margin-top: -18px;
}
.users-content .body .publish-icon:hover .publish-up-arrow2 {
  margin-top: -10px;
}
.users-content .body .publish-up-arrow2, .users-content .body .publish-up-arrow1 {
  width: 14px;
  height: 8px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
  position: absolute;
  left: 7px;
  top: 1px;
}
.users-content .body .edit-icon {
  width: 38px;
  height: 32px;
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  cursor: pointer;
}
.users-content .body .edit-icon:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}
.users-content .body .pen-icon {
  width: 50px;
  height: 40px;
  background-repeat: no-repeat;
  cursor: pointer;
}
.users-content .body .pen-icon:hover .PenToSquareSolid1 {
  transition: 0.3s;
  transform: translate(7px, -62%);
}
.users-content .body .pen-icon:hover::after {
  z-index: 2;
  opacity: 1;
}
.users-content .body .detail-more-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-repeat: no-repeat;
  cursor: pointer;
}
.users-content .body .detail-more-icon:hover {
  transition-delay: 0.2s;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}
.users-content .body .delete-icon {
  display: inline-block;
  width: 30px;
  height: 40px;
  margin-top: 3px;
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
  position: relative;
}
.users-content .body .delete-icon::after {
  background-color: #000000;
  content: "削除";
  width: max-content;
  padding: 2px 5px;
  border: 1px solid #f27a43;
  position: absolute;
  color: #ffffff;
  font-size: 11px;
  text-align: center;
  left: -37px;
  bottom: 40px;
  z-index: 0;
  opacity: 0;
  transition: all 0.5s ease-in-out;
}
.users-content .body .delete-icon:hover .trash-can-solid-2 {
  margin-top: 3px;
  transition: 0.3s;
  transform: matrix(0.829, -0.545, 0.545, 0.829, -1, 0.878);
  fill: #f27a43;
}
.users-content .body .delete-icon:hover .trash-can-solid {
  fill: #f27a43;
}
.users-content .body .delete-icon:hover::after {
  z-index: 2;
  opacity: 1;
}
.users-content .body .parameter-delete-icon {
  cursor: pointer;
  z-index: 1;
  position: relative;
}
.users-content .body .parameter-delete-icon::after {
  background-color: #000000;
  content: "削除";
  width: max-content;
  padding: 2px 5px;
  border: 1px solid #f27a43;
  position: absolute;
  color: #ffffff;
  font-size: 11px;
  text-align: center;
  left: -20px;
  bottom: 30px;
  z-index: 0;
  opacity: 0;
  transition: all 0.5s ease-in-out;
}
.users-content .body .parameter-delete-icon:hover .trash-can-solid-2 {
  z-index: 5;
  margin-top: 3px;
  transition: 0.3s;
  transform: matrix(0.829, -0.545, 0.545, 0.829, -1, 0.878);
  fill: #f27a43;
}
.users-content .body .parameter-delete-icon:hover .trash-can-solid {
  fill: #f27a43;
}
.users-content .body .parameter-delete-icon:hover::after {
  z-index: 2;
  opacity: 1;
}
.users-content .body .arrow-icon {
  width: 16px;
  height: 18px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.users-content .body .uncheck-icon {
  width: 25px;
  height: 25px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.users-content .body .check-icon {
  width: 25px;
  height: 25px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.users-content .body .dropdown-icon {
  width: 16px;
  height: 16px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.users-content .body .copy-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.users-content .body .plus-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.users-content .body .minus-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.users-content .body .close-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
  rotate: 45deg;
}
.users-content .body .grey-minus-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.users-content .body .pink-plus-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.users-content .body .random-plus {
  width: 30px;
  height: 30px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.users-content .body .random-plus:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}
.users-content .body .random-plus-disable {
  width: 30px;
  height: 30px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.users-content .bottom .space-width {
  width: 340px;
}
.users-content .bottom .font-size {
  font-size: 25px;
}
.users-content .bottom .left-arrow {
  width: 50px;
  height: 15px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  background-repeat: no-repeat;
  margin-top: 27px;
  cursor: pointer;
}
.users-content .bottom .left-arrow:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
}
.users-content .bottom .right-arrow {
  width: 50px;
  height: 15px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  background-repeat: no-repeat;
  transform: scaleX(-1);
  margin-top: 27px;
  cursor: pointer;
}
.users-content .bottom .right-arrow:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
  transform: scaleX(-1);
}

.setting-content {
  /* clip path variables */
  /* end clip path variables */
}
.setting-content .content-bg-darker {
  background-color: rgba(0, 0, 0, 0.2);
}
.setting-content .content-border {
  background-color: rgba(242, 122, 67, 0.5);
  min-height: 200px;
  width: 100%;
  height: 100%;
  z-index: -1;
  /* Content Border Path */
  clip-path: polygon(evenodd, 0% 0%, 270px 0%, 315px 46px, calc(100% - 12px) 45px, 100% 57px, 100% calc(100% - 12px), calc(100% - 12px) 100%, calc(100% - (100% - 340px) / 2) 100%, calc(100% - (100% - 340px) / 2 - 25px - 2px) calc(100% - 40px), calc((100% - 340px) / 2 + 25px + 2px) calc(100% - 40px), calc((100% - 340px) / 2) 100%, 12px 100%, 14px calc(100% - 2px), 2px calc(100% - 12px - 2px), 2px 2px, 269px 2px, 314px 47px, calc(100% - 2px - 12px) 47px, calc(100% - 2px) 59px, calc(100% - 2px) calc(100% - 12px - 2px), calc(100% - 12px - 2px) calc(100% - 2px), calc(100% - (100% - 340px) / 2 + 2px) calc(100% - 2px), calc(100% - (100% - 340px) / 2 - 25px) calc(100% - 42px), calc((100% - 340px) / 2 + 25px) calc(100% - 42px), calc((100% - 340px) / 2 - 2px) calc(100% - 2px), 14px calc(100% - 2px), 12px 100%, 0% calc(100% - 12px));
  /*End Content Border Path */
}
.setting-content .content-border-none-bt-space {
  background-color: rgba(242, 122, 67, 0.5);
  min-height: 200px;
  width: 100%;
  height: calc(100% + 3px);
  z-index: -1;
  /* Content Border Path */
  clip-path: polygon(evenodd, 0% 0%, 270px 0%, 315px 46px, calc(100% - 12px) 45px, 100% 57px, 100% calc(100% - 12px), calc(100% - 12px) 100%, 12px 100%, 14px calc(100% - 2px), 2px calc(100% - 12px - 2px), 2px 2px, 269px 2px, 314px 47px, calc(100% - 2px - 12px) 47px, calc(100% - 2px) 59px, calc(100% - 2px) calc(100% - 12px - 2px), calc(100% - 12px - 2px) calc(100% - 2px), 14px calc(100% - 2px), 12px 100%, 0% calc(100% - 12px));
  /*End Content Border Path */
}
.setting-content .title {
  width: 270px;
  font-size: 29px;
  color: white;
  font-family: "851ゴチカクット";
}
.setting-content .title .font-size {
  font-size: 29px;
}
.setting-content .wide-top-space {
  width: calc(100% - 160px) !important;
  height: 45px;
}
.setting-content .top-space {
  width: calc(100% - 270px);
  height: 45px;
}
.setting-content .body .header-font {
  font-size: 20px;
  text-align: center;
}
.setting-content .body .body-font {
  font-size: 18px;
  font-family: "NotoSansJP";
  line-height: 22px;
}
.setting-content .body .publish-icon {
  width: 28px;
  height: 9px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
  margin-top: 4px;
  position: relative;
}
.setting-content .body .publish-icon .publish-up-arrow {
  transition: all 0.5s ease;
}
.setting-content .body .publish-icon:hover .publish-up-arrow1 {
  margin-top: -18px;
}
.setting-content .body .publish-icon:hover .publish-up-arrow2 {
  margin-top: -10px;
}
.setting-content .body .publish-up-arrow2, .setting-content .body .publish-up-arrow1 {
  width: 14px;
  height: 8px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
  position: absolute;
  left: 7px;
  top: 1px;
}
.setting-content .body .edit-icon {
  width: 38px;
  height: 32px;
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  cursor: pointer;
}
.setting-content .body .edit-icon:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}
.setting-content .body .pen-icon {
  width: 50px;
  height: 40px;
  background-repeat: no-repeat;
  cursor: pointer;
}
.setting-content .body .pen-icon:hover .PenToSquareSolid1 {
  transition: 0.3s;
  transform: translate(7px, -62%);
}
.setting-content .body .pen-icon:hover::after {
  z-index: 2;
  opacity: 1;
}
.setting-content .body .detail-more-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-repeat: no-repeat;
  cursor: pointer;
}
.setting-content .body .detail-more-icon:hover {
  transition-delay: 0.2s;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}
.setting-content .body .delete-icon {
  display: inline-block;
  width: 30px;
  height: 40px;
  margin-top: 3px;
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
  position: relative;
}
.setting-content .body .delete-icon::after {
  background-color: #000000;
  content: "削除";
  width: max-content;
  padding: 2px 5px;
  border: 1px solid #f27a43;
  position: absolute;
  color: #ffffff;
  font-size: 11px;
  text-align: center;
  left: -37px;
  bottom: 40px;
  z-index: 0;
  opacity: 0;
  transition: all 0.5s ease-in-out;
}
.setting-content .body .delete-icon:hover .trash-can-solid-2 {
  margin-top: 3px;
  transition: 0.3s;
  transform: matrix(0.829, -0.545, 0.545, 0.829, -1, 0.878);
  fill: #f27a43;
}
.setting-content .body .delete-icon:hover .trash-can-solid {
  fill: #f27a43;
}
.setting-content .body .delete-icon:hover::after {
  z-index: 2;
  opacity: 1;
}
.setting-content .body .parameter-delete-icon {
  cursor: pointer;
  z-index: 1;
  position: relative;
}
.setting-content .body .parameter-delete-icon::after {
  background-color: #000000;
  content: "削除";
  width: max-content;
  padding: 2px 5px;
  border: 1px solid #f27a43;
  position: absolute;
  color: #ffffff;
  font-size: 11px;
  text-align: center;
  left: -20px;
  bottom: 30px;
  z-index: 0;
  opacity: 0;
  transition: all 0.5s ease-in-out;
}
.setting-content .body .parameter-delete-icon:hover .trash-can-solid-2 {
  z-index: 5;
  margin-top: 3px;
  transition: 0.3s;
  transform: matrix(0.829, -0.545, 0.545, 0.829, -1, 0.878);
  fill: #f27a43;
}
.setting-content .body .parameter-delete-icon:hover .trash-can-solid {
  fill: #f27a43;
}
.setting-content .body .parameter-delete-icon:hover::after {
  z-index: 2;
  opacity: 1;
}
.setting-content .body .arrow-icon {
  width: 16px;
  height: 18px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.setting-content .body .uncheck-icon {
  width: 25px;
  height: 25px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.setting-content .body .check-icon {
  width: 25px;
  height: 25px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.setting-content .body .dropdown-icon {
  width: 16px;
  height: 16px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.setting-content .body .copy-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.setting-content .body .plus-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.setting-content .body .minus-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.setting-content .body .close-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
  rotate: 45deg;
}
.setting-content .body .grey-minus-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.setting-content .body .pink-plus-icon {
  width: 20px;
  height: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.setting-content .body .random-plus {
  width: 30px;
  height: 30px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.setting-content .body .random-plus:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}
.setting-content .body .random-plus-disable {
  width: 30px;
  height: 30px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
  background-repeat: no-repeat;
  cursor: pointer;
  z-index: 1;
}
.setting-content .bottom .space-width {
  width: 340px;
}
.setting-content .bottom .font-size {
  font-size: 25px;
}
.setting-content .bottom .left-arrow {
  width: 50px;
  height: 15px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  background-repeat: no-repeat;
  margin-top: 27px;
  cursor: pointer;
}
.setting-content .bottom .left-arrow:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
}
.setting-content .bottom .right-arrow {
  width: 50px;
  height: 15px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  background-repeat: no-repeat;
  transform: scaleX(-1);
  margin-top: 27px;
  cursor: pointer;
}
.setting-content .bottom .right-arrow:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
  transform: scaleX(-1);
}

/** end content */
.login-box {
  width: 910px;
  height: 510px;
  margin: auto;
}

/** Input Classes */
.activate-on-hover:hover {
  opacity: 1;
}
.activate-on-hover:hover .text-box {
  opacity: 1;
}

.hide-placeholder:focus::placeholder {
  color: transparent !important;
}

.smaller-placeholder::placeholder {
  font-size: 15px !important;
  color: #9a9a9a;
}

.large-placeholder::placeholder {
  font-size: 17px !important;
}

.lighter-placeholder::placeholder {
  color: rgba(255, 255, 255, 0.4) !important;
}

.center-placeholder {
  padding-bottom: 0.5% !important;
}

.center-placeholder::placeholder {
  text-align: center !important;
}

.left-placeholder::placeholder {
  text-align: left !important;
}

.inherit-placeholder::placeholder {
  color: inherit !important;
  font-size: inherit !important;
}

.hiragino-sans-placeholder::placeholder {
  font-family: "Hiragino Sans" !important;
}

.font-18px-impt {
  font-size: 18px !important;
}

.minus-margin {
  margin-top: -7px;
}

.person-icon {
  background-color: transparent;
  border: 0;
  position: relative;
  z-index: 1;
}
.person-icon::after {
  background-color: #000000;
  content: "ペルリア追加発行";
  width: max-content;
  padding: 2px 5px;
  border: 1px solid #f27a43;
  position: absolute;
  color: #ffffff;
  font-size: 11px;
  text-align: center;
  left: -55px;
  bottom: 25px;
  z-index: 1;
  opacity: 0;
  transition: all 0.5s ease-in-out;
}
.person-icon:hover path {
  opacity: 1;
}
.person-icon:hover::after {
  z-index: 2;
  opacity: 1;
}

.upload-icon {
  background-color: transparent;
  border: 0;
  position: relative;
  z-index: 1;
}
.upload-icon::after {
  background-color: #000000;
  content: "売り出し設定";
  width: max-content;
  padding: 2px 5px;
  border: 1px solid #f27a43;
  position: absolute;
  color: #ffffff;
  font-size: 11px;
  text-align: center;
  left: -55px;
  bottom: 25px;
  z-index: 1;
  opacity: 0;
  transition: all 0.5s ease-in-out;
}
.upload-icon:hover path {
  opacity: 1;
}
.upload-icon:hover::after {
  z-index: 2;
  opacity: 1;
}

input[type=number]::-webkit-outer-spin-button,
input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.text-input {
  position: relative;
  min-width: 100px;
  height: 40px;
}
.text-input:focus-within {
  opacity: 1;
}
.text-input:focus-within .text-box {
  background-color: #24b8c0;
}
.text-input:hover {
  opacity: 1;
}
.text-input:hover .text-box:not(.disabled) {
  background-color: #24b8c0;
}
.text-input:hover path {
  opacity: 1;
}
.text-input:has(input:valid) {
  opacity: 1;
}
.text-input .text-box {
  position: absolute;
  top: 0px;
  opacity: 0.8;
  width: 100%;
  height: 100%;
  background-color: rgba(242, 122, 67, 0.8);
  clip-path: polygon(calc(100% - 12px) 100%, 100% calc(100% - 12px), 100% 12px, calc(100% - 12px) 0%, 12px 0%, 0% 12px, 0% calc(100% - 12px), 12px 100%);
}
.text-input .text-box::after {
  content: "";
  position: absolute;
  background-color: #000000;
  clip-path: polygon(calc(100% - 12px) 100%, 100% calc(100% - 12px), 100% 12px, calc(100% - 12px) 0%, 12px 0%, 0% 12px, 0% calc(100% - 12px), 12px 100%);
  inset: 1.5px;
}
.text-input .error-border {
  background-color: rgba(255, 0, 0, 0.4);
}
.text-input .inactive {
  background-color: rgba(122, 115, 115, 0.5);
}
.text-input .input {
  position: relative;
  color: white;
}
.text-input .textarea {
  position: absolute;
  color: white;
  left: 0;
  resize: none;
  padding-block: 10px;
}
.text-input .text-form-control-value {
  box-sizing: border-box;
  color: #dcc97e;
  font-family: "ethnocentric";
  font-size: 20px;
  text-align: center;
  padding: 0px 20px;
}
.text-input .text-form-control {
  box-sizing: border-box;
  font-size: 20px;
  padding: 0px 20px;
}
.text-input .form-control-right-icon {
  position: absolute;
  right: 12px;
  top: 5px;
}
.text-input .form-control-left-icon {
  position: absolute;
  left: 15px;
  top: 7px;
}
.text-input .text-form-control-border {
  background-color: #020202;
}
.text-input .error-left-align, .text-input .error-without-right, .text-input .error {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: #ff0000;
  position: absolute;
  right: 0;
  bottom: -22px;
  font-family: "NotoSansJP";
}
.text-input .error-without-right {
  right: unset;
  bottom: -25px;
}
.text-input .error-left-align {
  left: 0;
  overflow: visible;
}
.text-input input,
.text-input textarea {
  caret-color: #24b8c0;
  height: 100%;
  width: 100%;
  z-index: 1;
  padding: 0 16px;
  font-family: "Europa";
  font-size: 14px;
}
.text-input input::placeholder,
.text-input textarea::placeholder {
  font-size: 14px;
  color: #9a9a9a;
  vertical-align: middle;
  font-family: inherit;
}
.text-input input:focus::placeholder,
.text-input textarea:focus::placeholder {
  color: transparent;
}
.text-input .form-control-left-icon ~ input,
.text-input .form-control-left-icon ~ textarea {
  padding-left: 40px;
}
.text-input .form-control-right-icon ~ input,
.text-input .form-control-right-icon ~ textarea {
  padding-right: 40px;
}

.text-input-lesser-radius {
  position: relative;
  min-width: 100px;
  height: 40px;
}
.text-input-lesser-radius:focus-within {
  opacity: 1;
}
.text-input-lesser-radius:focus-within .text-box {
  background-color: #24b8c0;
}
.text-input-lesser-radius:hover {
  opacity: 1;
}
.text-input-lesser-radius:hover .text-box:not(.disabled) {
  background-color: #24b8c0;
}
.text-input-lesser-radius:hover path {
  opacity: 1;
}
.text-input-lesser-radius:has(input:valid) {
  opacity: 1;
}
.text-input-lesser-radius .text-box {
  position: absolute;
  top: 0px;
  opacity: 0.8;
  width: 100%;
  height: 100%;
  background-color: rgba(242, 122, 67, 0.8);
  clip-path: polygon(calc(100% - 12px) 100%, 100% calc(100% - 12px), 100% 12px, calc(100% - 12px) 0%, 12px 0%, 0% 12px, 0% calc(100% - 12px), 12px 100%);
}
.text-input-lesser-radius .text-box::after {
  content: "";
  position: absolute;
  background-color: #000000;
  clip-path: polygon(calc(100% - 12px) 100%, 100% calc(100% - 12px), 100% 12px, calc(100% - 12px) 0%, 12px 0%, 0% 12px, 0% calc(100% - 12px), 12px 100%);
  inset: 1.5px;
}
.text-input-lesser-radius .error-border {
  background-color: rgba(255, 0, 0, 0.4);
}
.text-input-lesser-radius .inactive {
  background-color: rgba(122, 115, 115, 0.5);
}
.text-input-lesser-radius .input {
  position: relative;
  color: white;
}
.text-input-lesser-radius .textarea {
  position: absolute;
  color: white;
  left: 0;
  resize: none;
  padding-block: 10px;
}
.text-input-lesser-radius .text-form-control-value {
  box-sizing: border-box;
  color: #dcc97e;
  font-family: "ethnocentric";
  font-size: 20px;
  text-align: center;
  padding: 0px 20px;
}
.text-input-lesser-radius .text-form-control {
  box-sizing: border-box;
  font-size: 20px;
  padding: 0px 20px;
}
.text-input-lesser-radius .form-control-right-icon {
  position: absolute;
  right: 12px;
  top: 5px;
}
.text-input-lesser-radius .form-control-left-icon {
  position: absolute;
  left: 15px;
  top: 7px;
}
.text-input-lesser-radius .text-form-control-border {
  background-color: #020202;
}
.text-input-lesser-radius .error-left-align, .text-input-lesser-radius .error-without-right, .text-input-lesser-radius .error {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: #ff0000;
  position: absolute;
  right: 0;
  bottom: -22px;
  font-family: "NotoSansJP";
}
.text-input-lesser-radius .error-without-right {
  right: unset;
  bottom: -25px;
}
.text-input-lesser-radius .error-left-align {
  left: 0;
  overflow: visible;
}
.text-input-lesser-radius input,
.text-input-lesser-radius textarea {
  caret-color: #24b8c0;
  height: 100%;
  width: 100%;
  z-index: 1;
  padding: 0 16px;
  font-family: "Europa";
  font-size: 14px;
}
.text-input-lesser-radius input::placeholder,
.text-input-lesser-radius textarea::placeholder {
  font-size: 14px;
  color: #9a9a9a;
  vertical-align: middle;
  font-family: inherit;
}
.text-input-lesser-radius input:focus::placeholder,
.text-input-lesser-radius textarea:focus::placeholder {
  color: transparent;
}
.text-input-lesser-radius .form-control-left-icon ~ input,
.text-input-lesser-radius .form-control-left-icon ~ textarea {
  padding-left: 40px;
}
.text-input-lesser-radius .form-control-right-icon ~ input,
.text-input-lesser-radius .form-control-right-icon ~ textarea {
  padding-right: 40px;
}

.text-input-bigger-border {
  position: relative;
  min-width: 100px;
  height: 40px;
}
.text-input-bigger-border:focus-within {
  opacity: 1;
}
.text-input-bigger-border:focus-within .text-box {
  background-color: #24b8c0;
}
.text-input-bigger-border:hover {
  opacity: 1;
}
.text-input-bigger-border:hover .text-box:not(.disabled) {
  background-color: #24b8c0;
}
.text-input-bigger-border:hover path {
  opacity: 1;
}
.text-input-bigger-border:has(input:valid) {
  opacity: 1;
}
.text-input-bigger-border .text-box {
  position: absolute;
  top: 0px;
  opacity: 0.8;
  width: 100%;
  height: 100%;
  background-color: rgba(242, 122, 67, 0.8);
  clip-path: polygon(calc(100% - 12px) 100%, 100% calc(100% - 12px), 100% 12px, calc(100% - 12px) 0%, 12px 0%, 0% 12px, 0% calc(100% - 12px), 12px 100%);
}
.text-input-bigger-border .text-box::after {
  content: "";
  position: absolute;
  background-color: #000000;
  clip-path: polygon(calc(100% - 12px) 100%, 100% calc(100% - 12px), 100% 12px, calc(100% - 12px) 0%, 12px 0%, 0% 12px, 0% calc(100% - 12px), 12px 100%);
  inset: 2.5px;
}
.text-input-bigger-border .error-border {
  background-color: rgba(255, 0, 0, 0.4);
}
.text-input-bigger-border .inactive {
  background-color: rgba(122, 115, 115, 0.5);
}
.text-input-bigger-border .input {
  position: relative;
  color: white;
}
.text-input-bigger-border .textarea {
  position: absolute;
  color: white;
  left: 0;
  resize: none;
  padding-block: 10px;
}
.text-input-bigger-border .text-form-control-value {
  box-sizing: border-box;
  color: #dcc97e;
  font-family: "ethnocentric";
  font-size: 20px;
  text-align: center;
  padding: 0px 20px;
}
.text-input-bigger-border .text-form-control {
  box-sizing: border-box;
  font-size: 20px;
  padding: 0px 20px;
}
.text-input-bigger-border .form-control-right-icon {
  position: absolute;
  right: 12px;
  top: 5px;
}
.text-input-bigger-border .form-control-left-icon {
  position: absolute;
  left: 15px;
  top: 7px;
}
.text-input-bigger-border .text-form-control-border {
  background-color: #020202;
}
.text-input-bigger-border .error-left-align, .text-input-bigger-border .error-without-right, .text-input-bigger-border .error {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: #ff0000;
  position: absolute;
  right: 0;
  bottom: -22px;
  font-family: "NotoSansJP";
}
.text-input-bigger-border .error-without-right {
  right: unset;
  bottom: -25px;
}
.text-input-bigger-border .error-left-align {
  left: 0;
  overflow: visible;
}
.text-input-bigger-border input,
.text-input-bigger-border textarea {
  caret-color: #24b8c0;
  height: 100%;
  width: 100%;
  z-index: 1;
  padding: 0 16px;
  font-family: "Europa";
  font-size: 14px;
}
.text-input-bigger-border input::placeholder,
.text-input-bigger-border textarea::placeholder {
  font-size: 14px;
  color: #9a9a9a;
  vertical-align: middle;
  font-family: inherit;
}
.text-input-bigger-border input:focus::placeholder,
.text-input-bigger-border textarea:focus::placeholder {
  color: transparent;
}
.text-input-bigger-border .form-control-left-icon ~ input,
.text-input-bigger-border .form-control-left-icon ~ textarea {
  padding-left: 40px;
}
.text-input-bigger-border .form-control-right-icon ~ input,
.text-input-bigger-border .form-control-right-icon ~ textarea {
  padding-right: 40px;
}

.text-input-big-border {
  position: relative;
  min-width: 100px;
  height: 40px;
}
.text-input-big-border:focus-within {
  opacity: 1;
}
.text-input-big-border:focus-within .text-box {
  background-color: #24b8c0;
}
.text-input-big-border:hover {
  opacity: 1;
}
.text-input-big-border:hover .text-box:not(.disabled) {
  background-color: #24b8c0;
}
.text-input-big-border:hover path {
  opacity: 1;
}
.text-input-big-border:has(input:valid) {
  opacity: 1;
}
.text-input-big-border .text-box {
  position: absolute;
  top: 0px;
  opacity: 0.8;
  width: 100%;
  height: 100%;
  background-color: rgba(242, 122, 67, 0.8);
  clip-path: polygon(calc(100% - 12px) 100%, 100% calc(100% - 12px), 100% 12px, calc(100% - 12px) 0%, 12px 0%, 0% 12px, 0% calc(100% - 12px), 12px 100%);
}
.text-input-big-border .text-box::after {
  content: "";
  position: absolute;
  background-color: #000000;
  clip-path: polygon(calc(100% - 12px) 100%, 100% calc(100% - 12px), 100% 12px, calc(100% - 12px) 0%, 12px 0%, 0% 12px, 0% calc(100% - 12px), 12px 100%);
  inset: 2px;
}
.text-input-big-border .error-border {
  background-color: rgba(255, 0, 0, 0.4);
}
.text-input-big-border .inactive {
  background-color: rgba(122, 115, 115, 0.5);
}
.text-input-big-border .input {
  position: relative;
  color: white;
}
.text-input-big-border .textarea {
  position: absolute;
  color: white;
  left: 0;
  resize: none;
  padding-block: 10px;
}
.text-input-big-border .text-form-control-value {
  box-sizing: border-box;
  color: #dcc97e;
  font-family: "ethnocentric";
  font-size: 20px;
  text-align: center;
  padding: 0px 20px;
}
.text-input-big-border .text-form-control {
  box-sizing: border-box;
  font-size: 20px;
  padding: 0px 20px;
}
.text-input-big-border .form-control-right-icon {
  position: absolute;
  right: 12px;
  top: 5px;
}
.text-input-big-border .form-control-left-icon {
  position: absolute;
  left: 15px;
  top: 7px;
}
.text-input-big-border .text-form-control-border {
  background-color: #020202;
}
.text-input-big-border .error-left-align, .text-input-big-border .error-without-right, .text-input-big-border .error {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: #ff0000;
  position: absolute;
  right: 0;
  bottom: -22px;
  font-family: "NotoSansJP";
}
.text-input-big-border .error-without-right {
  right: unset;
  bottom: -25px;
}
.text-input-big-border .error-left-align {
  left: 0;
  overflow: visible;
}
.text-input-big-border input,
.text-input-big-border textarea {
  caret-color: #24b8c0;
  height: 100%;
  width: 100%;
  z-index: 1;
  padding: 0 16px;
  font-family: "Europa";
  font-size: 14px;
}
.text-input-big-border input::placeholder,
.text-input-big-border textarea::placeholder {
  font-size: 14px;
  color: #9a9a9a;
  vertical-align: middle;
  font-family: inherit;
}
.text-input-big-border input:focus::placeholder,
.text-input-big-border textarea:focus::placeholder {
  color: transparent;
}
.text-input-big-border .form-control-left-icon ~ input,
.text-input-big-border .form-control-left-icon ~ textarea {
  padding-left: 40px;
}
.text-input-big-border .form-control-right-icon ~ input,
.text-input-big-border .form-control-right-icon ~ textarea {
  padding-right: 40px;
}

.text-input-lesser-opacity {
  position: relative;
  min-width: 100px;
  height: 40px;
  opacity: 0.6;
}
.text-input-lesser-opacity:focus-within {
  opacity: 1;
}
.text-input-lesser-opacity:focus-within .text-box {
  background-color: #24b8c0;
}
.text-input-lesser-opacity:hover {
  opacity: 1;
}
.text-input-lesser-opacity:hover .text-box:not(.disabled) {
  background-color: #24b8c0;
}
.text-input-lesser-opacity:hover path {
  opacity: 1;
}
.text-input-lesser-opacity:has(input:valid) {
  opacity: 1;
}
.text-input-lesser-opacity .text-box {
  position: absolute;
  top: 0px;
  opacity: 0.8;
  width: 100%;
  height: 100%;
  background-color: rgba(242, 122, 67, 0.8);
  clip-path: polygon(calc(100% - 12px) 100%, 100% calc(100% - 12px), 100% 12px, calc(100% - 12px) 0%, 12px 0%, 0% 12px, 0% calc(100% - 12px), 12px 100%);
}
.text-input-lesser-opacity .text-box::after {
  content: "";
  position: absolute;
  background-color: #000000;
  clip-path: polygon(calc(100% - 12px) 100%, 100% calc(100% - 12px), 100% 12px, calc(100% - 12px) 0%, 12px 0%, 0% 12px, 0% calc(100% - 12px), 12px 100%);
  inset: 1.5px;
}
.text-input-lesser-opacity .error-border {
  background-color: rgba(255, 0, 0, 0.4);
}
.text-input-lesser-opacity .inactive {
  background-color: rgba(122, 115, 115, 0.5);
}
.text-input-lesser-opacity .input {
  position: relative;
  color: white;
}
.text-input-lesser-opacity .textarea {
  position: absolute;
  color: white;
  left: 0;
  resize: none;
  padding-block: 10px;
}
.text-input-lesser-opacity .text-form-control-value {
  box-sizing: border-box;
  color: #dcc97e;
  font-family: "ethnocentric";
  font-size: 20px;
  text-align: center;
  padding: 0px 20px;
}
.text-input-lesser-opacity .text-form-control {
  box-sizing: border-box;
  font-size: 20px;
  padding: 0px 20px;
}
.text-input-lesser-opacity .form-control-right-icon {
  position: absolute;
  right: 12px;
  top: 5px;
}
.text-input-lesser-opacity .form-control-left-icon {
  position: absolute;
  left: 15px;
  top: 7px;
}
.text-input-lesser-opacity .text-form-control-border {
  background-color: #020202;
}
.text-input-lesser-opacity .error-left-align, .text-input-lesser-opacity .error-without-right, .text-input-lesser-opacity .error {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: #ff0000;
  position: absolute;
  right: 0;
  bottom: -22px;
  font-family: "NotoSansJP";
}
.text-input-lesser-opacity .error-without-right {
  right: unset;
  bottom: -25px;
}
.text-input-lesser-opacity .error-left-align {
  left: 0;
  overflow: visible;
}
.text-input-lesser-opacity input,
.text-input-lesser-opacity textarea {
  caret-color: #24b8c0;
  height: 100%;
  width: 100%;
  z-index: 1;
  padding: 0 16px;
  font-family: "Europa";
  font-size: 14px;
}
.text-input-lesser-opacity input::placeholder,
.text-input-lesser-opacity textarea::placeholder {
  font-size: 14px;
  color: #9a9a9a;
  vertical-align: middle;
  font-family: inherit;
}
.text-input-lesser-opacity input:focus::placeholder,
.text-input-lesser-opacity textarea:focus::placeholder {
  color: transparent;
}
.text-input-lesser-opacity .form-control-left-icon ~ input,
.text-input-lesser-opacity .form-control-left-icon ~ textarea {
  padding-left: 40px;
}
.text-input-lesser-opacity .form-control-right-icon ~ input,
.text-input-lesser-opacity .form-control-right-icon ~ textarea {
  padding-right: 40px;
}
.text-input-lesser-opacity input {
  caret-color: rgba(242, 122, 67, 0.6);
}

.text-input-white-caret {
  position: relative;
  min-width: 100px;
  height: 40px;
}
.text-input-white-caret:focus-within {
  opacity: 1;
}
.text-input-white-caret:focus-within .text-box {
  background-color: #24b8c0;
}
.text-input-white-caret:hover {
  opacity: 1;
}
.text-input-white-caret:hover .text-box:not(.disabled) {
  background-color: #24b8c0;
}
.text-input-white-caret:hover path {
  opacity: 1;
}
.text-input-white-caret:has(input:valid) {
  opacity: 1;
}
.text-input-white-caret .text-box {
  position: absolute;
  top: 0px;
  opacity: 0.8;
  width: 100%;
  height: 100%;
  background-color: rgba(242, 122, 67, 0.8);
  clip-path: polygon(calc(100% - 12px) 100%, 100% calc(100% - 12px), 100% 12px, calc(100% - 12px) 0%, 12px 0%, 0% 12px, 0% calc(100% - 12px), 12px 100%);
}
.text-input-white-caret .text-box::after {
  content: "";
  position: absolute;
  background-color: #000000;
  clip-path: polygon(calc(100% - 12px) 100%, 100% calc(100% - 12px), 100% 12px, calc(100% - 12px) 0%, 12px 0%, 0% 12px, 0% calc(100% - 12px), 12px 100%);
  inset: 1.5px;
}
.text-input-white-caret .error-border {
  background-color: rgba(255, 0, 0, 0.4);
}
.text-input-white-caret .inactive {
  background-color: rgba(122, 115, 115, 0.5);
}
.text-input-white-caret .input {
  position: relative;
  color: white;
}
.text-input-white-caret .textarea {
  position: absolute;
  color: white;
  left: 0;
  resize: none;
  padding-block: 10px;
}
.text-input-white-caret .text-form-control-value {
  box-sizing: border-box;
  color: #dcc97e;
  font-family: "ethnocentric";
  font-size: 20px;
  text-align: center;
  padding: 0px 20px;
}
.text-input-white-caret .text-form-control {
  box-sizing: border-box;
  font-size: 20px;
  padding: 0px 20px;
}
.text-input-white-caret .form-control-right-icon {
  position: absolute;
  right: 12px;
  top: 5px;
}
.text-input-white-caret .form-control-left-icon {
  position: absolute;
  left: 15px;
  top: 7px;
}
.text-input-white-caret .text-form-control-border {
  background-color: #020202;
}
.text-input-white-caret .error-left-align, .text-input-white-caret .error-without-right, .text-input-white-caret .error {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: #ff0000;
  position: absolute;
  right: 0;
  bottom: -22px;
  font-family: "NotoSansJP";
}
.text-input-white-caret .error-without-right {
  right: unset;
  bottom: -25px;
}
.text-input-white-caret .error-left-align {
  left: 0;
  overflow: visible;
}
.text-input-white-caret input,
.text-input-white-caret textarea {
  caret-color: #24b8c0;
  height: 100%;
  width: 100%;
  z-index: 1;
  padding: 0 16px;
  font-family: "Europa";
  font-size: 14px;
}
.text-input-white-caret input::placeholder,
.text-input-white-caret textarea::placeholder {
  font-size: 14px;
  color: #9a9a9a;
  vertical-align: middle;
  font-family: inherit;
}
.text-input-white-caret input:focus::placeholder,
.text-input-white-caret textarea:focus::placeholder {
  color: transparent;
}
.text-input-white-caret .form-control-left-icon ~ input,
.text-input-white-caret .form-control-left-icon ~ textarea {
  padding-left: 40px;
}
.text-input-white-caret .form-control-right-icon ~ input,
.text-input-white-caret .form-control-right-icon ~ textarea {
  padding-right: 40px;
}
.text-input-white-caret input {
  caret-color: white;
}

.button-input {
  position: relative;
  min-width: 100px;
  height: 40px;
}
.button-input:focus-within {
  opacity: 1;
}
.button-input:focus-within .text-box {
  background-color: #24b8c0;
}
.button-input:hover {
  opacity: 1;
}
.button-input:hover .text-box:not(.disabled) {
  background-color: #24b8c0;
}
.button-input:hover path {
  opacity: 1;
}
.button-input:has(input:valid) {
  opacity: 1;
}
.button-input .text-box {
  position: absolute;
  top: 0px;
  opacity: 0.8;
  width: 100%;
  height: 100%;
  background-color: rgba(242, 122, 67, 0.8);
  clip-path: polygon(calc(100% - 12px) 100%, 100% calc(100% - 12px), 100% 12px, calc(100% - 12px) 0%, 12px 0%, 0% 12px, 0% calc(100% - 12px), 12px 100%);
}
.button-input .text-box::after {
  content: "";
  position: absolute;
  background-color: #000000;
  clip-path: polygon(calc(100% - 12px) 100%, 100% calc(100% - 12px), 100% 12px, calc(100% - 12px) 0%, 12px 0%, 0% 12px, 0% calc(100% - 12px), 12px 100%);
  inset: 1.5px;
}
.button-input .error-border {
  background-color: rgba(255, 0, 0, 0.4);
}
.button-input .inactive {
  background-color: rgba(122, 115, 115, 0.5);
}
.button-input .input {
  position: relative;
  color: white;
}
.button-input .textarea {
  position: absolute;
  color: white;
  left: 0;
  resize: none;
  padding-block: 10px;
}
.button-input .text-form-control-value {
  box-sizing: border-box;
  color: #dcc97e;
  font-family: "ethnocentric";
  font-size: 20px;
  text-align: center;
  padding: 0px 20px;
}
.button-input .text-form-control {
  box-sizing: border-box;
  font-size: 20px;
  padding: 0px 20px;
}
.button-input .form-control-right-icon {
  position: absolute;
  right: 12px;
  top: 5px;
}
.button-input .form-control-left-icon {
  position: absolute;
  left: 15px;
  top: 7px;
}
.button-input .text-form-control-border {
  background-color: #020202;
}
.button-input .error-left-align, .button-input .error-without-right, .button-input .error {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: #ff0000;
  position: absolute;
  right: 0;
  bottom: -22px;
  font-family: "NotoSansJP";
}
.button-input .error-without-right {
  right: unset;
  bottom: -25px;
}
.button-input .error-left-align {
  left: 0;
  overflow: visible;
}
.button-input input,
.button-input textarea {
  caret-color: #24b8c0;
  height: 100%;
  width: 100%;
  z-index: 1;
  padding: 0 16px;
  font-family: "Europa";
  font-size: 14px;
}
.button-input input::placeholder,
.button-input textarea::placeholder {
  font-size: 14px;
  color: #9a9a9a;
  vertical-align: middle;
  font-family: inherit;
}
.button-input input:focus::placeholder,
.button-input textarea:focus::placeholder {
  color: transparent;
}
.button-input .form-control-left-icon ~ input,
.button-input .form-control-left-icon ~ textarea {
  padding-left: 40px;
}
.button-input .form-control-right-icon ~ input,
.button-input .form-control-right-icon ~ textarea {
  padding-right: 40px;
}
.button-input:focus-within {
  opacity: 1;
}
.button-input:focus-within .text-box {
  background-color: rgba(122, 115, 115, 0.5);
}
.button-input:hover {
  opacity: 1;
}
.button-input:hover .text-box:not(.disabled) {
  background-color: rgba(122, 115, 115, 0.5);
}
.button-input:hover path {
  opacity: 1;
}
.button-input:active {
  opacity: 1;
}
.button-input:active .text-box:not(.disabled) {
  background-color: rgba(168, 161, 161, 0.5);
}
.button-input input[data-exist="0"] {
  font-family: "NotoSansJP-light" !important;
}
.button-input input[data-exist="1"] {
  font-family: "ethno-light" !important;
  font-weight: 300;
}

.login-input {
  position: relative;
  min-width: 100px;
  min-height: 30px;
  opacity: 0.6;
}
.login-input:focus-within {
  opacity: 1;
}
.login-input:has(input:valid) {
  opacity: 1;
}
.login-input .left-wrapper {
  position: absolute;
  width: 25px;
  height: 55px;
  clip-path: polygon(19.5px 100%, 3.5px 75%, 3.5px 25%, 19.5px 0%, 16px 0%, 0% 22%, 0% 78%, 16px 100%);
  background-color: #f27a43;
  margin-left: -6px;
}
.login-input .text-box {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(242, 122, 67, 0.5);
  clip-path: polygon(calc(100% - 16px) 100%, 100% 75%, 100% 25%, calc(100% - 16px) 0%, 16px 0%, 0% 25%, 0% 75%, 16px 100%);
}
.login-input .text-box::after {
  content: "";
  position: absolute;
  background-color: #000000;
  clip-path: polygon(calc(100% - 16px) 100%, 100% 75%, 100% 25%, calc(100% - 16px) 0%, 16px 0%, 0% 25%, 0% 75%, 16px 100%);
  inset: 1px;
}
.login-input .right-wrapper {
  position: absolute;
  width: 25px;
  height: 55px;
  clip-path: polygon(19.5px 100%, 3.5px 75%, 3.5px 25%, 19.5px 0%, 16px 0%, 0% 22%, 0% 78%, 16px 100%);
  background-color: #f27a43;
  margin-left: 95%;
  transform: scaleX(-1);
}
.login-input .input {
  position: absolute;
  color: white;
}
.login-input input {
  height: 100%;
  width: 100%;
  z-index: 1;
  padding-left: 50px;
}
.login-input input::placeholder {
  letter-spacing: 0px;
  color: #9a9a9a;
  font-size: 17px;
}

.icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: 20%;
  padding: 10px;
  position: absolute;
  box-sizing: border-box;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  z-index: 1;
}

.icon-lock {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: 20%;
  padding: 13px;
  position: absolute;
  box-sizing: border-box;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  z-index: 1;
}

.input-row {
  position: relative;
}

.search-input {
  opacity: 0.7;
}
.search-input .search-box {
  clip-path: polygon(calc(100% - 10px) 100%, 100% calc(100% - 10px), 100% 10px, calc(100% - 10px) 0%, 0% 0%, 40px 100%);
  background-color: rgba(242, 122, 67, 0.5);
  min-width: 100px;
  min-height: 30px;
  width: 100%;
  height: 100%;
  position: relative;
  padding-left: 50px;
}
.search-input .search-box .input {
  position: static;
}
.search-input .search-box .search-icon {
  z-index: 1;
  margin-right: 10px;
}
.search-input:focus-within {
  opacity: 1;
}
.search-input:focus-within .search-box {
  opacity: 1;
  background-color: #24b8c0;
  background-color: #24b8c0;
}
.search-input:has(input:valid) {
  opacity: 1;
}
.search-input .search-box::after {
  content: "";
  position: absolute;
  inset: 2px;
  clip-path: polygon(calc(100% - 10px) 100%, 100% calc(100% - 10px), 100% 10px, calc(100% - 10px) 0%, 3px 0%, 40px 100%);
  background-color: #000000;
}
.search-input .input {
  height: 95%;
  position: absolute;
  color: white;
  caret-color: #24b8c0;
}
.search-input .input::placeholder {
  color: white;
}
.search-input input {
  all: unset;
  height: 100%;
  width: 100%;
  padding-left: 0px;
  z-index: 1;
}

/** End Input Classes */
/** Button Classes */
.selected-button-menu, .button-menu {
  position: relative;
  min-width: 100px;
  min-height: 20px;
  background-color: transparent;
  border: none;
  cursor: pointer;
}
.selected-button-menu:disabled, .button-menu:disabled {
  cursor: not-allowed;
}
.selected-button-menu .left-wrapper, .button-menu .left-wrapper {
  position: absolute;
  clip-path: polygon(16px 100%, 4px 75%, 4px 25%, 16px 0%, 12px 0%, 0% 22%, 0% 78%, 12px 100%);
  background-color: #e45a1b;
  inset: 1px;
}
.selected-button-menu .right-wrapper, .button-menu .right-wrapper {
  position: absolute;
  clip-path: polygon(16px 100%, 4px 75%, 4px 25%, 16px 0%, 12px 0%, 0% 22%, 0% 78%, 12px 100%);
  background-color: #e45a1b;
  inset: 1px;
  transform: scaleX(-1);
}
.selected-button-menu .inner, .button-menu .inner {
  position: absolute;
  background-color: linear-gradient(270deg, #ed541d 0%, #f4901b 100%);
  clip-path: polygon(calc(100% - 12px) 100%, 100% 75%, 100% 25%, calc(100% - 12px) 0%, 12px 0%, 0% 25%, 0% 75%, 12px 100%);
  inset: 1px;
  margin-left: 7px;
  margin-right: 7px;
}
.selected-button-menu .inner::after, .button-menu .inner::after {
  content: "";
  position: absolute;
  background-color: #000000;
  clip-path: polygon(calc(100% - 12px) 100%, 100% 75%, 100% 25%, calc(100% - 12px) 0%, 12px 0%, 0% 25%, 0% 75%, 12px 100%);
  inset: 1px;
}
.selected-button-menu .text, .button-menu .text {
  color: #ffffff;
  font-size: 18px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-family: "851ゴチカクット";
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.selected-button-menu:hover path, .button-menu:hover path {
  fill: #000000;
}
.selected-button-menu .left-icon, .button-menu .left-icon {
  position: absolute;
  left: 20px;
  top: 3px;
}
.selected-button-menu .box-button, .button-menu .box-button {
  color: #ffffff;
  font-size: 18px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-family: "Ethno";
  width: 100%;
  text-align: center;
}

.button-primary {
  position: relative;
  min-width: 100px;
  min-height: 20px;
  background-color: transparent;
  border: none;
  cursor: pointer;
}
.button-primary:disabled {
  cursor: not-allowed;
}
.button-primary .left-wrapper {
  position: absolute;
  clip-path: polygon(16px 100%, 4px 75%, 4px 25%, 16px 0%, 12px 0%, 0% 22%, 0% 78%, 12px 100%);
  background-color: #e45a1b;
  inset: 1px;
}
.button-primary .right-wrapper {
  position: absolute;
  clip-path: polygon(16px 100%, 4px 75%, 4px 25%, 16px 0%, 12px 0%, 0% 22%, 0% 78%, 12px 100%);
  background-color: #e45a1b;
  inset: 1px;
  transform: scaleX(-1);
}
.button-primary .inner {
  position: absolute;
  background-color: linear-gradient(270deg, #ed541d 0%, #f4901b 100%);
  clip-path: polygon(calc(100% - 12px) 100%, 100% 75%, 100% 25%, calc(100% - 12px) 0%, 12px 0%, 0% 25%, 0% 75%, 12px 100%);
  inset: 1px;
  margin-left: 7px;
  margin-right: 7px;
}
.button-primary .inner::after {
  content: "";
  position: absolute;
  background-color: #000000;
  clip-path: polygon(calc(100% - 12px) 100%, 100% 75%, 100% 25%, calc(100% - 12px) 0%, 12px 0%, 0% 25%, 0% 75%, 12px 100%);
  inset: 1px;
}
.button-primary .text {
  color: #ffffff;
  font-size: 18px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-family: "851ゴチカクット";
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.button-primary:hover path {
  fill: #000000;
}
.button-primary .left-icon {
  position: absolute;
  left: 20px;
  top: 3px;
}
.button-primary .box-button {
  color: #ffffff;
  font-size: 18px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-family: "Ethno";
  width: 100%;
  text-align: center;
}
.button-primary .inner {
  background-color: rgba(242, 122, 67, 0.5);
}
.button-primary:hover .inner {
  opacity: 1;
}
.button-primary:hover .inner::after {
  background: rgb(245, 151, 27);
  background: linear-gradient(90deg, rgb(245, 151, 27) 0%, rgb(236, 77, 29) 100%);
}
.button-primary:hover .text {
  color: #000000;
}
.button-primary:hover .box-button {
  color: #000000;
}

.button-cancel {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 15px;
  cursor: pointer;
}
.button-cancel .text {
  color: #ffffff;
  font-size: 16px;
  font-family: "851ゴチカクット";
}
.button-cancel:hover .text {
  color: #f27a43;
}

.button-grey {
  position: relative;
  min-width: 100px;
  min-height: 20px;
  background-color: transparent;
  border: none;
  cursor: pointer;
}
.button-grey:disabled {
  cursor: not-allowed;
}
.button-grey .left-wrapper {
  position: absolute;
  clip-path: polygon(16px 100%, 4px 75%, 4px 25%, 16px 0%, 12px 0%, 0% 22%, 0% 78%, 12px 100%);
  background-color: #e45a1b;
  inset: 1px;
}
.button-grey .right-wrapper {
  position: absolute;
  clip-path: polygon(16px 100%, 4px 75%, 4px 25%, 16px 0%, 12px 0%, 0% 22%, 0% 78%, 12px 100%);
  background-color: #e45a1b;
  inset: 1px;
  transform: scaleX(-1);
}
.button-grey .inner {
  position: absolute;
  background-color: linear-gradient(270deg, #ed541d 0%, #f4901b 100%);
  clip-path: polygon(calc(100% - 12px) 100%, 100% 75%, 100% 25%, calc(100% - 12px) 0%, 12px 0%, 0% 25%, 0% 75%, 12px 100%);
  inset: 1px;
  margin-left: 7px;
  margin-right: 7px;
}
.button-grey .inner::after {
  content: "";
  position: absolute;
  background-color: #000000;
  clip-path: polygon(calc(100% - 12px) 100%, 100% 75%, 100% 25%, calc(100% - 12px) 0%, 12px 0%, 0% 25%, 0% 75%, 12px 100%);
  inset: 1px;
}
.button-grey .text {
  color: #ffffff;
  font-size: 18px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-family: "851ゴチカクット";
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.button-grey:hover path {
  fill: #000000;
}
.button-grey .left-icon {
  position: absolute;
  left: 20px;
  top: 3px;
}
.button-grey .box-button {
  color: #ffffff;
  font-size: 18px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-family: "Ethno";
  width: 100%;
  text-align: center;
}
.button-grey .inner {
  background-color: rgba(122, 115, 115, 0.5);
}
.button-grey .left-wrapper {
  background-color: #7a7373;
}
.button-grey .right-wrapper {
  background-color: #7a7373;
}
.button-grey .text {
  color: #7a7373;
}
.button-grey:hover .inner {
  opacity: 1;
}
.button-grey:hover .inner::after {
  background-color: #f27a43;
}
.button-grey:hover .text {
  color: #000000;
}
.button-grey:hover .box-button {
  color: #000000;
}

.button-dialog {
  position: relative;
  min-width: 100px;
  min-height: 20px;
  background-color: transparent;
  border: none;
  cursor: pointer;
}
.button-dialog:disabled {
  cursor: not-allowed;
}
.button-dialog .left-wrapper {
  position: absolute;
  clip-path: polygon(16px 100%, 4px 75%, 4px 25%, 16px 0%, 12px 0%, 0% 22%, 0% 78%, 12px 100%);
  background-color: #e45a1b;
  inset: 1px;
}
.button-dialog .right-wrapper {
  position: absolute;
  clip-path: polygon(16px 100%, 4px 75%, 4px 25%, 16px 0%, 12px 0%, 0% 22%, 0% 78%, 12px 100%);
  background-color: #e45a1b;
  inset: 1px;
  transform: scaleX(-1);
}
.button-dialog .inner {
  position: absolute;
  background-color: linear-gradient(270deg, #ed541d 0%, #f4901b 100%);
  clip-path: polygon(calc(100% - 12px) 100%, 100% 75%, 100% 25%, calc(100% - 12px) 0%, 12px 0%, 0% 25%, 0% 75%, 12px 100%);
  inset: 1px;
  margin-left: 7px;
  margin-right: 7px;
}
.button-dialog .inner::after {
  content: "";
  position: absolute;
  background-color: #000000;
  clip-path: polygon(calc(100% - 12px) 100%, 100% 75%, 100% 25%, calc(100% - 12px) 0%, 12px 0%, 0% 25%, 0% 75%, 12px 100%);
  inset: 1px;
}
.button-dialog .text {
  color: #ffffff;
  font-size: 15px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-family: "ethno-light";
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.button-dialog:hover path {
  fill: #000000;
}
.button-dialog .left-icon {
  position: absolute;
  left: 20px;
  top: 3px;
}
.button-dialog .box-button {
  color: #ffffff;
  font-size: 15px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-family: "Ethno";
  width: 100%;
  text-align: center;
}
.button-dialog .text {
  margin-top: -3px;
}
.button-dialog .inner {
  background-color: rgba(242, 122, 67, 0.3);
}
.button-dialog:hover .inner {
  opacity: 1;
}
.button-dialog:hover .inner::after {
  background-color: #f27a43;
  background: rgb(245, 151, 27);
  background: linear-gradient(90deg, rgb(245, 151, 27) 0%, rgb(236, 77, 29) 100%);
}
.button-dialog:hover .box-button {
  color: #000000;
}

.selected-button-menu .left-wrapper, .button-menu:hover .left-wrapper {
  background-color: #e45a1b;
}
.selected-button-menu .inner, .button-menu:hover .inner {
  background-color: #e45a1b;
}
.selected-button-menu .inner::after, .button-menu:hover .inner::after {
  background: rgb(245, 151, 27);
  background: linear-gradient(90deg, rgb(245, 151, 27) 0%, rgb(236, 77, 29) 100%);
}
.selected-button-menu .right-wrapper, .button-menu:hover .right-wrapper {
  background-color: #e45a1b;
}
.selected-button-menu .text, .button-menu:hover .text {
  color: #ffffff;
}
.selected-button-menu .box-button, .button-menu:hover .box-button {
  color: linear-gradient(270deg, #ed541d 0%, #f4901b 100%);
}

.button-menu .text {
  font-size: inherit;
}
.button-menu .inner {
  box-sizing: content-box;
  background-color: rgba(242, 122, 67, 0.3);
}
.button-plus {
  background-color: transparent;
  border: 0;
  position: relative;
}
.button-plus::after {
  background-color: #000000;
  content: "追加";
  width: max-content;
  padding: 2px 5px;
  border: 1px solid #f27a43;
  position: absolute;
  color: #ffffff;
  font-size: 11px;
  text-align: center;
  left: -30px;
  bottom: 20px;
  z-index: 0;
  opacity: 0;
  transition: all 0.5s ease-in-out;
}
.button-plus:hover path {
  stroke: #f27a43;
}
.button-plus:hover::after {
  z-index: 2;
  opacity: 1;
}

.in-de-btn {
  background-color: transparent;
  border: 0;
  margin: 0;
  padding: 0;
}

/** select persona button **/
.button-select-persona {
  min-width: 196px;
  width: 296px;
  height: 40px;
  position: relative;
}
.button-select-persona::before {
  content: "";
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(122, 115, 115, 0.5);
  clip-path: polygon(calc(100% - 12px) 100%, 100% calc(100% - 12px), 100% 12px, calc(100% - 12px) 0%, 12px 0%, 0% 12px, 0% calc(100% - 12px), 12px 100%);
}
.button-select-persona:disabled {
  background-color: red;
}
.button-select-persona:not(.disabled):hover:before, .button-select-persona:not(.disabled):focus::before {
  background-color: #24b8c0;
}
.button-select-persona button {
  position: absolute;
  border: none;
  background-color: transparent;
  padding: 10px 16px;
  text-align: center;
  width: 100%;
  height: 100%;
  z-index: 1;
}
.button-select-persona::after {
  content: "";
  position: absolute;
  clip-path: polygon(calc(100% - 12px) 100%, 100% calc(100% - 12px), 100% 12px, calc(100% - 12px) 0%, 12px 0%, 0% 12px, 0% calc(100% - 12px), 12px 100%);
  inset: 1.5px 1px 1.5px 2px;
  background-color: #000000;
}

/** end select persona button **/
/** End Button Classes */
.message-box {
  position: relative;
}
.message-box .container {
  clip-path: polygon(calc(5% + 2px) 3px, calc(95% - 2px) 3px, calc(100% - 4px) calc(10% + 2px), calc(100% - 4px) calc(90% - 2px), calc(95% - 3px) calc(100% - 3px), calc(5% + 2px) calc(100% - 3px), 3px calc(90% - 2px), 3px calc(10% + 2px));
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: black;
  width: 100%;
  height: 100%;
}
.message-box .outside-box-top {
  clip-path: polygon(0px 40%, 0px 10%, 5% 0%, 95% 0%, 100% 10%, 100% 40%, calc(100% - 3px) 40%, calc(100% - 3px) calc(10% + 2px), calc(95% - 2px) 3px, calc(5% + 2px) 3px, 3px calc(10% + 2px), calc(0% + 3px) 40%);
  background-color: #f27a43;
  height: 100%;
  width: 100%;
  opacity: 0.7;
  position: absolute;
}
.message-box .outside-box-bottom {
  clip-path: polygon(0px 40%, 0px 10%, 5% 0%, 95% 0%, 100% 10%, 100% 40%, calc(100% - 3px) 40%, calc(100% - 3px) calc(10% + 2px), calc(95% - 2px) 3px, calc(5% + 2px) 3px, 3px calc(10% + 2px), calc(0% + 3px) 40%);
  background-color: #f27a43;
  height: 100%;
  width: 100%;
  opacity: 0.7;
  position: absolute;
  top: 0;
  left: 0;
  transform: rotateX(180deg);
}
.message-box .middle-choose-group-right-box {
  content: "";
  position: absolute;
  display: block;
  width: 50%;
  height: 27%;
  z-index: 0;
  top: 33.5%;
  right: 0;
  background-color: #000000;
}
.message-box .middle-choose-group-left-box {
  content: "";
  position: absolute;
  display: block;
  width: 50%;
  height: 15%;
  z-index: 0;
  top: 46%;
  left: 0;
  background-color: #000000;
}
.message-box .middle-box {
  content: "";
  position: absolute;
  display: block;
  width: calc(100% + 2px);
  margin-left: -0.6px;
  height: 20%;
  z-index: 0;
  top: 38%;
  left: 0;
  right: 0;
}
.message-box .inside-box {
  clip-path: polygon(24px 0, calc(100% - 24px) 0, 100% 24px, 100% calc(100% - 24px), calc(100% - 24px) 100%, 24px 100%, 0 calc(100% - 24px), 0 24px);
  content: "";
  position: absolute;
  display: block;
  inset: 3px;
}
.message-box .save-box .body .container-box {
  width: 100%;
  height: 100%;
}
.message-box .save-box .body .button-row {
  width: 100%;
  padding: 0;
  justify-content: center;
  margin-top: 70px;
}
.message-box .save-box .body .con-button {
  width: 182px;
  height: 40px;
}
.message-box .save-box .path {
  margin-top: 155px;
}
.message-box .side-path {
  clip-path: polygon(0% 2px, 0% 0%, calc(60% + 2px) 25px, calc(60% + 2px) 100%, 60% 100%, 60% 27px);
  background-color: #f27a43;
  height: 40%;
  width: 38px;
  opacity: 0.7;
}

.group-select-message-box {
  position: relative;
}
.group-select-message-box .container {
  clip-path: polygon(calc(5% + 2px) 3px, calc(95% - 2px) 3px, calc(100% - 4px) calc(10% + 2px), calc(100% - 4px) calc(90% - 2px), calc(95% - 3px) calc(100% - 3px), calc(5% + 2px) calc(100% - 3px), 3px calc(90% - 2px), 3px calc(10% + 2px));
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: black;
  width: 100%;
  height: 100%;
}
.group-select-message-box .outside-box-top {
  clip-path: polygon(0px 40%, 0px 10%, 5% 0%, 95% 0%, 100% 10%, 100% 40%, calc(100% - 3px) 40%, calc(100% - 3px) calc(10% + 2px), calc(95% - 2px) 3px, calc(5% + 2px) 3px, 3px calc(10% + 2px), calc(0% + 3px) 40%);
  background-color: #f27a43;
  height: 100%;
  width: 100%;
  opacity: 0.7;
  position: absolute;
}
.group-select-message-box .outside-box-bottom {
  clip-path: polygon(0px 40%, 0px 10%, 5% 0%, 95% 0%, 100% 10%, 100% 40%, calc(100% - 3px) 40%, calc(100% - 3px) calc(10% + 2px), calc(95% - 2px) 3px, calc(5% + 2px) 3px, 3px calc(10% + 2px), calc(0% + 3px) 40%);
  background-color: #f27a43;
  height: 100%;
  width: 100%;
  opacity: 0.7;
  position: absolute;
  top: 0;
  left: 0;
  transform: rotateX(180deg);
}
.group-select-message-box .middle-choose-group-right-box {
  content: "";
  position: absolute;
  display: block;
  width: 50%;
  height: 27%;
  z-index: 0;
  top: 33.5%;
  right: 0;
  background-color: #000000;
}
.group-select-message-box .middle-choose-group-left-box {
  content: "";
  position: absolute;
  display: block;
  width: 50%;
  height: 15%;
  z-index: 0;
  top: 46%;
  left: 0;
  background-color: #000000;
}
.group-select-message-box .middle-box {
  content: "";
  position: absolute;
  display: block;
  width: calc(100% + 2px);
  margin-left: -0.6px;
  height: 20%;
  z-index: 0;
  top: 38%;
  left: 0;
  right: 0;
}
.group-select-message-box .inside-box {
  clip-path: polygon(35px 0, calc(100% - 35px) 0, 100% 35px, 100% calc(100% - 35px), calc(100% - 35px) 100%, 35px 100%, 0 calc(100% - 35px), 0 35px);
  content: "";
  position: absolute;
  display: block;
  inset: 3px;
}
.group-select-message-box .save-box .body .container-box {
  width: 100%;
  height: 100%;
}
.group-select-message-box .save-box .body .button-row {
  width: 100%;
  padding: 0;
  justify-content: center;
  margin-top: 70px;
}
.group-select-message-box .save-box .body .con-button {
  width: 182px;
  height: 40px;
}
.group-select-message-box .save-box .path {
  margin-top: 155px;
}
.group-select-message-box .side-path {
  clip-path: polygon(0% 2px, 0% 0%, calc(60% + 2px) 25px, calc(60% + 2px) 100%, 60% 100%, 60% 27px);
  background-color: #f27a43;
  height: 40%;
  width: 50px;
  opacity: 0.7;
}

.button-text {
  color: black;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}

.button-text:hover {
  color: #000000;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}

.link {
  text-decoration: none;
}

.error-border {
  background-color: rgba(255, 0, 0, 0.4) !important;
}

.img-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.persona-img-container {
  width: 284px;
  height: 325px;
}

.drawchain-thumbnail-container {
  width: 349.95px;
  height: 232.68px;
  border: 1px solid rgba(122, 115, 115, 0.5607843137);
}

.drawchain-v-thumbnail-container {
  width: 155px;
  height: 232.68px;
  border: 1px solid rgba(122, 115, 115, 0.5607843137);
}

.marketplace-img-container {
  width: 120px;
  height: 40px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.marketplace-img-container img {
  width: 64px;
  height: 34px;
  object-fit: contain;
}
.marketplace-img-container .icon-container {
  position: absolute;
  right: -20px;
  bottom: -14px;
  background-color: #3d3939;
  width: 28px;
  height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  border: 0;
  z-index: 1;
}
.marketplace-img-container .icon-container::after {
  background-color: #000000;
  content: "画像設定";
  width: max-content;
  padding: 2px 5px;
  border: 1px solid #f27a43;
  position: absolute;
  color: #ffffff;
  font-size: 11px;
  text-align: center;
  left: -20px;
  bottom: 30px;
  z-index: 1;
  opacity: 1;
  transition: all 0.5s ease-in-out;
}
.marketplace-img-container .icon-container:hover path {
  opacity: 1;
}
.marketplace-img-container .icon-container:hover::after {
  z-index: 2;
  opacity: 1;
}

.image-box {
  z-index: 0;
  min-width: 100px;
  min-height: 20px;
  position: relative;
  background-color: rgba(242, 122, 67, 0.5);
  clip-path: polygon(calc(100% - 10px) 100%, 100% 97.5%, 100% 2.5%, calc(100% - 10px) 0%, 10px 0%, 0% 2.5%, 0% 97.5%, 10px 100%);
}
.image-box .dark-bg {
  position: absolute;
  background-color: #000000;
  clip-path: polygon(calc(100% - 10px) 100%, 100% 97.5%, 100% 2.5%, calc(100% - 10px) 0%, 10px 0%, 0% 2.5%, 0% 97.5%, 10px 100%);
  inset: 1px;
}
.image-box .upload-image {
  position: absolute;
  clip-path: polygon(calc(100% - 10px) 100%, 100% 97.5%, 100% 2.5%, calc(100% - 10px) 0%, 10px 0%, 0% 2.5%, 0% 97.5%, 10px 100%);
  inset: 1px;
  z-index: 2;
}

.cust-modal .overlay {
  width: 100vw;
  height: 100vh;
  inset: 0;
  position: fixed;
  background-color: rgba(1, 1, 1, 0.852);
  z-index: 10;
  transition: all 0.5s ease-in-out;
  opacity: 0;
  visibility: hidden;
}
.cust-modal .modal-content {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  transition: all 0.5s ease-in-out;
  opacity: 0;
  visibility: hidden;
}

.show-modal .overlay,
.show-modal .modal-content {
  opacity: 1;
  visibility: visible;
}

.loading-text {
  animation: loading forwards;
  animation-duration: 10s;
  animation-fill-mode: forwards;
}

@keyframes loading {
  0% {
    opacity: 1;
  }
  20% {
    opacity: 1;
  }
  50% {
    opacity: 0.2;
  }
  100% {
    opacity: 0;
  }
}
.loading-complete-text {
  animation: loading_complete forwards;
  animation-duration: 10s;
  animation-fill-mode: forwards;
}

@keyframes loading_complete {
  0% {
    opacity: 0;
  }
  20% {
    opacity: 0;
  }
  50% {
    opacity: 0.5;
  }
  75% {
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
}
.app-text::after {
  content: "";
  animation: spin forwards;
  animation-duration: 10s;
  position: relative;
  animation-fill-mode: forwards;
}

@keyframes spin {
  0% {
    content: "ローディング. . . .";
    opacity: 1;
  }
  20% {
    content: "ローディング. . . .";
    opacity: 0.5;
  }
  40% {
    content: "ローディング. . . .";
    opacity: 0.1;
  }
  50% {
    content: "完了";
    opacity: 0.1;
  }
  70% {
    content: "完了";
    opacity: 0.7;
  }
  100% {
    content: "完了";
    opacity: 1;
  }
}
.re-text::after {
  content: "";
  animation: animate forwards;
  animation-duration: 10s;
  position: relative;
  animation-fill-mode: forwards;
}

@keyframes animate {
  0% {
    content: "発行中. . . . .";
    opacity: 1;
  }
  20% {
    content: "発行中. . . . .";
    opacity: 0.5;
  }
  40% {
    content: "発行中. . . . .";
    opacity: 0.1;
  }
  50% {
    content: "完了";
    opacity: 0.1;
  }
  70% {
    content: "完了";
    opacity: 0.7;
  }
  100% {
    content: "完了";
    opacity: 1;
  }
}
.loader-border {
  display: block;
  position: relative;
  border: 1px solid rgba(242, 122, 67, 0.8);
  border-radius: 10px;
  padding: 1px 1px 1px 1px;
}

.loader {
  display: block;
  position: relative;
  overflow: hidden;
}
.loader .circle {
  width: 20px;
  height: 100%;
  background: #f27a43;
  border-radius: 10px;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  z-index: 1;
}
.loader .progress {
  position: absolute;
  left: 1;
  top: 1;
  height: 100%;
  width: 0;
  border-radius: 10px;
  background: #f27a43;
}

.opacity-button {
  animation: fadeIn 5s;
  -webkit-animation: fadeIn 5s;
  -moz-animation: fadeIn 5s;
  -o-animation: fadeIn 5s;
  -ms-animation: fadeIn 5s;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.blink {
  animation: blink 0.5s linear infinite;
}

@keyframes blink {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
.choose-group-list {
  font-family: "Europa";
}
.choose-group-list .name {
  width: 50%;
}
.choose-group-list .groupno {
  width: 50%;
}
.choose-group-list .choose-arrow {
  display: none;
}
.choose-group-list:hover {
  padding: 0 20px 0;
}
.choose-group-list:hover .name {
  width: 40%;
}
.choose-group-list:hover .groupno {
  width: 40%;
  text-align: right;
}
.choose-group-list:hover .choose-arrow {
  display: block;
}

.crop {
  width: 300px;
  height: 300px;
  overflow: hidden;
}

.crop img {
  width: 430px;
  height: auto;
  margin: 15px 0 0 -60px;
}

.error-valid-login {
  font-family: "Europa";
  color: #ff0000;
  font-size: 18px;
  line-height: 22px;
  text-align: right;
}

.select-box {
  border-radius: 5px;
  background-color: white;
  width: 100px;
  z-index: 10;
}
.select-box .select-row {
  color: black;
}
.select-box .select-row:hover {
  cursor: pointer;
  background-color: #7a7373;
}

.dynamic-grid-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(5, min-content);
}

.w-2 {
  width: 2%;
}

.w-80 {
  width: 80%;
}

.w-87 {
  width: 87% !important;
}

.w-90 {
  width: 90%;
}

.text-word-wrap {
  word-wrap: break-word;
}

.gird-table table {
  width: 100%;
}
.gird-table thead,
.gird-table tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}
.gird-table tbody {
  overflow: hidden;
  display: block;
  overflow-y: auto;
  table-layout: fixed;
  max-height: 440px;
}
.gird-table .grid-table-body td {
  height: 80%;
}
.gird-table .grid-table-header th {
  height: 40px;
}

.table-row .tr-btn {
  border-radius: 20px;
  padding: 6px 15px;
  cursor: pointer;
}
.table-row:hover {
  background: #262626 0% 0% no-repeat padding-box;
}
.table-row:hover .text {
  color: #f27a43;
}
.table-row:hover .tr-btn {
  background: linear-gradient(270deg, #ed541d 0%, #f4901b 100%);
}
.table-row:hover .tr-icon {
  fill: white;
}

.choose-perria-table table {
  table-layout: fixed;
  width: 400px;
  border-collapse: collapse;
  text-align: center;
  font-size: 20px;
  position: relative;
}
.choose-perria-table thead {
  position: sticky;
  left: 0;
  top: 0;
  background-color: black;
  z-index: 2;
}
.choose-perria-table thead th {
  padding-block: 10px;
  color: #e8723c;
  font-family: "ethno-light" !important;
  font-weight: 300;
}
.choose-perria-table thead th:first-child {
  width: 40%;
}
.choose-perria-table thead th:last-child {
  width: 60%;
}
.choose-perria-table tbody tr {
  position: relative;
}
.choose-perria-table tbody tr td {
  padding-block: 6px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 50%;
}
.choose-perria-table tbody tr:hover {
  cursor: pointer;
}
.choose-perria-table tbody tr:hover td:first-child::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  width: 12px;
  height: 6px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  transform: rotate(180deg);
}
.choose-perria-table tbody tr:hover td:last-child::after {
  content: "";
  position: absolute;
  right: 0;
  top: 50%;
  width: 12px;
  height: 6px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}

.custom-table table {
  table-layout: fixed;
  width: 100%;
  border-collapse: collapse;
}
.custom-table th {
  padding-block: 10px;
  padding-left: 10px;
}
.custom-table td {
  padding-block: 6px;
  padding-left: 20px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.custom-table th:first-child,
.custom-table td:first-child {
  padding-left: 30px;
}
.custom-table td:last-child {
  padding-right: 30px;
}
.custom-table th:last-child {
  padding-right: 40px;
}
.custom-table tbody > tr .action-btn {
  color: #ffffff;
  text-decoration: none;
  padding: 5px 10px;
  border-radius: 35px;
  background-color: transparent;
  border: none;
}
.custom-table tbody > tr:hover {
  color: #f27a43;
  background-color: #262626;
}
.custom-table tbody > tr:hover .action-btn {
  background: rgb(245, 151, 27);
  background: linear-gradient(90deg, rgb(245, 151, 27) 0%, rgb(236, 77, 29) 100%);
  color: #ffffff;
}
.custom-table tbody > tr:hover .action-btn path {
  fill: #ffffff;
  stroke: #ffffff;
}

.drawchain-table th:last-child,
.drawchain-table td:last-child {
  padding-right: 20px;
}

.label-text {
  color: #ffffff;
  font-size: 18px;
}

.parameter-label-text {
  color: #ffffff;
  font-size: 14px;
  font-family: "NotoSansJP-light";
  text-align: center;
}

.op-1 path {
  opacity: 1;
}

.side-bar-container {
  translate: 0 0;
  scale: 100% 1;
  z-index: 2;
  transition: all 1s ease-in-out;
}

.side-bar-out {
  translate: -100vw 0;
  scale: 200% 1;
}

@keyframes slidein {
  from {
    translate: -100vw 0;
    scale: 200% 1;
  }
  to {
    translate: 0 0;
    scale: 100% 1;
  }
}
@keyframes slideout {
  from {
    translate: 0 0;
    scale: 100% 1;
  }
  to {
    translate: -100vw 0;
    scale: 200% 1;
  }
}
.vertical-text-container {
  width: 40px;
  height: auto;
  writing-mode: vertical-lr;
}

.vertical-text {
  transform: rotate(-90deg);
  width: 0;
  height: auto;
  direction: rtl;
  letter-spacing: 0.23em;
}

.vertical-en-text {
  font-size: 47px;
  color: #f27a43;
  font-family: "ethno-light";
  font-weight: 300;
  line-height: 43px;
  text-align: center;
}
.vertical-en-text span {
  display: block;
}

.side-text-container {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  transition: opacity 1s ease-in-out;
  z-index: 0;
}

.side-text-container.show {
  z-index: 1;
  opacity: 1;
}

.bg-btn-primary-color {
  background: linear-gradient(270deg, #ed541d 0%, #f4901b 100%);
}

.center-vertical-line {
  position: absolute;
  width: 2px;
  height: 30px;
  background-color: rgba(122, 115, 115, 0.5);
  left: calc(50% - 1px);
}

.fade-in-out {
  opacity: 0;
  visibility: hidden;
}

.fade-in-out.show {
  visibility: visible;
  animation: fadeIn 1s ease-in-out forwards;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/app.scss","webpack://./src/assets/scss/variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB,2BAAA;AACA;EACE,UAAA;AAAF;;AAGA,uBAAA;AACA;EACE,kBAAA;AAAF;;AAGA,WAAA;AACA;EACE,gBAAA;EACA,kBAAA;AAAF;;AAGA,oBAAA;AACA;EACE,gBAAA;AAAF;;AAGA,YAAA;AACA;EACE,qBAAA,EAAA,UAAA;EACA,qBAAA;AAAF;;AAGA,0EAAA;AACA;EACE,0BAAA;AAAF;;AAGA;;;;;CAAA;AAOA,gCAAA;AACA;;;CAAA;AAKE;EACE,yBAAA;AAFJ;;AACE;EACE,yBAAA;AAEJ;;AAHE;EACE,yBAAA;AAMJ;;AAPE;EACE,yBAAA;AAUJ;;AAXE;EACE,yBAAA;AAcJ;;AAfE;EACE,yBAAA;AAkBJ;;AAnBE;EACE,yBAAA;AAsBJ;;AAvBE;EACE,yBAAA;AA0BJ;;AA3BE;EACE,yBAAA;AA8BJ;;AA/BE;EACE,0BAAA;AAkCJ;;AAnCE;EACE,0BAAA;AAsCJ;;AAvCE;EACE,0BAAA;AA0CJ;;AA3CE;EACE,0BAAA;AA8CJ;;AA/CE;EACE,0BAAA;AAkDJ;;AAnDE;EACE,0BAAA;AAsDJ;;AAvDE;EACE,0BAAA;AA0DJ;;AA3DE;EACE,0BAAA;AA8DJ;;AA/DE;EACE,0BAAA;AAkEJ;;AAnEE;EACE,0BAAA;AAsEJ;;AAvEE;EACE,0BAAA;AA0EJ;;AA3EE;EACE,0BAAA;AA8EJ;;AA/EE;EACE,0BAAA;AAkFJ;;AAnFE;EACE,0BAAA;AAsFJ;;AAvFE;EACE,0BAAA;AA0FJ;;AA3FE;EACE,0BAAA;AA8FJ;;AA/FE;EACE,0BAAA;AAkGJ;;AAnGE;EACE,0BAAA;AAsGJ;;AAvGE;EACE,0BAAA;AA0GJ;;AA3GE;EACE,0BAAA;AA8GJ;;AA/GE;EACE,0BAAA;AAkHJ;;AAnHE;EACE,0BAAA;AAsHJ;;AAvHE;EACE,0BAAA;AA0HJ;;AA3HE;EACE,0BAAA;AA8HJ;;AA/HE;EACE,0BAAA;AAkIJ;;AAnIE;EACE,0BAAA;AAsIJ;;AAvIE;EACE,0BAAA;AA0IJ;;AA3IE;EACE,0BAAA;AA8IJ;;AA/IE;EACE,0BAAA;AAkJJ;;AAnJE;EACE,0BAAA;AAsJJ;;AAvJE;EACE,0BAAA;AA0JJ;;AA3JE;EACE,0BAAA;AA8JJ;;AA/JE;EACE,0BAAA;AAkKJ;;AAnKE;EACE,0BAAA;AAsKJ;;AAvKE;EACE,0BAAA;AA0KJ;;AA3KE;EACE,0BAAA;AA8KJ;;AA/KE;EACE,0BAAA;AAkLJ;;AAnLE;EACE,0BAAA;AAsLJ;;AAvLE;EACE,0BAAA;AA0LJ;;AA3LE;EACE,0BAAA;AA8LJ;;AA/LE;EACE,0BAAA;AAkMJ;;AA7LI;EACE,yBAAA;AAgMN;;AAjMI;EACE,yBAAA;AAoMN;;AArMI;EACE,yBAAA;AAwMN;;AAzMI;EACE,yBAAA;AA4MN;;AA7MI;EACE,yBAAA;AAgNN;;AAjNI;EACE,yBAAA;AAoNN;;AArNI;EACE,yBAAA;AAwNN;;AAzNI;EACE,yBAAA;AA4NN;;AA7NI;EACE,yBAAA;AAgON;;AAjOI;EACE,0BAAA;AAoON;;AArOI;EACE,0BAAA;AAwON;;AAzOI;EACE,0BAAA;AA4ON;;AA7OI;EACE,0BAAA;AAgPN;;AAjPI;EACE,0BAAA;AAoPN;;AArPI;EACE,0BAAA;AAwPN;;AAzPI;EACE,0BAAA;AA4PN;;AA7PI;EACE,0BAAA;AAgQN;;AAjQI;EACE,0BAAA;AAoQN;;AArQI;EACE,0BAAA;AAwQN;;AAzQI;EACE,0BAAA;AA4QN;;AA7QI;EACE,0BAAA;AAgRN;;AAjRI;EACE,0BAAA;AAoRN;;AArRI;EACE,0BAAA;AAwRN;;AAzRI;EACE,0BAAA;AA4RN;;AA7RI;EACE,0BAAA;AAgSN;;AAjSI;EACE,0BAAA;AAoSN;;AArSI;EACE,0BAAA;AAwSN;;AAzSI;EACE,0BAAA;AA4SN;;AA7SI;EACE,0BAAA;AAgTN;;AAjTI;EACE,0BAAA;AAoTN;;AArTI;EACE,0BAAA;AAwTN;;AAzTI;EACE,0BAAA;AA4TN;;AA7TI;EACE,0BAAA;AAgUN;;AAjUI;EACE,0BAAA;AAoUN;;AArUI;EACE,0BAAA;AAwUN;;AAzUI;EACE,0BAAA;AA4UN;;AA7UI;EACE,0BAAA;AAgVN;;AAjVI;EACE,0BAAA;AAoVN;;AArVI;EACE,0BAAA;AAwVN;;AAzVI;EACE,0BAAA;AA4VN;;AA7VI;EACE,0BAAA;AAgWN;;AAjWI;EACE,0BAAA;AAoWN;;AArWI;EACE,0BAAA;AAwWN;;AAzWI;EACE,0BAAA;AA4WN;;AA7WI;EACE,0BAAA;AAgXN;;AAjXI;EACE,0BAAA;AAoXN;;AArXI;EACE,0BAAA;AAwXN;;AAzXI;EACE,0BAAA;AA4XN;;AA7XI;EACE,0BAAA;AAgYN;;AAjYI;EACE,0BAAA;AAoYN;;AA9XE;EACE,uBAAA;AAiYJ;;AA9XE;EACE,4BAAA;AAiYJ;;AA9XE;EACE,6BAAA;AAiYJ;;AA9XE;EACE,2BAAA;AAiYJ;;AA9XE;EACE,8BAAA;AAiYJ;;AA9XE;EACE,8BAAA;AAiYJ;;AA9XE;EACE,6BAAA;AAiYJ;;AA9XE;EACE,sBAAA;AAiYJ;;AA9XE;EACE,2BAAA;AAiYJ;;AA9XE;EACE,4BAAA;AAiYJ;;AA9XE;EACE,0BAAA;AAiYJ;;AA9XE;EACE,6BAAA;AAiYJ;;AA9XE;EACE,6BAAA;AAiYJ;;AA9XE;EACE,4BAAA;AAiYJ;;AAtbE;EACE,uBAAA;AAybJ;;AAtbE;EACE,4BAAA;AAybJ;;AAtbE;EACE,6BAAA;AAybJ;;AAtbE;EACE,2BAAA;AAybJ;;AAtbE;EACE,8BAAA;AAybJ;;AAtbE;EACE,8BAAA;AAybJ;;AAtbE;EACE,6BAAA;AAybJ;;AAtbE;EACE,sBAAA;AAybJ;;AAtbE;EACE,2BAAA;AAybJ;;AAtbE;EACE,4BAAA;AAybJ;;AAtbE;EACE,0BAAA;AAybJ;;AAtbE;EACE,6BAAA;AAybJ;;AAtbE;EACE,6BAAA;AAybJ;;AAtbE;EACE,4BAAA;AAybJ;;AA9eE;EACE,uBAAA;AAifJ;;AA9eE;EACE,4BAAA;AAifJ;;AA9eE;EACE,6BAAA;AAifJ;;AA9eE;EACE,2BAAA;AAifJ;;AA9eE;EACE,8BAAA;AAifJ;;AA9eE;EACE,8BAAA;AAifJ;;AA9eE;EACE,6BAAA;AAifJ;;AA9eE;EACE,sBAAA;AAifJ;;AA9eE;EACE,2BAAA;AAifJ;;AA9eE;EACE,4BAAA;AAifJ;;AA9eE;EACE,0BAAA;AAifJ;;AA9eE;EACE,6BAAA;AAifJ;;AA9eE;EACE,6BAAA;AAifJ;;AA9eE;EACE,4BAAA;AAifJ;;AAtiBE;EACE,uBAAA;AAyiBJ;;AAtiBE;EACE,4BAAA;AAyiBJ;;AAtiBE;EACE,6BAAA;AAyiBJ;;AAtiBE;EACE,2BAAA;AAyiBJ;;AAtiBE;EACE,8BAAA;AAyiBJ;;AAtiBE;EACE,8BAAA;AAyiBJ;;AAtiBE;EACE,6BAAA;AAyiBJ;;AAtiBE;EACE,sBAAA;AAyiBJ;;AAtiBE;EACE,2BAAA;AAyiBJ;;AAtiBE;EACE,4BAAA;AAyiBJ;;AAtiBE;EACE,0BAAA;AAyiBJ;;AAtiBE;EACE,6BAAA;AAyiBJ;;AAtiBE;EACE,6BAAA;AAyiBJ;;AAtiBE;EACE,4BAAA;AAyiBJ;;AA9lBE;EACE,uBAAA;AAimBJ;;AA9lBE;EACE,4BAAA;AAimBJ;;AA9lBE;EACE,6BAAA;AAimBJ;;AA9lBE;EACE,2BAAA;AAimBJ;;AA9lBE;EACE,8BAAA;AAimBJ;;AA9lBE;EACE,8BAAA;AAimBJ;;AA9lBE;EACE,6BAAA;AAimBJ;;AA9lBE;EACE,sBAAA;AAimBJ;;AA9lBE;EACE,2BAAA;AAimBJ;;AA9lBE;EACE,4BAAA;AAimBJ;;AA9lBE;EACE,0BAAA;AAimBJ;;AA9lBE;EACE,6BAAA;AAimBJ;;AA9lBE;EACE,6BAAA;AAimBJ;;AA9lBE;EACE,4BAAA;AAimBJ;;AAtpBE;EACE,uBAAA;AAypBJ;;AAtpBE;EACE,4BAAA;AAypBJ;;AAtpBE;EACE,6BAAA;AAypBJ;;AAtpBE;EACE,2BAAA;AAypBJ;;AAtpBE;EACE,8BAAA;AAypBJ;;AAtpBE;EACE,8BAAA;AAypBJ;;AAtpBE;EACE,6BAAA;AAypBJ;;AAtpBE;EACE,sBAAA;AAypBJ;;AAtpBE;EACE,2BAAA;AAypBJ;;AAtpBE;EACE,4BAAA;AAypBJ;;AAtpBE;EACE,0BAAA;AAypBJ;;AAtpBE;EACE,6BAAA;AAypBJ;;AAtpBE;EACE,6BAAA;AAypBJ;;AAtpBE;EACE,4BAAA;AAypBJ;;AA9sBE;EACE,uBAAA;AAitBJ;;AA9sBE;EACE,4BAAA;AAitBJ;;AA9sBE;EACE,6BAAA;AAitBJ;;AA9sBE;EACE,2BAAA;AAitBJ;;AA9sBE;EACE,8BAAA;AAitBJ;;AA9sBE;EACE,8BAAA;AAitBJ;;AA9sBE;EACE,6BAAA;AAitBJ;;AA9sBE;EACE,sBAAA;AAitBJ;;AA9sBE;EACE,2BAAA;AAitBJ;;AA9sBE;EACE,4BAAA;AAitBJ;;AA9sBE;EACE,0BAAA;AAitBJ;;AA9sBE;EACE,6BAAA;AAitBJ;;AA9sBE;EACE,6BAAA;AAitBJ;;AA9sBE;EACE,4BAAA;AAitBJ;;AAtwBE;EACE,uBAAA;AAywBJ;;AAtwBE;EACE,4BAAA;AAywBJ;;AAtwBE;EACE,6BAAA;AAywBJ;;AAtwBE;EACE,2BAAA;AAywBJ;;AAtwBE;EACE,8BAAA;AAywBJ;;AAtwBE;EACE,8BAAA;AAywBJ;;AAtwBE;EACE,6BAAA;AAywBJ;;AAtwBE;EACE,sBAAA;AAywBJ;;AAtwBE;EACE,2BAAA;AAywBJ;;AAtwBE;EACE,4BAAA;AAywBJ;;AAtwBE;EACE,0BAAA;AAywBJ;;AAtwBE;EACE,6BAAA;AAywBJ;;AAtwBE;EACE,6BAAA;AAywBJ;;AAtwBE;EACE,4BAAA;AAywBJ;;AA9zBE;EACE,uBAAA;AAi0BJ;;AA9zBE;EACE,4BAAA;AAi0BJ;;AA9zBE;EACE,6BAAA;AAi0BJ;;AA9zBE;EACE,2BAAA;AAi0BJ;;AA9zBE;EACE,8BAAA;AAi0BJ;;AA9zBE;EACE,8BAAA;AAi0BJ;;AA9zBE;EACE,6BAAA;AAi0BJ;;AA9zBE;EACE,sBAAA;AAi0BJ;;AA9zBE;EACE,2BAAA;AAi0BJ;;AA9zBE;EACE,4BAAA;AAi0BJ;;AA9zBE;EACE,0BAAA;AAi0BJ;;AA9zBE;EACE,6BAAA;AAi0BJ;;AA9zBE;EACE,6BAAA;AAi0BJ;;AA9zBE;EACE,4BAAA;AAi0BJ;;AAt3BE;EACE,uBAAA;AAy3BJ;;AAt3BE;EACE,4BAAA;AAy3BJ;;AAt3BE;EACE,6BAAA;AAy3BJ;;AAt3BE;EACE,2BAAA;AAy3BJ;;AAt3BE;EACE,8BAAA;AAy3BJ;;AAt3BE;EACE,8BAAA;AAy3BJ;;AAt3BE;EACE,6BAAA;AAy3BJ;;AAt3BE;EACE,sBAAA;AAy3BJ;;AAt3BE;EACE,2BAAA;AAy3BJ;;AAt3BE;EACE,4BAAA;AAy3BJ;;AAt3BE;EACE,0BAAA;AAy3BJ;;AAt3BE;EACE,6BAAA;AAy3BJ;;AAt3BE;EACE,6BAAA;AAy3BJ;;AAt3BE;EACE,4BAAA;AAy3BJ;;AA96BE;EACE,wBAAA;AAi7BJ;;AA96BE;EACE,6BAAA;AAi7BJ;;AA96BE;EACE,8BAAA;AAi7BJ;;AA96BE;EACE,4BAAA;AAi7BJ;;AA96BE;EACE,+BAAA;AAi7BJ;;AA96BE;EACE,+BAAA;AAi7BJ;;AA96BE;EACE,8BAAA;AAi7BJ;;AA96BE;EACE,uBAAA;AAi7BJ;;AA96BE;EACE,4BAAA;AAi7BJ;;AA96BE;EACE,6BAAA;AAi7BJ;;AA96BE;EACE,2BAAA;AAi7BJ;;AA96BE;EACE,8BAAA;AAi7BJ;;AA96BE;EACE,8BAAA;AAi7BJ;;AA96BE;EACE,6BAAA;AAi7BJ;;AAt+BE;EACE,wBAAA;AAy+BJ;;AAt+BE;EACE,6BAAA;AAy+BJ;;AAt+BE;EACE,8BAAA;AAy+BJ;;AAt+BE;EACE,4BAAA;AAy+BJ;;AAt+BE;EACE,+BAAA;AAy+BJ;;AAt+BE;EACE,+BAAA;AAy+BJ;;AAt+BE;EACE,8BAAA;AAy+BJ;;AAt+BE;EACE,uBAAA;AAy+BJ;;AAt+BE;EACE,4BAAA;AAy+BJ;;AAt+BE;EACE,6BAAA;AAy+BJ;;AAt+BE;EACE,2BAAA;AAy+BJ;;AAt+BE;EACE,8BAAA;AAy+BJ;;AAt+BE;EACE,8BAAA;AAy+BJ;;AAt+BE;EACE,6BAAA;AAy+BJ;;AA9hCE;EACE,wBAAA;AAiiCJ;;AA9hCE;EACE,6BAAA;AAiiCJ;;AA9hCE;EACE,8BAAA;AAiiCJ;;AA9hCE;EACE,4BAAA;AAiiCJ;;AA9hCE;EACE,+BAAA;AAiiCJ;;AA9hCE;EACE,+BAAA;AAiiCJ;;AA9hCE;EACE,8BAAA;AAiiCJ;;AA9hCE;EACE,uBAAA;AAiiCJ;;AA9hCE;EACE,4BAAA;AAiiCJ;;AA9hCE;EACE,6BAAA;AAiiCJ;;AA9hCE;EACE,2BAAA;AAiiCJ;;AA9hCE;EACE,8BAAA;AAiiCJ;;AA9hCE;EACE,8BAAA;AAiiCJ;;AA9hCE;EACE,6BAAA;AAiiCJ;;AAtlCE;EACE,wBAAA;AAylCJ;;AAtlCE;EACE,6BAAA;AAylCJ;;AAtlCE;EACE,8BAAA;AAylCJ;;AAtlCE;EACE,4BAAA;AAylCJ;;AAtlCE;EACE,+BAAA;AAylCJ;;AAtlCE;EACE,+BAAA;AAylCJ;;AAtlCE;EACE,8BAAA;AAylCJ;;AAtlCE;EACE,uBAAA;AAylCJ;;AAtlCE;EACE,4BAAA;AAylCJ;;AAtlCE;EACE,6BAAA;AAylCJ;;AAtlCE;EACE,2BAAA;AAylCJ;;AAtlCE;EACE,8BAAA;AAylCJ;;AAtlCE;EACE,8BAAA;AAylCJ;;AAtlCE;EACE,6BAAA;AAylCJ;;AA9oCE;EACE,wBAAA;AAipCJ;;AA9oCE;EACE,6BAAA;AAipCJ;;AA9oCE;EACE,8BAAA;AAipCJ;;AA9oCE;EACE,4BAAA;AAipCJ;;AA9oCE;EACE,+BAAA;AAipCJ;;AA9oCE;EACE,+BAAA;AAipCJ;;AA9oCE;EACE,8BAAA;AAipCJ;;AA9oCE;EACE,uBAAA;AAipCJ;;AA9oCE;EACE,4BAAA;AAipCJ;;AA9oCE;EACE,6BAAA;AAipCJ;;AA9oCE;EACE,2BAAA;AAipCJ;;AA9oCE;EACE,8BAAA;AAipCJ;;AA9oCE;EACE,8BAAA;AAipCJ;;AA9oCE;EACE,6BAAA;AAipCJ;;AAtsCE;EACE,wBAAA;AAysCJ;;AAtsCE;EACE,6BAAA;AAysCJ;;AAtsCE;EACE,8BAAA;AAysCJ;;AAtsCE;EACE,4BAAA;AAysCJ;;AAtsCE;EACE,+BAAA;AAysCJ;;AAtsCE;EACE,+BAAA;AAysCJ;;AAtsCE;EACE,8BAAA;AAysCJ;;AAtsCE;EACE,uBAAA;AAysCJ;;AAtsCE;EACE,4BAAA;AAysCJ;;AAtsCE;EACE,6BAAA;AAysCJ;;AAtsCE;EACE,2BAAA;AAysCJ;;AAtsCE;EACE,8BAAA;AAysCJ;;AAtsCE;EACE,8BAAA;AAysCJ;;AAtsCE;EACE,6BAAA;AAysCJ;;AA9vCE;EACE,wBAAA;AAiwCJ;;AA9vCE;EACE,6BAAA;AAiwCJ;;AA9vCE;EACE,8BAAA;AAiwCJ;;AA9vCE;EACE,4BAAA;AAiwCJ;;AA9vCE;EACE,+BAAA;AAiwCJ;;AA9vCE;EACE,+BAAA;AAiwCJ;;AA9vCE;EACE,8BAAA;AAiwCJ;;AA9vCE;EACE,uBAAA;AAiwCJ;;AA9vCE;EACE,4BAAA;AAiwCJ;;AA9vCE;EACE,6BAAA;AAiwCJ;;AA9vCE;EACE,2BAAA;AAiwCJ;;AA9vCE;EACE,8BAAA;AAiwCJ;;AA9vCE;EACE,8BAAA;AAiwCJ;;AA9vCE;EACE,6BAAA;AAiwCJ;;AAtzCE;EACE,wBAAA;AAyzCJ;;AAtzCE;EACE,6BAAA;AAyzCJ;;AAtzCE;EACE,8BAAA;AAyzCJ;;AAtzCE;EACE,4BAAA;AAyzCJ;;AAtzCE;EACE,+BAAA;AAyzCJ;;AAtzCE;EACE,+BAAA;AAyzCJ;;AAtzCE;EACE,8BAAA;AAyzCJ;;AAtzCE;EACE,uBAAA;AAyzCJ;;AAtzCE;EACE,4BAAA;AAyzCJ;;AAtzCE;EACE,6BAAA;AAyzCJ;;AAtzCE;EACE,2BAAA;AAyzCJ;;AAtzCE;EACE,8BAAA;AAyzCJ;;AAtzCE;EACE,8BAAA;AAyzCJ;;AAtzCE;EACE,6BAAA;AAyzCJ;;AA92CE;EACE,wBAAA;AAi3CJ;;AA92CE;EACE,6BAAA;AAi3CJ;;AA92CE;EACE,8BAAA;AAi3CJ;;AA92CE;EACE,4BAAA;AAi3CJ;;AA92CE;EACE,+BAAA;AAi3CJ;;AA92CE;EACE,+BAAA;AAi3CJ;;AA92CE;EACE,8BAAA;AAi3CJ;;AA92CE;EACE,uBAAA;AAi3CJ;;AA92CE;EACE,4BAAA;AAi3CJ;;AA92CE;EACE,6BAAA;AAi3CJ;;AA92CE;EACE,2BAAA;AAi3CJ;;AA92CE;EACE,8BAAA;AAi3CJ;;AA92CE;EACE,8BAAA;AAi3CJ;;AA92CE;EACE,6BAAA;AAi3CJ;;AAt6CE;EACE,wBAAA;AAy6CJ;;AAt6CE;EACE,6BAAA;AAy6CJ;;AAt6CE;EACE,8BAAA;AAy6CJ;;AAt6CE;EACE,4BAAA;AAy6CJ;;AAt6CE;EACE,+BAAA;AAy6CJ;;AAt6CE;EACE,+BAAA;AAy6CJ;;AAt6CE;EACE,8BAAA;AAy6CJ;;AAt6CE;EACE,uBAAA;AAy6CJ;;AAt6CE;EACE,4BAAA;AAy6CJ;;AAt6CE;EACE,6BAAA;AAy6CJ;;AAt6CE;EACE,2BAAA;AAy6CJ;;AAt6CE;EACE,8BAAA;AAy6CJ;;AAt6CE;EACE,8BAAA;AAy6CJ;;AAt6CE;EACE,6BAAA;AAy6CJ;;AA99CE;EACE,wBAAA;AAi+CJ;;AA99CE;EACE,6BAAA;AAi+CJ;;AA99CE;EACE,8BAAA;AAi+CJ;;AA99CE;EACE,4BAAA;AAi+CJ;;AA99CE;EACE,+BAAA;AAi+CJ;;AA99CE;EACE,+BAAA;AAi+CJ;;AA99CE;EACE,8BAAA;AAi+CJ;;AA99CE;EACE,uBAAA;AAi+CJ;;AA99CE;EACE,4BAAA;AAi+CJ;;AA99CE;EACE,6BAAA;AAi+CJ;;AA99CE;EACE,2BAAA;AAi+CJ;;AA99CE;EACE,8BAAA;AAi+CJ;;AA99CE;EACE,8BAAA;AAi+CJ;;AA99CE;EACE,6BAAA;AAi+CJ;;AAthDE;EACE,wBAAA;AAyhDJ;;AAthDE;EACE,6BAAA;AAyhDJ;;AAthDE;EACE,8BAAA;AAyhDJ;;AAthDE;EACE,4BAAA;AAyhDJ;;AAthDE;EACE,+BAAA;AAyhDJ;;AAthDE;EACE,+BAAA;AAyhDJ;;AAthDE;EACE,8BAAA;AAyhDJ;;AAthDE;EACE,uBAAA;AAyhDJ;;AAthDE;EACE,4BAAA;AAyhDJ;;AAthDE;EACE,6BAAA;AAyhDJ;;AAthDE;EACE,2BAAA;AAyhDJ;;AAthDE;EACE,8BAAA;AAyhDJ;;AAthDE;EACE,8BAAA;AAyhDJ;;AAthDE;EACE,6BAAA;AAyhDJ;;AA9kDE;EACE,wBAAA;AAilDJ;;AA9kDE;EACE,6BAAA;AAilDJ;;AA9kDE;EACE,8BAAA;AAilDJ;;AA9kDE;EACE,4BAAA;AAilDJ;;AA9kDE;EACE,+BAAA;AAilDJ;;AA9kDE;EACE,+BAAA;AAilDJ;;AA9kDE;EACE,8BAAA;AAilDJ;;AA9kDE;EACE,uBAAA;AAilDJ;;AA9kDE;EACE,4BAAA;AAilDJ;;AA9kDE;EACE,6BAAA;AAilDJ;;AA9kDE;EACE,2BAAA;AAilDJ;;AA9kDE;EACE,8BAAA;AAilDJ;;AA9kDE;EACE,8BAAA;AAilDJ;;AA9kDE;EACE,6BAAA;AAilDJ;;AAtoDE;EACE,wBAAA;AAyoDJ;;AAtoDE;EACE,6BAAA;AAyoDJ;;AAtoDE;EACE,8BAAA;AAyoDJ;;AAtoDE;EACE,4BAAA;AAyoDJ;;AAtoDE;EACE,+BAAA;AAyoDJ;;AAtoDE;EACE,+BAAA;AAyoDJ;;AAtoDE;EACE,8BAAA;AAyoDJ;;AAtoDE;EACE,uBAAA;AAyoDJ;;AAtoDE;EACE,4BAAA;AAyoDJ;;AAtoDE;EACE,6BAAA;AAyoDJ;;AAtoDE;EACE,2BAAA;AAyoDJ;;AAtoDE;EACE,8BAAA;AAyoDJ;;AAtoDE;EACE,8BAAA;AAyoDJ;;AAtoDE;EACE,6BAAA;AAyoDJ;;AA9rDE;EACE,wBAAA;AAisDJ;;AA9rDE;EACE,6BAAA;AAisDJ;;AA9rDE;EACE,8BAAA;AAisDJ;;AA9rDE;EACE,4BAAA;AAisDJ;;AA9rDE;EACE,+BAAA;AAisDJ;;AA9rDE;EACE,+BAAA;AAisDJ;;AA9rDE;EACE,8BAAA;AAisDJ;;AA9rDE;EACE,uBAAA;AAisDJ;;AA9rDE;EACE,4BAAA;AAisDJ;;AA9rDE;EACE,6BAAA;AAisDJ;;AA9rDE;EACE,2BAAA;AAisDJ;;AA9rDE;EACE,8BAAA;AAisDJ;;AA9rDE;EACE,8BAAA;AAisDJ;;AA9rDE;EACE,6BAAA;AAisDJ;;AAtvDE;EACE,wBAAA;AAyvDJ;;AAtvDE;EACE,6BAAA;AAyvDJ;;AAtvDE;EACE,8BAAA;AAyvDJ;;AAtvDE;EACE,4BAAA;AAyvDJ;;AAtvDE;EACE,+BAAA;AAyvDJ;;AAtvDE;EACE,+BAAA;AAyvDJ;;AAtvDE;EACE,8BAAA;AAyvDJ;;AAtvDE;EACE,uBAAA;AAyvDJ;;AAtvDE;EACE,4BAAA;AAyvDJ;;AAtvDE;EACE,6BAAA;AAyvDJ;;AAtvDE;EACE,2BAAA;AAyvDJ;;AAtvDE;EACE,8BAAA;AAyvDJ;;AAtvDE;EACE,8BAAA;AAyvDJ;;AAtvDE;EACE,6BAAA;AAyvDJ;;AA9yDE;EACE,wBAAA;AAizDJ;;AA9yDE;EACE,6BAAA;AAizDJ;;AA9yDE;EACE,8BAAA;AAizDJ;;AA9yDE;EACE,4BAAA;AAizDJ;;AA9yDE;EACE,+BAAA;AAizDJ;;AA9yDE;EACE,+BAAA;AAizDJ;;AA9yDE;EACE,8BAAA;AAizDJ;;AA9yDE;EACE,uBAAA;AAizDJ;;AA9yDE;EACE,4BAAA;AAizDJ;;AA9yDE;EACE,6BAAA;AAizDJ;;AA9yDE;EACE,2BAAA;AAizDJ;;AA9yDE;EACE,8BAAA;AAizDJ;;AA9yDE;EACE,8BAAA;AAizDJ;;AA9yDE;EACE,6BAAA;AAizDJ;;AAt2DE;EACE,wBAAA;AAy2DJ;;AAt2DE;EACE,6BAAA;AAy2DJ;;AAt2DE;EACE,8BAAA;AAy2DJ;;AAt2DE;EACE,4BAAA;AAy2DJ;;AAt2DE;EACE,+BAAA;AAy2DJ;;AAt2DE;EACE,+BAAA;AAy2DJ;;AAt2DE;EACE,8BAAA;AAy2DJ;;AAt2DE;EACE,uBAAA;AAy2DJ;;AAt2DE;EACE,4BAAA;AAy2DJ;;AAt2DE;EACE,6BAAA;AAy2DJ;;AAt2DE;EACE,2BAAA;AAy2DJ;;AAt2DE;EACE,8BAAA;AAy2DJ;;AAt2DE;EACE,8BAAA;AAy2DJ;;AAt2DE;EACE,6BAAA;AAy2DJ;;AA95DE;EACE,wBAAA;AAi6DJ;;AA95DE;EACE,6BAAA;AAi6DJ;;AA95DE;EACE,8BAAA;AAi6DJ;;AA95DE;EACE,4BAAA;AAi6DJ;;AA95DE;EACE,+BAAA;AAi6DJ;;AA95DE;EACE,+BAAA;AAi6DJ;;AA95DE;EACE,8BAAA;AAi6DJ;;AA95DE;EACE,uBAAA;AAi6DJ;;AA95DE;EACE,4BAAA;AAi6DJ;;AA95DE;EACE,6BAAA;AAi6DJ;;AA95DE;EACE,2BAAA;AAi6DJ;;AA95DE;EACE,8BAAA;AAi6DJ;;AA95DE;EACE,8BAAA;AAi6DJ;;AA95DE;EACE,6BAAA;AAi6DJ;;AAt9DE;EACE,wBAAA;AAy9DJ;;AAt9DE;EACE,6BAAA;AAy9DJ;;AAt9DE;EACE,8BAAA;AAy9DJ;;AAt9DE;EACE,4BAAA;AAy9DJ;;AAt9DE;EACE,+BAAA;AAy9DJ;;AAt9DE;EACE,+BAAA;AAy9DJ;;AAt9DE;EACE,8BAAA;AAy9DJ;;AAt9DE;EACE,uBAAA;AAy9DJ;;AAt9DE;EACE,4BAAA;AAy9DJ;;AAt9DE;EACE,6BAAA;AAy9DJ;;AAt9DE;EACE,2BAAA;AAy9DJ;;AAt9DE;EACE,8BAAA;AAy9DJ;;AAt9DE;EACE,8BAAA;AAy9DJ;;AAt9DE;EACE,6BAAA;AAy9DJ;;AA9gEE;EACE,wBAAA;AAihEJ;;AA9gEE;EACE,6BAAA;AAihEJ;;AA9gEE;EACE,8BAAA;AAihEJ;;AA9gEE;EACE,4BAAA;AAihEJ;;AA9gEE;EACE,+BAAA;AAihEJ;;AA9gEE;EACE,+BAAA;AAihEJ;;AA9gEE;EACE,8BAAA;AAihEJ;;AA9gEE;EACE,uBAAA;AAihEJ;;AA9gEE;EACE,4BAAA;AAihEJ;;AA9gEE;EACE,6BAAA;AAihEJ;;AA9gEE;EACE,2BAAA;AAihEJ;;AA9gEE;EACE,8BAAA;AAihEJ;;AA9gEE;EACE,8BAAA;AAihEJ;;AA9gEE;EACE,6BAAA;AAihEJ;;AAtkEE;EACE,wBAAA;AAykEJ;;AAtkEE;EACE,6BAAA;AAykEJ;;AAtkEE;EACE,8BAAA;AAykEJ;;AAtkEE;EACE,4BAAA;AAykEJ;;AAtkEE;EACE,+BAAA;AAykEJ;;AAtkEE;EACE,+BAAA;AAykEJ;;AAtkEE;EACE,8BAAA;AAykEJ;;AAtkEE;EACE,uBAAA;AAykEJ;;AAtkEE;EACE,4BAAA;AAykEJ;;AAtkEE;EACE,6BAAA;AAykEJ;;AAtkEE;EACE,2BAAA;AAykEJ;;AAtkEE;EACE,8BAAA;AAykEJ;;AAtkEE;EACE,8BAAA;AAykEJ;;AAtkEE;EACE,6BAAA;AAykEJ;;AA9nEE;EACE,wBAAA;AAioEJ;;AA9nEE;EACE,6BAAA;AAioEJ;;AA9nEE;EACE,8BAAA;AAioEJ;;AA9nEE;EACE,4BAAA;AAioEJ;;AA9nEE;EACE,+BAAA;AAioEJ;;AA9nEE;EACE,+BAAA;AAioEJ;;AA9nEE;EACE,8BAAA;AAioEJ;;AA9nEE;EACE,uBAAA;AAioEJ;;AA9nEE;EACE,4BAAA;AAioEJ;;AA9nEE;EACE,6BAAA;AAioEJ;;AA9nEE;EACE,2BAAA;AAioEJ;;AA9nEE;EACE,8BAAA;AAioEJ;;AA9nEE;EACE,8BAAA;AAioEJ;;AA9nEE;EACE,6BAAA;AAioEJ;;AAtrEE;EACE,wBAAA;AAyrEJ;;AAtrEE;EACE,6BAAA;AAyrEJ;;AAtrEE;EACE,8BAAA;AAyrEJ;;AAtrEE;EACE,4BAAA;AAyrEJ;;AAtrEE;EACE,+BAAA;AAyrEJ;;AAtrEE;EACE,+BAAA;AAyrEJ;;AAtrEE;EACE,8BAAA;AAyrEJ;;AAtrEE;EACE,uBAAA;AAyrEJ;;AAtrEE;EACE,4BAAA;AAyrEJ;;AAtrEE;EACE,6BAAA;AAyrEJ;;AAtrEE;EACE,2BAAA;AAyrEJ;;AAtrEE;EACE,8BAAA;AAyrEJ;;AAtrEE;EACE,8BAAA;AAyrEJ;;AAtrEE;EACE,6BAAA;AAyrEJ;;AA9uEE;EACE,wBAAA;AAivEJ;;AA9uEE;EACE,6BAAA;AAivEJ;;AA9uEE;EACE,8BAAA;AAivEJ;;AA9uEE;EACE,4BAAA;AAivEJ;;AA9uEE;EACE,+BAAA;AAivEJ;;AA9uEE;EACE,+BAAA;AAivEJ;;AA9uEE;EACE,8BAAA;AAivEJ;;AA9uEE;EACE,uBAAA;AAivEJ;;AA9uEE;EACE,4BAAA;AAivEJ;;AA9uEE;EACE,6BAAA;AAivEJ;;AA9uEE;EACE,2BAAA;AAivEJ;;AA9uEE;EACE,8BAAA;AAivEJ;;AA9uEE;EACE,8BAAA;AAivEJ;;AA9uEE;EACE,6BAAA;AAivEJ;;AAtyEE;EACE,wBAAA;AAyyEJ;;AAtyEE;EACE,6BAAA;AAyyEJ;;AAtyEE;EACE,8BAAA;AAyyEJ;;AAtyEE;EACE,4BAAA;AAyyEJ;;AAtyEE;EACE,+BAAA;AAyyEJ;;AAtyEE;EACE,+BAAA;AAyyEJ;;AAtyEE;EACE,8BAAA;AAyyEJ;;AAtyEE;EACE,uBAAA;AAyyEJ;;AAtyEE;EACE,4BAAA;AAyyEJ;;AAtyEE;EACE,6BAAA;AAyyEJ;;AAtyEE;EACE,2BAAA;AAyyEJ;;AAtyEE;EACE,8BAAA;AAyyEJ;;AAtyEE;EACE,8BAAA;AAyyEJ;;AAtyEE;EACE,6BAAA;AAyyEJ;;AA91EE;EACE,wBAAA;AAi2EJ;;AA91EE;EACE,6BAAA;AAi2EJ;;AA91EE;EACE,8BAAA;AAi2EJ;;AA91EE;EACE,4BAAA;AAi2EJ;;AA91EE;EACE,+BAAA;AAi2EJ;;AA91EE;EACE,+BAAA;AAi2EJ;;AA91EE;EACE,8BAAA;AAi2EJ;;AA91EE;EACE,uBAAA;AAi2EJ;;AA91EE;EACE,4BAAA;AAi2EJ;;AA91EE;EACE,6BAAA;AAi2EJ;;AA91EE;EACE,2BAAA;AAi2EJ;;AA91EE;EACE,8BAAA;AAi2EJ;;AA91EE;EACE,8BAAA;AAi2EJ;;AA91EE;EACE,6BAAA;AAi2EJ;;AAt5EE;EACE,wBAAA;AAy5EJ;;AAt5EE;EACE,6BAAA;AAy5EJ;;AAt5EE;EACE,8BAAA;AAy5EJ;;AAt5EE;EACE,4BAAA;AAy5EJ;;AAt5EE;EACE,+BAAA;AAy5EJ;;AAt5EE;EACE,+BAAA;AAy5EJ;;AAt5EE;EACE,8BAAA;AAy5EJ;;AAt5EE;EACE,uBAAA;AAy5EJ;;AAt5EE;EACE,4BAAA;AAy5EJ;;AAt5EE;EACE,6BAAA;AAy5EJ;;AAt5EE;EACE,2BAAA;AAy5EJ;;AAt5EE;EACE,8BAAA;AAy5EJ;;AAt5EE;EACE,8BAAA;AAy5EJ;;AAt5EE;EACE,6BAAA;AAy5EJ;;AA98EE;EACE,wBAAA;AAi9EJ;;AA98EE;EACE,6BAAA;AAi9EJ;;AA98EE;EACE,8BAAA;AAi9EJ;;AA98EE;EACE,4BAAA;AAi9EJ;;AA98EE;EACE,+BAAA;AAi9EJ;;AA98EE;EACE,+BAAA;AAi9EJ;;AA98EE;EACE,8BAAA;AAi9EJ;;AA98EE;EACE,uBAAA;AAi9EJ;;AA98EE;EACE,4BAAA;AAi9EJ;;AA98EE;EACE,6BAAA;AAi9EJ;;AA98EE;EACE,2BAAA;AAi9EJ;;AA98EE;EACE,8BAAA;AAi9EJ;;AA98EE;EACE,8BAAA;AAi9EJ;;AA98EE;EACE,6BAAA;AAi9EJ;;AAtgFE;EACE,wBAAA;AAygFJ;;AAtgFE;EACE,6BAAA;AAygFJ;;AAtgFE;EACE,8BAAA;AAygFJ;;AAtgFE;EACE,4BAAA;AAygFJ;;AAtgFE;EACE,+BAAA;AAygFJ;;AAtgFE;EACE,+BAAA;AAygFJ;;AAtgFE;EACE,8BAAA;AAygFJ;;AAtgFE;EACE,uBAAA;AAygFJ;;AAtgFE;EACE,4BAAA;AAygFJ;;AAtgFE;EACE,6BAAA;AAygFJ;;AAtgFE;EACE,2BAAA;AAygFJ;;AAtgFE;EACE,8BAAA;AAygFJ;;AAtgFE;EACE,8BAAA;AAygFJ;;AAtgFE;EACE,6BAAA;AAygFJ;;AA9jFE;EACE,wBAAA;AAikFJ;;AA9jFE;EACE,6BAAA;AAikFJ;;AA9jFE;EACE,8BAAA;AAikFJ;;AA9jFE;EACE,4BAAA;AAikFJ;;AA9jFE;EACE,+BAAA;AAikFJ;;AA9jFE;EACE,+BAAA;AAikFJ;;AA9jFE;EACE,8BAAA;AAikFJ;;AA9jFE;EACE,uBAAA;AAikFJ;;AA9jFE;EACE,4BAAA;AAikFJ;;AA9jFE;EACE,6BAAA;AAikFJ;;AA9jFE;EACE,2BAAA;AAikFJ;;AA9jFE;EACE,8BAAA;AAikFJ;;AA9jFE;EACE,8BAAA;AAikFJ;;AA9jFE;EACE,6BAAA;AAikFJ;;AAtnFE;EACE,wBAAA;AAynFJ;;AAtnFE;EACE,6BAAA;AAynFJ;;AAtnFE;EACE,8BAAA;AAynFJ;;AAtnFE;EACE,4BAAA;AAynFJ;;AAtnFE;EACE,+BAAA;AAynFJ;;AAtnFE;EACE,+BAAA;AAynFJ;;AAtnFE;EACE,8BAAA;AAynFJ;;AAtnFE;EACE,uBAAA;AAynFJ;;AAtnFE;EACE,4BAAA;AAynFJ;;AAtnFE;EACE,6BAAA;AAynFJ;;AAtnFE;EACE,2BAAA;AAynFJ;;AAtnFE;EACE,8BAAA;AAynFJ;;AAtnFE;EACE,8BAAA;AAynFJ;;AAtnFE;EACE,6BAAA;AAynFJ;;AA9qFE;EACE,wBAAA;AAirFJ;;AA9qFE;EACE,6BAAA;AAirFJ;;AA9qFE;EACE,8BAAA;AAirFJ;;AA9qFE;EACE,4BAAA;AAirFJ;;AA9qFE;EACE,+BAAA;AAirFJ;;AA9qFE;EACE,+BAAA;AAirFJ;;AA9qFE;EACE,8BAAA;AAirFJ;;AA9qFE;EACE,uBAAA;AAirFJ;;AA9qFE;EACE,4BAAA;AAirFJ;;AA9qFE;EACE,6BAAA;AAirFJ;;AA9qFE;EACE,2BAAA;AAirFJ;;AA9qFE;EACE,8BAAA;AAirFJ;;AA9qFE;EACE,8BAAA;AAirFJ;;AA9qFE;EACE,6BAAA;AAirFJ;;AAtuFE;EACE,wBAAA;AAyuFJ;;AAtuFE;EACE,6BAAA;AAyuFJ;;AAtuFE;EACE,8BAAA;AAyuFJ;;AAtuFE;EACE,4BAAA;AAyuFJ;;AAtuFE;EACE,+BAAA;AAyuFJ;;AAtuFE;EACE,+BAAA;AAyuFJ;;AAtuFE;EACE,8BAAA;AAyuFJ;;AAtuFE;EACE,uBAAA;AAyuFJ;;AAtuFE;EACE,4BAAA;AAyuFJ;;AAtuFE;EACE,6BAAA;AAyuFJ;;AAtuFE;EACE,2BAAA;AAyuFJ;;AAtuFE;EACE,8BAAA;AAyuFJ;;AAtuFE;EACE,8BAAA;AAyuFJ;;AAtuFE;EACE,6BAAA;AAyuFJ;;AA9xFE;EACE,wBAAA;AAiyFJ;;AA9xFE;EACE,6BAAA;AAiyFJ;;AA9xFE;EACE,8BAAA;AAiyFJ;;AA9xFE;EACE,4BAAA;AAiyFJ;;AA9xFE;EACE,+BAAA;AAiyFJ;;AA9xFE;EACE,+BAAA;AAiyFJ;;AA9xFE;EACE,8BAAA;AAiyFJ;;AA9xFE;EACE,uBAAA;AAiyFJ;;AA9xFE;EACE,4BAAA;AAiyFJ;;AA9xFE;EACE,6BAAA;AAiyFJ;;AA9xFE;EACE,2BAAA;AAiyFJ;;AA9xFE;EACE,8BAAA;AAiyFJ;;AA9xFE;EACE,8BAAA;AAiyFJ;;AA9xFE;EACE,6BAAA;AAiyFJ;;AAt1FE;EACE,wBAAA;AAy1FJ;;AAt1FE;EACE,6BAAA;AAy1FJ;;AAt1FE;EACE,8BAAA;AAy1FJ;;AAt1FE;EACE,4BAAA;AAy1FJ;;AAt1FE;EACE,+BAAA;AAy1FJ;;AAt1FE;EACE,+BAAA;AAy1FJ;;AAt1FE;EACE,8BAAA;AAy1FJ;;AAt1FE;EACE,uBAAA;AAy1FJ;;AAt1FE;EACE,4BAAA;AAy1FJ;;AAt1FE;EACE,6BAAA;AAy1FJ;;AAt1FE;EACE,2BAAA;AAy1FJ;;AAt1FE;EACE,8BAAA;AAy1FJ;;AAt1FE;EACE,8BAAA;AAy1FJ;;AAt1FE;EACE,6BAAA;AAy1FJ;;AA94FE;EACE,wBAAA;AAi5FJ;;AA94FE;EACE,6BAAA;AAi5FJ;;AA94FE;EACE,8BAAA;AAi5FJ;;AA94FE;EACE,4BAAA;AAi5FJ;;AA94FE;EACE,+BAAA;AAi5FJ;;AA94FE;EACE,+BAAA;AAi5FJ;;AA94FE;EACE,8BAAA;AAi5FJ;;AA94FE;EACE,uBAAA;AAi5FJ;;AA94FE;EACE,4BAAA;AAi5FJ;;AA94FE;EACE,6BAAA;AAi5FJ;;AA94FE;EACE,2BAAA;AAi5FJ;;AA94FE;EACE,8BAAA;AAi5FJ;;AA94FE;EACE,8BAAA;AAi5FJ;;AA94FE;EACE,6BAAA;AAi5FJ;;AAt8FE;EACE,wBAAA;AAy8FJ;;AAt8FE;EACE,6BAAA;AAy8FJ;;AAt8FE;EACE,8BAAA;AAy8FJ;;AAt8FE;EACE,4BAAA;AAy8FJ;;AAt8FE;EACE,+BAAA;AAy8FJ;;AAt8FE;EACE,+BAAA;AAy8FJ;;AAt8FE;EACE,8BAAA;AAy8FJ;;AAt8FE;EACE,uBAAA;AAy8FJ;;AAt8FE;EACE,4BAAA;AAy8FJ;;AAt8FE;EACE,6BAAA;AAy8FJ;;AAt8FE;EACE,2BAAA;AAy8FJ;;AAt8FE;EACE,8BAAA;AAy8FJ;;AAt8FE;EACE,8BAAA;AAy8FJ;;AAt8FE;EACE,6BAAA;AAy8FJ;;AA9/FE;EACE,wBAAA;AAigGJ;;AA9/FE;EACE,6BAAA;AAigGJ;;AA9/FE;EACE,8BAAA;AAigGJ;;AA9/FE;EACE,4BAAA;AAigGJ;;AA9/FE;EACE,+BAAA;AAigGJ;;AA9/FE;EACE,+BAAA;AAigGJ;;AA9/FE;EACE,8BAAA;AAigGJ;;AA9/FE;EACE,uBAAA;AAigGJ;;AA9/FE;EACE,4BAAA;AAigGJ;;AA9/FE;EACE,6BAAA;AAigGJ;;AA9/FE;EACE,2BAAA;AAigGJ;;AA9/FE;EACE,8BAAA;AAigGJ;;AA9/FE;EACE,8BAAA;AAigGJ;;AA9/FE;EACE,6BAAA;AAigGJ;;AAtjGE;EACE,wBAAA;AAyjGJ;;AAtjGE;EACE,6BAAA;AAyjGJ;;AAtjGE;EACE,8BAAA;AAyjGJ;;AAtjGE;EACE,4BAAA;AAyjGJ;;AAtjGE;EACE,+BAAA;AAyjGJ;;AAtjGE;EACE,+BAAA;AAyjGJ;;AAtjGE;EACE,8BAAA;AAyjGJ;;AAtjGE;EACE,uBAAA;AAyjGJ;;AAtjGE;EACE,4BAAA;AAyjGJ;;AAtjGE;EACE,6BAAA;AAyjGJ;;AAtjGE;EACE,2BAAA;AAyjGJ;;AAtjGE;EACE,8BAAA;AAyjGJ;;AAtjGE;EACE,8BAAA;AAyjGJ;;AAtjGE;EACE,6BAAA;AAyjGJ;;AA9mGE;EACE,wBAAA;AAinGJ;;AA9mGE;EACE,6BAAA;AAinGJ;;AA9mGE;EACE,8BAAA;AAinGJ;;AA9mGE;EACE,4BAAA;AAinGJ;;AA9mGE;EACE,+BAAA;AAinGJ;;AA9mGE;EACE,+BAAA;AAinGJ;;AA9mGE;EACE,8BAAA;AAinGJ;;AA9mGE;EACE,uBAAA;AAinGJ;;AA9mGE;EACE,4BAAA;AAinGJ;;AA9mGE;EACE,6BAAA;AAinGJ;;AA9mGE;EACE,2BAAA;AAinGJ;;AA9mGE;EACE,8BAAA;AAinGJ;;AA9mGE;EACE,8BAAA;AAinGJ;;AA9mGE;EACE,6BAAA;AAinGJ;;AA7mGA;EACE,kBAAA;AAgnGF;;AA7mGA;EACE,kBAAA;AAgnGF;;AApmGA,oCAAA;AAGA;EACE,6BAAA;AAqmGF;;AAnmGA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;AAsmGF;;AAnmGA;;;;;;;;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,6BAAA;EAGA,gBAAA;AA6mGF;;AAzmGA,iBAAA;AAIA;EACE,yBAAA;EACA,4CAAA;AAymGF;AAtmGA;EACE,gCAAA;EACA,4CAAA;AAwmGF;AArmGA;EACE,+BAAA;EACA,4CAAA;AAumGF;AApmGA;EACE,oCAAA;AAsmGF;;AAnmGA;EACE,2CAAA;AAsmGF;;AAnmGA;EACE,0CAAA;AAsmGF;;AAlmGA;EACE,wBAAA;EACA,4CAAA;AAqmGF;AAlmGA;EACE,mCAAA;AAomGF;;AA/lGA;EACE,yBAAA;EACA,+DAAA;AAkmGF;AA/lGA;EACE,oCAAA;AAimGF;;AA9lGA;EACE,oBAAA;EACA,4CAAA;AAimGF;AA9lGA;EACE,+BAAA;AAgmGF;;AA9kGA;EACE,2BAAA;EACA,sgBAAA;EAMA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;AA4kGF;AAzkGA;EACE,sCAAA;EACA,gBAAA;AA2kGF;;AAxkGA;EACE,0BAAA;EACA,4CAAA;AA2kGF;AAzkGA;EACE,qCAAA;EACA,gBAAA;AA2kGF;;AAxkGA;EACE,qCAAA;EACA,gBAAA;AA2kGF;;AAxkGA;EACE,qBAAA;EACA,0EAAA;EACA,mdAAA;AA2kGF;AA3jGA;EACE,gCAAA;AA6jGF;;AA1jGA;EACE,4BAAA;EACA,4CAAA;AA6jGF;AAhjGA;EACE,uCAAA;AAkjGF;;AA/iGA,qBAAA;AAEA;EACE,wBAAA;EACA,gBAAA;EACA,qBAAA;EAEA,YAAA;AAgjGF;AA/iGE;EACE,aAAA;AAijGJ;;AA7iGA,YAAA;AACA;EACE,yBAAA;AAgjGF;;AA9iGA;EACE,yBAAA;AAijGF;;AA/iGA;EACE,yBAAA;AAkjGF;;AAhjGA;EACE,yBAAA;AAmjGF;;AAjjGA;EACE,yBAAA;AAojGF;;AAljGA,gBAAA;AAEA,yBAAA;AACA;EACE,SAAA;AAojGF;;AA3iGE;EACE,SAAA;AA8iGJ;AA7iGI;EAFF;IAGI,SAAA;EAgjGJ;AACF;;AA5iGA;EACE,8EAAA;EACA;;;;;;;;;GAAA;EAWA,YAAA;AA8iGF;AA5iGE;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,+BAAA;AA8iGJ;AA3iGE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,mBChYS;EDiYT,+BAAA;AA6iGJ;AA1iGE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,2BAAA;AA4iGJ;AAziGE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,2BAAA;EAEA,qBAAA;AA2iGJ;AAxiGE;EACE,YAAA;AA0iGJ;;AAriGE;EACE,mBC/Zc;EDgad,eAAA;AAwiGJ;AAriGE;EACE,mBCpac;AD28GlB;AApiGE;EACE,mBCxac;AD88GlB;AAniGE;EACE,cC5ac;ADi9GlB;;AAjiGA;EAKE,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;AAgiGF;AA/hGE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;EACA,sJAAA;AAiiGJ;AA/hGI;EACE,WAAA;EACA,kBAAA;EACA,yBClcO;EDmcP,sJAAA;EACA,YAnBW;AAojGjB;AA7hGE;EACE,6BAAA;EACA,SAAA;EACA,sBAAA;EACA,cC3cc;ED4cd,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,0BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;AA+hGJ;AA5hGE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;AA8hGJ;AA1hGI;EACE,yBAAA;AA4hGN;AAzhGI;EACE,UAAA;AA2hGN;;AAthGA,6BAAA;AAEA,aAAA;AA4hBA;EA1gBE,wBAAA;EAuBA,4BAAA;AAk/FF;AAt/FE;EACE,oCAAA;AAw/FJ;AAp/FE;EACE,yCAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EAEA,wBAAA;EACA,+zBAAA;EA2DA,2BAAA;AA27FJ;AAz7FE;EACE,yCAAA;EACA,iBAAA;EACA,WAAA;EACA,wBAAA;EACA,WAAA;EAEA,wBAAA;EACA,2aAAA;EA0CA,2BAAA;AAi5FJ;AA94FE;EAOE,YApK8B;EAqK9B,eAPY;EAQZ,YAAA;EAEA,wBC5oBS;ADqhHb;AAj5FI;EACE,eAHU;AAs5FhB;AAr4FE;EACE,oCAAA;EACA,YA9Ka;AAqjGjB;AAr4FE;EACE,yBAAA;EACA,YAlLa;AAyjGjB;AAl4FI;EACE,eAAA;EACA,kBAAA;AAo4FN;AA/3FI;EACE,eAAA;EACA,yBAAA;EACA,iBAAA;AAi4FN;AA93FI;EACE,WAAA;EACA,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;AAg4FN;AA93FM;EACE,yBAAA;AAg4FR;AA53FM;EACE,iBAAA;AA83FR;AA33FM;EACE,iBAAA;AA63FR;AAz3FI;EACE,WAAA;EACA,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;AA23FN;AAh3FI;EACE,WAAA;EACA,YAAA;EAEA,kBAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;AAi3FN;AAh3FM;EAEE,0DAAA;AAi3FR;AA72FI;EACE,WAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;AA+2FN;AA72FQ;EACE,gBAAA;EACA,+BAAA;AA+2FV;AA52FQ;EACE,UAAA;EACA,UAAA;AA82FV;AAz2FI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;AA22FN;AA12FM;EACE,sBAAA;EACA,0DAAA;AA42FR;AAx2FI;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EAEA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;AAy2FN;AAx2FM;EACE,yBC3xBK;ED4xBL,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cC9xBM;ED+xBN,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,gCAAA;AA02FR;AAv2FQ;EACE,eAAA;EACA,gBAAA;EACA,yDAAA;EACA,aClzBM;AD2pHhB;AAv2FQ;EACE,aCrzBM;AD8pHhB;AAv2FQ;EACE,UAAA;EACA,UAAA;AAy2FV;AAl2FI;EACE,eAAA;EACA,UAAA;EACA,kBAAA;AAo2FN;AAl2FM;EACE,yBCn0BK;EDo0BL,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cCt0BM;EDu0BN,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,gCAAA;AAo2FR;AAj2FQ;EACE,UAAA;EACA,eAAA;EACA,gBAAA;EACA,yDAAA;EACA,aC31BM;AD8rHhB;AAj2FQ;EACE,aC91BM;ADisHhB;AAj2FQ;EACE,UAAA;EACA,UAAA;AAm2FV;AA91FI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAg2FN;AA51FI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AA81FN;AA11FI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AA41FN;AAx1FI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AA01FN;AAt1FI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAw1FN;AAp1FI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAs1FN;AAl1FI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAo1FN;AAj1FI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,aAAA;AAm1FN;AAj1FI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAm1FN;AA/0FI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAi1FN;AA70FI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AA+0FN;AA90FM;EACE,0DAAA;AAg1FR;AA70FI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AA+0FN;AA10FI;EACE,YAteyD;AAkzG/D;AAz0FI;EACE,eAAA;AA20FN;AAx0FI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,gBAAA;EACA,eAAA;AA00FN;AAt0FI;EACE,0DAAA;AAw0FN;AAr0FI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EAEA,qBAAA;EACA,gBAAA;EACA,eAAA;AAu0FN;AAn0FI;EACE,0DAAA;EAEA,qBAAA;AAq0FN;;AA5zFA;EA9gBE,wBAAA;EAuBA,4BAAA;AAwzGF;AA5zGE;EACE,oCAAA;AA8zGJ;AA1zGE;EACE,yCAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EAEA,wBAAA;EACA,+zBAAA;EA2DA,2BAAA;AAiwGJ;AA/vGE;EACE,yCAAA;EACA,iBAAA;EACA,WAAA;EACA,wBAAA;EACA,WAAA;EAEA,wBAAA;EACA,2aAAA;EA0CA,2BAAA;AAutGJ;AAptGE;EAOE,YAsX6B;EArX7B,eAPY;EAQZ,YAAA;EAEA,wBC5oBS;AD21Hb;AAvtGI;EACE,eAHU;AA4tGhB;AA3sGE;EACE,oCAAA;EACA,YA9Ka;AA23GjB;AA3sGE;EACE,yBAAA;EACA,YAlLa;AA+3GjB;AAxsGI;EACE,eAAA;EACA,kBAAA;AA0sGN;AArsGI;EACE,eAAA;EACA,yBAAA;EACA,iBAAA;AAusGN;AApsGI;EACE,WAAA;EACA,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;AAssGN;AApsGM;EACE,yBAAA;AAssGR;AAlsGM;EACE,iBAAA;AAosGR;AAjsGM;EACE,iBAAA;AAmsGR;AA/rGI;EACE,WAAA;EACA,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;AAisGN;AAtrGI;EACE,WAAA;EACA,YAAA;EAEA,kBAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;AAurGN;AAtrGM;EAEE,0DAAA;AAurGR;AAnrGI;EACE,WAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;AAqrGN;AAnrGQ;EACE,gBAAA;EACA,+BAAA;AAqrGV;AAlrGQ;EACE,UAAA;EACA,UAAA;AAorGV;AA/qGI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;AAirGN;AAhrGM;EACE,sBAAA;EACA,0DAAA;AAkrGR;AA9qGI;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EAEA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;AA+qGN;AA9qGM;EACE,yBC3xBK;ED4xBL,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cC9xBM;ED+xBN,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,gCAAA;AAgrGR;AA7qGQ;EACE,eAAA;EACA,gBAAA;EACA,yDAAA;EACA,aClzBM;ADi+HhB;AA7qGQ;EACE,aCrzBM;ADo+HhB;AA7qGQ;EACE,UAAA;EACA,UAAA;AA+qGV;AAxqGI;EACE,eAAA;EACA,UAAA;EACA,kBAAA;AA0qGN;AAxqGM;EACE,yBCn0BK;EDo0BL,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cCt0BM;EDu0BN,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,gCAAA;AA0qGR;AAvqGQ;EACE,UAAA;EACA,eAAA;EACA,gBAAA;EACA,yDAAA;EACA,aC31BM;ADogIhB;AAvqGQ;EACE,aC91BM;ADugIhB;AAvqGQ;EACE,UAAA;EACA,UAAA;AAyqGV;AApqGI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAsqGN;AAlqGI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAoqGN;AAhqGI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAkqGN;AA9pGI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAgqGN;AA5pGI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AA8pGN;AA1pGI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AA4pGN;AAxpGI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AA0pGN;AAvpGI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,aAAA;AAypGN;AAvpGI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAypGN;AArpGI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAupGN;AAnpGI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAqpGN;AAppGM;EACE,0DAAA;AAspGR;AAnpGI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAqpGN;AAhpGI;EACE,YAteyD;AAwnH/D;AA/oGI;EACE,eAAA;AAipGN;AA9oGI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,gBAAA;EACA,eAAA;AAgpGN;AA5oGI;EACE,0DAAA;AA8oGN;AA3oGI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EAEA,qBAAA;EACA,gBAAA;EACA,eAAA;AA6oGN;AAzoGI;EACE,0DAAA;EAEA,qBAAA;AA2oGN;;AA9nGA;EAlhBE,wBAAA;EAuBA,4BAAA;AA8nHF;AAloHE;EACE,oCAAA;AAooHJ;AAhoHE;EACE,yCAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EAEA,wBAAA;EACA,+zBAAA;EA2DA,2BAAA;AAukHJ;AArkHE;EACE,yCAAA;EACA,iBAAA;EACA,WAAA;EACA,wBAAA;EACA,WAAA;EAEA,wBAAA;EACA,2aAAA;EA0CA,2BAAA;AA6hHJ;AA1hHE;EAOE,YA0X6B;EAzX7B,eAPY;EAQZ,YAAA;EAEA,wBC5oBS;ADiqIb;AA7hHI;EACE,eAHU;AAkiHhB;AAjhHE;EACE,oCAAA;EACA,YA9Ka;AAisHjB;AAjhHE;EACE,yBAAA;EACA,YAlLa;AAqsHjB;AA9gHI;EACE,eAAA;EACA,kBAAA;AAghHN;AA3gHI;EACE,eAAA;EACA,yBAAA;EACA,iBAAA;AA6gHN;AA1gHI;EACE,WAAA;EACA,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;AA4gHN;AA1gHM;EACE,yBAAA;AA4gHR;AAxgHM;EACE,iBAAA;AA0gHR;AAvgHM;EACE,iBAAA;AAygHR;AArgHI;EACE,WAAA;EACA,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;AAugHN;AA5/GI;EACE,WAAA;EACA,YAAA;EAEA,kBAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;AA6/GN;AA5/GM;EAEE,0DAAA;AA6/GR;AAz/GI;EACE,WAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;AA2/GN;AAz/GQ;EACE,gBAAA;EACA,+BAAA;AA2/GV;AAx/GQ;EACE,UAAA;EACA,UAAA;AA0/GV;AAr/GI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;AAu/GN;AAt/GM;EACE,sBAAA;EACA,0DAAA;AAw/GR;AAp/GI;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EAEA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;AAq/GN;AAp/GM;EACE,yBC3xBK;ED4xBL,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cC9xBM;ED+xBN,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,gCAAA;AAs/GR;AAn/GQ;EACE,eAAA;EACA,gBAAA;EACA,yDAAA;EACA,aClzBM;ADuyIhB;AAn/GQ;EACE,aCrzBM;AD0yIhB;AAn/GQ;EACE,UAAA;EACA,UAAA;AAq/GV;AA9+GI;EACE,eAAA;EACA,UAAA;EACA,kBAAA;AAg/GN;AA9+GM;EACE,yBCn0BK;EDo0BL,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cCt0BM;EDu0BN,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,gCAAA;AAg/GR;AA7+GQ;EACE,UAAA;EACA,eAAA;EACA,gBAAA;EACA,yDAAA;EACA,aC31BM;AD00IhB;AA7+GQ;EACE,aC91BM;AD60IhB;AA7+GQ;EACE,UAAA;EACA,UAAA;AA++GV;AA1+GI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AA4+GN;AAx+GI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AA0+GN;AAt+GI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAw+GN;AAp+GI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAs+GN;AAl+GI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAo+GN;AAh+GI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAk+GN;AA99GI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAg+GN;AA79GI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,aAAA;AA+9GN;AA79GI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AA+9GN;AA39GI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AA69GN;AAz9GI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AA29GN;AA19GM;EACE,0DAAA;AA49GR;AAz9GI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AA29GN;AAt9GI;EACE,YAteyD;AA87H/D;AAr9GI;EACE,eAAA;AAu9GN;AAp9GI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,gBAAA;EACA,eAAA;AAs9GN;AAl9GI;EACE,0DAAA;AAo9GN;AAj9GI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EAEA,qBAAA;EACA,gBAAA;EACA,eAAA;AAm9GN;AA/8GI;EACE,0DAAA;EAEA,qBAAA;AAi9GN;;AAh8GA;EAthBE,wBAAA;EAuBA,4BAAA;AAo8HF;AAx8HE;EACE,oCAAA;AA08HJ;AAt8HE;EACE,yCAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EAEA,wBAAA;EACA,+zBAAA;EA2DA,2BAAA;AA64HJ;AA34HE;EACE,yCAAA;EACA,iBAAA;EACA,WAAA;EACA,wBAAA;EACA,WAAA;EAEA,wBAAA;EACA,2aAAA;EA0CA,2BAAA;AAm2HJ;AAh2HE;EAOE,YA8X6B;EA7X7B,eAPY;EAQZ,YAAA;EAEA,wBC5oBS;ADu+Ib;AAn2HI;EACE,eAHU;AAw2HhB;AAv1HE;EACE,oCAAA;EACA,YA9Ka;AAugIjB;AAv1HE;EACE,yBAAA;EACA,YAlLa;AA2gIjB;AAp1HI;EACE,eAAA;EACA,kBAAA;AAs1HN;AAj1HI;EACE,eAAA;EACA,yBAAA;EACA,iBAAA;AAm1HN;AAh1HI;EACE,WAAA;EACA,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;AAk1HN;AAh1HM;EACE,yBAAA;AAk1HR;AA90HM;EACE,iBAAA;AAg1HR;AA70HM;EACE,iBAAA;AA+0HR;AA30HI;EACE,WAAA;EACA,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;AA60HN;AAl0HI;EACE,WAAA;EACA,YAAA;EAEA,kBAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;AAm0HN;AAl0HM;EAEE,0DAAA;AAm0HR;AA/zHI;EACE,WAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;AAi0HN;AA/zHQ;EACE,gBAAA;EACA,+BAAA;AAi0HV;AA9zHQ;EACE,UAAA;EACA,UAAA;AAg0HV;AA3zHI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;AA6zHN;AA5zHM;EACE,sBAAA;EACA,0DAAA;AA8zHR;AA1zHI;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EAEA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;AA2zHN;AA1zHM;EACE,yBC3xBK;ED4xBL,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cC9xBM;ED+xBN,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,gCAAA;AA4zHR;AAzzHQ;EACE,eAAA;EACA,gBAAA;EACA,yDAAA;EACA,aClzBM;AD6mJhB;AAzzHQ;EACE,aCrzBM;ADgnJhB;AAzzHQ;EACE,UAAA;EACA,UAAA;AA2zHV;AApzHI;EACE,eAAA;EACA,UAAA;EACA,kBAAA;AAszHN;AApzHM;EACE,yBCn0BK;EDo0BL,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cCt0BM;EDu0BN,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,gCAAA;AAszHR;AAnzHQ;EACE,UAAA;EACA,eAAA;EACA,gBAAA;EACA,yDAAA;EACA,aC31BM;ADgpJhB;AAnzHQ;EACE,aC91BM;ADmpJhB;AAnzHQ;EACE,UAAA;EACA,UAAA;AAqzHV;AAhzHI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAkzHN;AA9yHI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAgzHN;AA5yHI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AA8yHN;AA1yHI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AA4yHN;AAxyHI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AA0yHN;AAtyHI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAwyHN;AApyHI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAsyHN;AAnyHI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,aAAA;AAqyHN;AAnyHI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAqyHN;AAjyHI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAmyHN;AA/xHI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAiyHN;AAhyHM;EACE,0DAAA;AAkyHR;AA/xHI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAiyHN;AA5xHI;EACE,YAteyD;AAowI/D;AA3xHI;EACE,eAAA;AA6xHN;AA1xHI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,gBAAA;EACA,eAAA;AA4xHN;AAxxHI;EACE,0DAAA;AA0xHN;AAvxHI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EAEA,qBAAA;EACA,gBAAA;EACA,eAAA;AAyxHN;AArxHI;EACE,0DAAA;EAEA,qBAAA;AAuxHN;;AAlwHA;EA1hBE,wBAAA;EAuBA,4BAAA;AA0wIF;AA9wIE;EACE,oCAAA;AAgxIJ;AA5wIE;EACE,yCAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EAEA,wBAAA;EACA,+zBAAA;EA2DA,2BAAA;AAmtIJ;AAjtIE;EACE,yCAAA;EACA,iBAAA;EACA,WAAA;EACA,wBAAA;EACA,WAAA;EAEA,wBAAA;EACA,2aAAA;EA0CA,2BAAA;AAyqIJ;AAtqIE;EAOE,YAkY6B;EAjY7B,eAPY;EAQZ,YAAA;EAEA,wBC5oBS;AD6yJb;AAzqII;EACE,eAHU;AA8qIhB;AA7pIE;EACE,oCAAA;EACA,YA9Ka;AA60IjB;AA7pIE;EACE,yBAAA;EACA,YAlLa;AAi1IjB;AA1pII;EACE,eAAA;EACA,kBAAA;AA4pIN;AAvpII;EACE,eAAA;EACA,yBAAA;EACA,iBAAA;AAypIN;AAtpII;EACE,WAAA;EACA,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;AAwpIN;AAtpIM;EACE,yBAAA;AAwpIR;AAppIM;EACE,iBAAA;AAspIR;AAnpIM;EACE,iBAAA;AAqpIR;AAjpII;EACE,WAAA;EACA,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;AAmpIN;AAxoII;EACE,WAAA;EACA,YAAA;EAEA,kBAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;AAyoIN;AAxoIM;EAEE,0DAAA;AAyoIR;AAroII;EACE,WAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;AAuoIN;AAroIQ;EACE,gBAAA;EACA,+BAAA;AAuoIV;AApoIQ;EACE,UAAA;EACA,UAAA;AAsoIV;AAjoII;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;AAmoIN;AAloIM;EACE,sBAAA;EACA,0DAAA;AAooIR;AAhoII;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EAEA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;AAioIN;AAhoIM;EACE,yBC3xBK;ED4xBL,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cC9xBM;ED+xBN,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,gCAAA;AAkoIR;AA/nIQ;EACE,eAAA;EACA,gBAAA;EACA,yDAAA;EACA,aClzBM;ADm7JhB;AA/nIQ;EACE,aCrzBM;ADs7JhB;AA/nIQ;EACE,UAAA;EACA,UAAA;AAioIV;AA1nII;EACE,eAAA;EACA,UAAA;EACA,kBAAA;AA4nIN;AA1nIM;EACE,yBCn0BK;EDo0BL,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cCt0BM;EDu0BN,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,gCAAA;AA4nIR;AAznIQ;EACE,UAAA;EACA,eAAA;EACA,gBAAA;EACA,yDAAA;EACA,aC31BM;ADs9JhB;AAznIQ;EACE,aC91BM;ADy9JhB;AAznIQ;EACE,UAAA;EACA,UAAA;AA2nIV;AAtnII;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAwnIN;AApnII;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAsnIN;AAlnII;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAonIN;AAhnII;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAknIN;AA9mII;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAgnIN;AA5mII;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AA8mIN;AA1mII;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AA4mIN;AAzmII;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,aAAA;AA2mIN;AAzmII;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AA2mIN;AAvmII;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAymIN;AArmII;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAumIN;AAtmIM;EACE,0DAAA;AAwmIR;AArmII;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAumIN;AAlmII;EACE,YAteyD;AA0kJ/D;AAjmII;EACE,eAAA;AAmmIN;AAhmII;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,gBAAA;EACA,eAAA;AAkmIN;AA9lII;EACE,0DAAA;AAgmIN;AA7lII;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EAEA,qBAAA;EACA,gBAAA;EACA,eAAA;AA+lIN;AA3lII;EACE,0DAAA;EAEA,qBAAA;AA6lIN;;AApkIA;EA9hBE,wBAAA;EAuBA,4BAAA;AAglJF;AAplJE;EACE,oCAAA;AAslJJ;AAllJE;EACE,yCAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EAEA,wBAAA;EACA,+zBAAA;EA2DA,2BAAA;AAyhJJ;AAvhJE;EACE,yCAAA;EACA,iBAAA;EACA,WAAA;EACA,wBAAA;EACA,WAAA;EAEA,wBAAA;EACA,2aAAA;EA0CA,2BAAA;AA++IJ;AA5+IE;EAOE,YAsY6B;EArY7B,eAPY;EAQZ,YAAA;EAEA,wBC5oBS;ADmnKb;AA/+II;EACE,eAHU;AAo/IhB;AAn+IE;EACE,oCAAA;EACA,YA9Ka;AAmpJjB;AAn+IE;EACE,yBAAA;EACA,YAlLa;AAupJjB;AAh+II;EACE,eAAA;EACA,kBAAA;AAk+IN;AA79II;EACE,eAAA;EACA,yBAAA;EACA,iBAAA;AA+9IN;AA59II;EACE,WAAA;EACA,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;AA89IN;AA59IM;EACE,yBAAA;AA89IR;AA19IM;EACE,iBAAA;AA49IR;AAz9IM;EACE,iBAAA;AA29IR;AAv9II;EACE,WAAA;EACA,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;AAy9IN;AA98II;EACE,WAAA;EACA,YAAA;EAEA,kBAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;AA+8IN;AA98IM;EAEE,0DAAA;AA+8IR;AA38II;EACE,WAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;AA68IN;AA38IQ;EACE,gBAAA;EACA,+BAAA;AA68IV;AA18IQ;EACE,UAAA;EACA,UAAA;AA48IV;AAv8II;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;AAy8IN;AAx8IM;EACE,sBAAA;EACA,0DAAA;AA08IR;AAt8II;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EAEA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;AAu8IN;AAt8IM;EACE,yBC3xBK;ED4xBL,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cC9xBM;ED+xBN,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,gCAAA;AAw8IR;AAr8IQ;EACE,eAAA;EACA,gBAAA;EACA,yDAAA;EACA,aClzBM;ADyvKhB;AAr8IQ;EACE,aCrzBM;AD4vKhB;AAr8IQ;EACE,UAAA;EACA,UAAA;AAu8IV;AAh8II;EACE,eAAA;EACA,UAAA;EACA,kBAAA;AAk8IN;AAh8IM;EACE,yBCn0BK;EDo0BL,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cCt0BM;EDu0BN,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,gCAAA;AAk8IR;AA/7IQ;EACE,UAAA;EACA,eAAA;EACA,gBAAA;EACA,yDAAA;EACA,aC31BM;AD4xKhB;AA/7IQ;EACE,aC91BM;AD+xKhB;AA/7IQ;EACE,UAAA;EACA,UAAA;AAi8IV;AA57II;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AA87IN;AA17II;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AA47IN;AAx7II;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AA07IN;AAt7II;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAw7IN;AAp7II;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAs7IN;AAl7II;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAo7IN;AAh7II;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAk7IN;AA/6II;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,aAAA;AAi7IN;AA/6II;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAi7IN;AA76II;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AA+6IN;AA36II;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AA66IN;AA56IM;EACE,0DAAA;AA86IR;AA36II;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AA66IN;AAx6II;EACE,YAteyD;AAg5J/D;AAv6II;EACE,eAAA;AAy6IN;AAt6II;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,gBAAA;EACA,eAAA;AAw6IN;AAp6II;EACE,0DAAA;AAs6IN;AAn6II;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EAEA,qBAAA;EACA,gBAAA;EACA,eAAA;AAq6IN;AAj6II;EACE,0DAAA;EAEA,qBAAA;AAm6IN;;AAv4IA;EAjiBE,wBAAA;EAuBA,4BAAA;AAs5JF;AA15JE;EACE,oCAAA;AA45JJ;AAx5JE;EACE,yCAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EAEA,wBAAA;EACA,+zBAAA;EA2DA,2BAAA;AA+1JJ;AA71JE;EACE,yCAAA;EACA,iBAAA;EACA,WAAA;EACA,wBAAA;EACA,WAAA;EAEA,wBAAA;EACA,2aAAA;EA0CA,2BAAA;AAqzJJ;AAlzJE;EAOE,YAyY6B;EAxY7B,eAPY;EAQZ,YAAA;EAEA,wBC5oBS;ADy7Kb;AArzJI;EACE,eAHU;AA0zJhB;AAzyJE;EACE,oCAAA;EACA,YA9Ka;AAy9JjB;AAzyJE;EACE,yBAAA;EACA,YAlLa;AA69JjB;AAtyJI;EACE,eAAA;EACA,kBAAA;AAwyJN;AAnyJI;EACE,eAAA;EACA,yBAAA;EACA,iBAAA;AAqyJN;AAlyJI;EACE,WAAA;EACA,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;AAoyJN;AAlyJM;EACE,yBAAA;AAoyJR;AAhyJM;EACE,iBAAA;AAkyJR;AA/xJM;EACE,iBAAA;AAiyJR;AA7xJI;EACE,WAAA;EACA,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;AA+xJN;AApxJI;EACE,WAAA;EACA,YAAA;EAEA,kBAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;AAqxJN;AApxJM;EAEE,0DAAA;AAqxJR;AAjxJI;EACE,WAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;AAmxJN;AAjxJQ;EACE,gBAAA;EACA,+BAAA;AAmxJV;AAhxJQ;EACE,UAAA;EACA,UAAA;AAkxJV;AA7wJI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;AA+wJN;AA9wJM;EACE,sBAAA;EACA,0DAAA;AAgxJR;AA5wJI;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EAEA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;AA6wJN;AA5wJM;EACE,yBC3xBK;ED4xBL,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cC9xBM;ED+xBN,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,gCAAA;AA8wJR;AA3wJQ;EACE,eAAA;EACA,gBAAA;EACA,yDAAA;EACA,aClzBM;AD+jLhB;AA3wJQ;EACE,aCrzBM;ADkkLhB;AA3wJQ;EACE,UAAA;EACA,UAAA;AA6wJV;AAtwJI;EACE,eAAA;EACA,UAAA;EACA,kBAAA;AAwwJN;AAtwJM;EACE,yBCn0BK;EDo0BL,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cCt0BM;EDu0BN,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,gCAAA;AAwwJR;AArwJQ;EACE,UAAA;EACA,eAAA;EACA,gBAAA;EACA,yDAAA;EACA,aC31BM;ADkmLhB;AArwJQ;EACE,aC91BM;ADqmLhB;AArwJQ;EACE,UAAA;EACA,UAAA;AAuwJV;AAlwJI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAowJN;AAhwJI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAkwJN;AA9vJI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAgwJN;AA5vJI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AA8vJN;AA1vJI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AA4vJN;AAxvJI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AA0vJN;AAtvJI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAwvJN;AArvJI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,aAAA;AAuvJN;AArvJI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAuvJN;AAnvJI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAqvJN;AAjvJI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAmvJN;AAlvJM;EACE,0DAAA;AAovJR;AAjvJI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAmvJN;AA9uJI;EACE,YAteyD;AAstK/D;AA7uJI;EACE,eAAA;AA+uJN;AA5uJI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,gBAAA;EACA,eAAA;AA8uJN;AA1uJI;EACE,0DAAA;AA4uJN;AAzuJI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EAEA,qBAAA;EACA,gBAAA;EACA,eAAA;AA2uJN;AAvuJI;EACE,0DAAA;EAEA,qBAAA;AAyuJN;;AAzsJA;EAriBE,wBAAA;EAuBA,4BAAA;AA4tKF;AAhuKE;EACE,oCAAA;AAkuKJ;AA9tKE;EACE,yCAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EAEA,wBAAA;EACA,20BAAA;EA2DA,2BAAA;AAqqKJ;AAnqKE;EACE,yCAAA;EACA,iBAAA;EACA,WAAA;EACA,wBAAA;EACA,WAAA;EAEA,wBAAA;EACA,ubAAA;EA0CA,2BAAA;AA2nKJ;AAxnKE;EAOE,eA6Y6B;EA5Y7B,eAPY;EAQZ,YAAA;EAEA,wBC5oBS;AD+vLb;AA3nKI;EACE,eAHU;AAgoKhB;AA/mKE;EACE,oCAAA;EACA,YA9Ka;AA+xKjB;AA/mKE;EACE,4BAAA;EACA,YAlLa;AAmyKjB;AA5mKI;EACE,eAAA;EACA,kBAAA;AA8mKN;AAzmKI;EACE,eAAA;EACA,yBAAA;EACA,iBAAA;AA2mKN;AAxmKI;EACE,WAAA;EACA,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;AA0mKN;AAxmKM;EACE,yBAAA;AA0mKR;AAtmKM;EACE,iBAAA;AAwmKR;AArmKM;EACE,iBAAA;AAumKR;AAnmKI;EACE,WAAA;EACA,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;AAqmKN;AA1lKI;EACE,WAAA;EACA,YAAA;EAEA,kBAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;AA2lKN;AA1lKM;EAEE,0DAAA;AA2lKR;AAvlKI;EACE,WAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;AAylKN;AAvlKQ;EACE,gBAAA;EACA,+BAAA;AAylKV;AAtlKQ;EACE,UAAA;EACA,UAAA;AAwlKV;AAnlKI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;AAqlKN;AAplKM;EACE,sBAAA;EACA,0DAAA;AAslKR;AAllKI;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EAEA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;AAmlKN;AAllKM;EACE,yBC3xBK;ED4xBL,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cC9xBM;ED+xBN,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,gCAAA;AAolKR;AAjlKQ;EACE,eAAA;EACA,gBAAA;EACA,yDAAA;EACA,aClzBM;ADq4LhB;AAjlKQ;EACE,aCrzBM;ADw4LhB;AAjlKQ;EACE,UAAA;EACA,UAAA;AAmlKV;AA5kKI;EACE,eAAA;EACA,UAAA;EACA,kBAAA;AA8kKN;AA5kKM;EACE,yBCn0BK;EDo0BL,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cCt0BM;EDu0BN,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,gCAAA;AA8kKR;AA3kKQ;EACE,UAAA;EACA,eAAA;EACA,gBAAA;EACA,yDAAA;EACA,aC31BM;ADw6LhB;AA3kKQ;EACE,aC91BM;AD26LhB;AA3kKQ;EACE,UAAA;EACA,UAAA;AA6kKV;AAxkKI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AA0kKN;AAtkKI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAwkKN;AApkKI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAskKN;AAlkKI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAokKN;AAhkKI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAkkKN;AA9jKI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAgkKN;AA5jKI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AA8jKN;AA3jKI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,aAAA;AA6jKN;AA3jKI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AA6jKN;AAzjKI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AA2jKN;AAvjKI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAyjKN;AAxjKM;EACE,0DAAA;AA0jKR;AAvjKI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAyjKN;AApjKI;EACE,YAteyD;AA4hL/D;AAnjKI;EACE,eAAA;AAqjKN;AAljKI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,gBAAA;EACA,eAAA;AAojKN;AAhjKI;EACE,0DAAA;AAkjKN;AA/iKI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EAEA,qBAAA;EACA,gBAAA;EACA,eAAA;AAijKN;AA7iKI;EACE,0DAAA;EAEA,qBAAA;AA+iKN;;AA3gKA;EAziBE,wBAAA;EAuBA,4BAAA;AAkiLF;AAtiLE;EACE,oCAAA;AAwiLJ;AApiLE;EACE,yCAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EAEA,wBAAA;EACA,20BAAA;EA2DA,2BAAA;AA2+KJ;AAz+KE;EACE,yCAAA;EACA,iBAAA;EACA,WAAA;EACA,wBAAA;EACA,WAAA;EAEA,wBAAA;EACA,ubAAA;EA0CA,2BAAA;AAi8KJ;AA97KE;EAOE,eAiZ0B;EAhZ1B,eAPY;EAQZ,YAAA;EAEA,wBC5oBS;ADqkMb;AAj8KI;EACE,eAHU;AAs8KhB;AAr7KE;EACE,oCAAA;EACA,YA9Ka;AAqmLjB;AAr7KE;EACE,4BAAA;EACA,YAlLa;AAymLjB;AAl7KI;EACE,eAAA;EACA,kBAAA;AAo7KN;AA/6KI;EACE,eAAA;EACA,yBAAA;EACA,iBAAA;AAi7KN;AA96KI;EACE,WAAA;EACA,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;AAg7KN;AA96KM;EACE,yBAAA;AAg7KR;AA56KM;EACE,iBAAA;AA86KR;AA36KM;EACE,iBAAA;AA66KR;AAz6KI;EACE,WAAA;EACA,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;AA26KN;AAh6KI;EACE,WAAA;EACA,YAAA;EAEA,kBAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;AAi6KN;AAh6KM;EAEE,0DAAA;AAi6KR;AA75KI;EACE,WAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;AA+5KN;AA75KQ;EACE,gBAAA;EACA,+BAAA;AA+5KV;AA55KQ;EACE,UAAA;EACA,UAAA;AA85KV;AAz5KI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;AA25KN;AA15KM;EACE,sBAAA;EACA,0DAAA;AA45KR;AAx5KI;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EAEA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;AAy5KN;AAx5KM;EACE,yBC3xBK;ED4xBL,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cC9xBM;ED+xBN,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,gCAAA;AA05KR;AAv5KQ;EACE,eAAA;EACA,gBAAA;EACA,yDAAA;EACA,aClzBM;AD2sMhB;AAv5KQ;EACE,aCrzBM;AD8sMhB;AAv5KQ;EACE,UAAA;EACA,UAAA;AAy5KV;AAl5KI;EACE,eAAA;EACA,UAAA;EACA,kBAAA;AAo5KN;AAl5KM;EACE,yBCn0BK;EDo0BL,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cCt0BM;EDu0BN,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,gCAAA;AAo5KR;AAj5KQ;EACE,UAAA;EACA,eAAA;EACA,gBAAA;EACA,yDAAA;EACA,aC31BM;AD8uMhB;AAj5KQ;EACE,aC91BM;ADivMhB;AAj5KQ;EACE,UAAA;EACA,UAAA;AAm5KV;AA94KI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAg5KN;AA54KI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AA84KN;AA14KI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AA44KN;AAx4KI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AA04KN;AAt4KI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAw4KN;AAp4KI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAs4KN;AAl4KI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAo4KN;AAj4KI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,aAAA;AAm4KN;AAj4KI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAm4KN;AA/3KI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAi4KN;AA73KI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AA+3KN;AA93KM;EACE,0DAAA;AAg4KR;AA73KI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AA+3KN;AA13KI;EACE,YAteyD;AAk2L/D;AAz3KI;EACE,eAAA;AA23KN;AAx3KI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,gBAAA;EACA,eAAA;AA03KN;AAt3KI;EACE,0DAAA;AAw3KN;AAr3KI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EAEA,qBAAA;EACA,gBAAA;EACA,eAAA;AAu3KN;AAn3KI;EACE,0DAAA;EAEA,qBAAA;AAq3KN;;AA70KA;EA7iBE,wBAAA;EAuBA,4BAAA;AAw2LF;AA52LE;EACE,oCAAA;AA82LJ;AA12LE;EACE,yCAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EAEA,wBAAA;EACA,+zBAAA;EA2DA,2BAAA;AAizLJ;AA/yLE;EACE,yCAAA;EACA,iBAAA;EACA,WAAA;EACA,wBAAA;EACA,WAAA;EAEA,wBAAA;EACA,2aAAA;EA0CA,2BAAA;AAuwLJ;AApwLE;EAOE,YAqZ0B;EApZ1B,eAPY;EAQZ,YAAA;EAEA,wBC5oBS;AD24Mb;AAvwLI;EACE,eAHU;AA4wLhB;AA3vLE;EACE,oCAAA;EACA,YA9Ka;AA26LjB;AA3vLE;EACE,yBAAA;EACA,YAlLa;AA+6LjB;AAxvLI;EACE,eAAA;EACA,kBAAA;AA0vLN;AArvLI;EACE,eAAA;EACA,yBAAA;EACA,iBAAA;AAuvLN;AApvLI;EACE,WAAA;EACA,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;AAsvLN;AApvLM;EACE,yBAAA;AAsvLR;AAlvLM;EACE,iBAAA;AAovLR;AAjvLM;EACE,iBAAA;AAmvLR;AA/uLI;EACE,WAAA;EACA,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;AAivLN;AAtuLI;EACE,WAAA;EACA,YAAA;EAEA,kBAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;AAuuLN;AAtuLM;EAEE,0DAAA;AAuuLR;AAnuLI;EACE,WAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;AAquLN;AAnuLQ;EACE,gBAAA;EACA,+BAAA;AAquLV;AAluLQ;EACE,UAAA;EACA,UAAA;AAouLV;AA/tLI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;AAiuLN;AAhuLM;EACE,sBAAA;EACA,0DAAA;AAkuLR;AA9tLI;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EAEA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;AA+tLN;AA9tLM;EACE,yBC3xBK;ED4xBL,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cC9xBM;ED+xBN,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,gCAAA;AAguLR;AA7tLQ;EACE,eAAA;EACA,gBAAA;EACA,yDAAA;EACA,aClzBM;ADihNhB;AA7tLQ;EACE,aCrzBM;ADohNhB;AA7tLQ;EACE,UAAA;EACA,UAAA;AA+tLV;AAxtLI;EACE,eAAA;EACA,UAAA;EACA,kBAAA;AA0tLN;AAxtLM;EACE,yBCn0BK;EDo0BL,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cCt0BM;EDu0BN,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,gCAAA;AA0tLR;AAvtLQ;EACE,UAAA;EACA,eAAA;EACA,gBAAA;EACA,yDAAA;EACA,aC31BM;ADojNhB;AAvtLQ;EACE,aC91BM;ADujNhB;AAvtLQ;EACE,UAAA;EACA,UAAA;AAytLV;AAptLI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAstLN;AAltLI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAotLN;AAhtLI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAktLN;AA9sLI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAgtLN;AA5sLI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AA8sLN;AA1sLI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AA4sLN;AAxsLI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AA0sLN;AAvsLI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;EACA,aAAA;AAysLN;AAvsLI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAysLN;AArsLI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAusLN;AAnsLI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAqsLN;AApsLM;EACE,0DAAA;AAssLR;AAnsLI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,eAAA;EACA,UAAA;AAqsLN;AAhsLI;EACE,YAteyD;AAwqM/D;AA/rLI;EACE,eAAA;AAisLN;AA9rLI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,gBAAA;EACA,eAAA;AAgsLN;AA5rLI;EACE,0DAAA;AA8rLN;AA3rLI;EACE,WAAA;EACA,YAAA;EACA,0DAAA;EACA,4BAAA;EAEA,qBAAA;EACA,gBAAA;EACA,eAAA;AA6rLN;AAzrLI;EACE,0DAAA;EAEA,qBAAA;AA2rLN;;AAhpLA,iBAAA;AACA;EACE,YAAA;EACA,aAAA;EAGA,YAAA;AAipLF;;AAxoLA,mBAAA;AACA;EACE,UAAA;AA2oLF;AAzoLE;EACE,UAAA;AA2oLJ;;AAvoLA;EACE,6BAAA;AA0oLF;;AAvoLA;EACE,0BAAA;EAEA,cAAA;AAyoLF;;AAtoLA;EACE,0BAAA;AAyoLF;;AAtoLA;EACE,0CAAA;AAyoLF;;AAtoLA;EACE,+BAAA;AAyoLF;;AAvoLA;EACE,6BAAA;AA0oLF;;AAvoLA;EACE,2BAAA;AA0oLF;;AAvoLA;EACE,yBAAA;EACA,6BAAA;AA0oLF;;AAvoLA;EACE,uCAAA;AA0oLF;;AAtoLA;EACE,0BAAA;AAyoLF;;AAvoLA;EACE,gBAAA;AA0oLF;;AAvoLA;EACE,6BAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;AA0oLF;AAxoLE;EACE,yBCznCS;ED0nCT,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cC5nCU;ED6nCV,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,gCAAA;AA0oLJ;AAvoLI;EACE,UAAA;AAyoLN;AAvoLI;EACE,UAAA;EACA,UAAA;AAyoLN;;AApoLA;EACE,6BAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;AAuoLF;AAroLE;EACE,yBC1pCS;ED2pCT,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cC7pCU;ED8pCV,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,gCAAA;AAuoLJ;AApoLI;EACE,UAAA;AAsoLN;AApoLI;EACE,UAAA;EACA,UAAA;AAsoLN;;AA19KA;;EAEE,wBAAA;EACA,SAAA;AA69KF;;AA19KA;EAtKE,kBAAA;EACA,gBAAA;EACA,YAAA;AAooLF;AAloLE;EACE,UAAA;AAooLJ;AAnoLI;EACE,yBAAA;AAqoLN;AAjoLE;EACE,UAAA;AAmoLJ;AAloLI;EACE,yBAAA;AAooLN;AAloLI;EACE,UAAA;AAooLN;AAhoLE;EACE,UAAA;AAkoLJ;AA/nLE;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,yCAAA;EACA,sJAAA;AAioLJ;AA/nLI;EACE,WAAA;EACA,kBAAA;EACA,yBChuCO;EDiuCP,sJAAA;EACA,YA7C0C;AA8qLhD;AA7nLE;EACE,sCAAA;AA+nLJ;AA7nLE;EACE,0CAAA;AA+nLJ;AA7nLE;EACE,kBAAA;EACA,YAAA;AA+nLJ;AA3nLE;EACE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,YAAA;EACA,mBAAA;AA6nLJ;AA1nLE;EACE,sBAAA;EACA,cC3vCc;ED4vCd,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AA4nLJ;AAznLE;EACE,sBAAA;EACA,eAAA;EACA,iBAAA;AA2nLJ;AAxnLE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;AA0nLJ;AAvnLE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;AAynLJ;AAtnLE;EACE,yBAAA;AAwnLJ;AArnLE;EACE,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cC9xCW;ED+xCX,kBAAA;EACA,QAAA;EACA,aAAA;EACA,yBAAA;AAunLJ;AAhnLE;EAEE,YAAA;EACA,aAAA;AAinLJ;AA9mLE;EAEE,OAAA;EACA,iBAAA;AA+mLJ;AA5mLE;;EAIE,oBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;AA4mLJ;AAxmLI;;EACE,eAAA;EACA,cAAA;EACA,sBAAA;EACA,oBAAA;AA2mLN;AAtmLI;;EACE,kBAAA;AAymLN;AArmLE;;EAEE,kBAAA;AAumLJ;AApmLE;;EAEE,mBAAA;AAsmLJ;;AAzlLA;EAzKE,kBAAA;EACA,gBAAA;EACA,YAAA;AAswLF;AApwLE;EACE,UAAA;AAswLJ;AArwLI;EACE,yBAAA;AAuwLN;AAnwLE;EACE,UAAA;AAqwLJ;AApwLI;EACE,yBAAA;AAswLN;AApwLI;EACE,UAAA;AAswLN;AAlwLE;EACE,UAAA;AAowLJ;AAjwLE;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,yCAAA;EACA,sJAAA;AAmwLJ;AAjwLI;EACE,WAAA;EACA,kBAAA;EACA,yBChuCO;EDiuCP,sJAAA;EACA,YA7C0C;AAgzLhD;AA/vLE;EACE,sCAAA;AAiwLJ;AA/vLE;EACE,0CAAA;AAiwLJ;AA/vLE;EACE,kBAAA;EACA,YAAA;AAiwLJ;AA7vLE;EACE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,YAAA;EACA,mBAAA;AA+vLJ;AA5vLE;EACE,sBAAA;EACA,cC3vCc;ED4vCd,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AA8vLJ;AA3vLE;EACE,sBAAA;EACA,eAAA;EACA,iBAAA;AA6vLJ;AA1vLE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;AA4vLJ;AAzvLE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;AA2vLJ;AAxvLE;EACE,yBAAA;AA0vLJ;AAvvLE;EACE,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cC9xCW;ED+xCX,kBAAA;EACA,QAAA;EACA,aAAA;EACA,yBAAA;AAyvLJ;AAlvLE;EAEE,YAAA;EACA,aAAA;AAmvLJ;AAhvLE;EAEE,OAAA;EACA,iBAAA;AAivLJ;AA9uLE;;EAIE,oBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;AA8uLJ;AA1uLI;;EACE,eAAA;EACA,cAAA;EACA,sBAAA;EACA,oBAAA;AA6uLN;AAxuLI;;EACE,kBAAA;AA2uLN;AAvuLE;;EAEE,kBAAA;AAyuLJ;AAtuLE;;EAEE,mBAAA;AAwuLJ;;AAxtLA;EA5KE,kBAAA;EACA,gBAAA;EACA,YAAA;AAw4LF;AAt4LE;EACE,UAAA;AAw4LJ;AAv4LI;EACE,yBAAA;AAy4LN;AAr4LE;EACE,UAAA;AAu4LJ;AAt4LI;EACE,yBAAA;AAw4LN;AAt4LI;EACE,UAAA;AAw4LN;AAp4LE;EACE,UAAA;AAs4LJ;AAn4LE;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,yCAAA;EACA,sJAAA;AAq4LJ;AAn4LI;EACE,WAAA;EACA,kBAAA;EACA,yBChuCO;EDiuCP,sJAAA;EACA,YAsI8C;AA+vLpD;AAj4LE;EACE,sCAAA;AAm4LJ;AAj4LE;EACE,0CAAA;AAm4LJ;AAj4LE;EACE,kBAAA;EACA,YAAA;AAm4LJ;AA/3LE;EACE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,YAAA;EACA,mBAAA;AAi4LJ;AA93LE;EACE,sBAAA;EACA,cC3vCc;ED4vCd,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AAg4LJ;AA73LE;EACE,sBAAA;EACA,eAAA;EACA,iBAAA;AA+3LJ;AA53LE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;AA83LJ;AA33LE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;AA63LJ;AA13LE;EACE,yBAAA;AA43LJ;AAz3LE;EACE,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cC9xCW;ED+xCX,kBAAA;EACA,QAAA;EACA,aAAA;EACA,yBAAA;AA23LJ;AAp3LE;EAEE,YAAA;EACA,aAAA;AAq3LJ;AAl3LE;EAEE,OAAA;EACA,iBAAA;AAm3LJ;AAh3LE;;EAIE,oBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;AAg3LJ;AA52LI;;EACE,eAAA;EACA,cAAA;EACA,sBAAA;EACA,oBAAA;AA+2LN;AA12LI;;EACE,kBAAA;AA62LN;AAz2LE;;EAEE,kBAAA;AA22LJ;AAx2LE;;EAEE,mBAAA;AA02LJ;;AAv1LA;EA/KE,kBAAA;EACA,gBAAA;EACA,YAAA;AA0gMF;AAxgME;EACE,UAAA;AA0gMJ;AAzgMI;EACE,yBAAA;AA2gMN;AAvgME;EACE,UAAA;AAygMJ;AAxgMI;EACE,yBAAA;AA0gMN;AAxgMI;EACE,UAAA;AA0gMN;AAtgME;EACE,UAAA;AAwgMJ;AArgME;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,yCAAA;EACA,sJAAA;AAugMJ;AArgMI;EACE,WAAA;EACA,kBAAA;EACA,yBChuCO;EDiuCP,sJAAA;EACA,UAyI8C;AA83LpD;AAngME;EACE,sCAAA;AAqgMJ;AAngME;EACE,0CAAA;AAqgMJ;AAngME;EACE,kBAAA;EACA,YAAA;AAqgMJ;AAjgME;EACE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,YAAA;EACA,mBAAA;AAmgMJ;AAhgME;EACE,sBAAA;EACA,cC3vCc;ED4vCd,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AAkgMJ;AA//LE;EACE,sBAAA;EACA,eAAA;EACA,iBAAA;AAigMJ;AA9/LE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;AAggMJ;AA7/LE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;AA+/LJ;AA5/LE;EACE,yBAAA;AA8/LJ;AA3/LE;EACE,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cC9xCW;ED+xCX,kBAAA;EACA,QAAA;EACA,aAAA;EACA,yBAAA;AA6/LJ;AAt/LE;EAEE,YAAA;EACA,aAAA;AAu/LJ;AAp/LE;EAEE,OAAA;EACA,iBAAA;AAq/LJ;AAl/LE;;EAIE,oBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;AAk/LJ;AA9+LI;;EACE,eAAA;EACA,cAAA;EACA,sBAAA;EACA,oBAAA;AAi/LN;AA5+LI;;EACE,kBAAA;AA++LN;AA3+LE;;EAEE,kBAAA;AA6+LJ;AA1+LE;;EAEE,mBAAA;AA4+LJ;;AAt9LA;EAlLE,kBAAA;EACA,gBAAA;EACA,YAAA;EAmLA,YAAA;AA09LF;AA3oME;EACE,UAAA;AA6oMJ;AA5oMI;EACE,yBAAA;AA8oMN;AA1oME;EACE,UAAA;AA4oMJ;AA3oMI;EACE,yBAAA;AA6oMN;AA3oMI;EACE,UAAA;AA6oMN;AAzoME;EACE,UAAA;AA2oMJ;AAxoME;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,yCAAA;EACA,sJAAA;AA0oMJ;AAxoMI;EACE,WAAA;EACA,kBAAA;EACA,yBChuCO;EDiuCP,sJAAA;EACA,YA7C0C;AAurMhD;AAtoME;EACE,sCAAA;AAwoMJ;AAtoME;EACE,0CAAA;AAwoMJ;AAtoME;EACE,kBAAA;EACA,YAAA;AAwoMJ;AApoME;EACE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,YAAA;EACA,mBAAA;AAsoMJ;AAnoME;EACE,sBAAA;EACA,cC3vCc;ED4vCd,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AAqoMJ;AAloME;EACE,sBAAA;EACA,eAAA;EACA,iBAAA;AAooMJ;AAjoME;EACE,kBAAA;EACA,WAAA;EACA,QAAA;AAmoMJ;AAhoME;EACE,kBAAA;EACA,UAAA;EACA,QAAA;AAkoMJ;AA/nME;EACE,yBAAA;AAioMJ;AA9nME;EACE,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cC9xCW;ED+xCX,kBAAA;EACA,QAAA;EACA,aAAA;EACA,yBAAA;AAgoMJ;AAznME;EAEE,YAAA;EACA,aAAA;AA0nMJ;AAvnME;EAEE,OAAA;EACA,iBAAA;AAwnMJ;AArnME;;EAIE,oBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;AAqnMJ;AAjnMI;;EACE,eAAA;EACA,cAAA;EACA,sBAAA;EACA,oBAAA;AAonMN;AA/mMI;;EACE,kBAAA;AAknMN;AA9mME;;EAEE,kBAAA;AAgnMJ;AA7mME;;EAEE,mBAAA;AA+mMJ;AArlME;EACE,oCAAA;AAulMJ;;AAplMA;EA1LE,kBAAA;EACA,gBAAA;EACA,YAAA;AAkxMF;AAhxME;EACE,UAAA;AAkxMJ;AAjxMI;EACE,yBAAA;AAmxMN;AA/wME;EACE,UAAA;AAixMJ;AAhxMI;EACE,yBAAA;AAkxMN;AAhxMI;EACE,UAAA;AAkxMN;AA9wME;EACE,UAAA;AAgxMJ;AA7wME;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,yCAAA;EACA,sJAAA;AA+wMJ;AA7wMI;EACE,WAAA;EACA,kBAAA;EACA,yBChuCO;EDiuCP,sJAAA;EACA,YA7C0C;AA4zMhD;AA3wME;EACE,sCAAA;AA6wMJ;AA3wME;EACE,0CAAA;AA6wMJ;AA3wME;EACE,kBAAA;EACA,YAAA;AA6wMJ;AAzwME;EACE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,YAAA;EACA,mBAAA;AA2wMJ;AAxwME;EACE,sBAAA;EACA,cC3vCc;ED4vCd,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AA0wMJ;AAvwME;EACE,sBAAA;EACA,eAAA;EACA,iBAAA;AAywMJ;AAtwME;EACE,kBAAA;EACA,WAAA;EACA,QAAA;AAwwMJ;AArwME;EACE,kBAAA;EACA,UAAA;EACA,QAAA;AAuwMJ;AApwME;EACE,yBAAA;AAswMJ;AAnwME;EACE,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cC9xCW;ED+xCX,kBAAA;EACA,QAAA;EACA,aAAA;EACA,yBAAA;AAqwMJ;AA9vME;EAEE,YAAA;EACA,aAAA;AA+vMJ;AA5vME;EAEE,OAAA;EACA,iBAAA;AA6vMJ;AA1vME;;EAIE,oBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;AA0vMJ;AAtvMI;;EACE,eAAA;EACA,cAAA;EACA,sBAAA;EACA,oBAAA;AAyvMN;AApvMI;;EACE,kBAAA;AAuvMN;AAnvME;;EAEE,kBAAA;AAqvMJ;AAlvME;;EAEE,mBAAA;AAovMJ;AAntME;EACE,kBAAA;AAqtMJ;;AAjtMA;EAlME,kBAAA;EACA,gBAAA;EACA,YAAA;AAu5MF;AAr5ME;EACE,UAAA;AAu5MJ;AAt5MI;EACE,yBAAA;AAw5MN;AAp5ME;EACE,UAAA;AAs5MJ;AAr5MI;EACE,yBAAA;AAu5MN;AAr5MI;EACE,UAAA;AAu5MN;AAn5ME;EACE,UAAA;AAq5MJ;AAl5ME;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,yCAAA;EACA,sJAAA;AAo5MJ;AAl5MI;EACE,WAAA;EACA,kBAAA;EACA,yBChuCO;EDiuCP,sJAAA;EACA,YA7C0C;AAi8MhD;AAh5ME;EACE,sCAAA;AAk5MJ;AAh5ME;EACE,0CAAA;AAk5MJ;AAh5ME;EACE,kBAAA;EACA,YAAA;AAk5MJ;AA94ME;EACE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,YAAA;EACA,mBAAA;AAg5MJ;AA74ME;EACE,sBAAA;EACA,cC3vCc;ED4vCd,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AA+4MJ;AA54ME;EACE,sBAAA;EACA,eAAA;EACA,iBAAA;AA84MJ;AA34ME;EACE,kBAAA;EACA,WAAA;EACA,QAAA;AA64MJ;AA14ME;EACE,kBAAA;EACA,UAAA;EACA,QAAA;AA44MJ;AAz4ME;EACE,yBAAA;AA24MJ;AAx4ME;EACE,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cC9xCW;ED+xCX,kBAAA;EACA,QAAA;EACA,aAAA;EACA,yBAAA;AA04MJ;AAn4ME;EAEE,YAAA;EACA,aAAA;AAo4MJ;AAj4ME;EAEE,OAAA;EACA,iBAAA;AAk4MJ;AA/3ME;;EAIE,oBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;AA+3MJ;AA33MI;;EACE,eAAA;EACA,cAAA;EACA,sBAAA;EACA,oBAAA;AA83MN;AAz3MI;;EACE,kBAAA;AA43MN;AAx3ME;;EAEE,kBAAA;AA03MJ;AAv3ME;;EAEE,mBAAA;AAy3MJ;AAh1ME;EACE,UAAA;AAk1MJ;AAj1MI;EACE,0CAAA;AAm1MN;AA/0ME;EACE,UAAA;AAi1MJ;AAh1MI;EACE,0CAAA;AAk1MN;AAh1MI;EACE,UAAA;AAk1MN;AA90ME;EACE,UAAA;AAg1MJ;AA/0MI;EACE,0CAAA;AAi1MN;AA90ME;EACE,0CAAA;AAg1MJ;AA70ME;EACE,qCAAA;EACA,gBAAA;AA+0MJ;;AAx0MA;EAaE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;AA+zMF;AA7zME;EACE,UAAA;AA+zMJ;AA5zME;EACE,UAAA;AA8zMJ;AA3zME;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,oGAAA;EACA,yBCt8CY;EDu8CZ,iBAAA;AA6zMJ;AA1zME;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yCAAA;EACA,wHAAA;AA4zMJ;AA1zMI;EACE,WAAA;EACA,kBAAA;EACA,yBCj9CO;EDk9CP,wHAAA;EACA,UA7CW;AAy2MjB;AAxzME;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,oGAAA;EACA,yBC/9CY;EDg+CZ,gBAAA;EACA,qBAAA;AA0zMJ;AAvzME;EACE,kBAAA;EACA,YAAA;AAyzMJ;AAtzME;EAIE,YAAA;EACA,WAAA;EACA,UAAA;EAEA,kBAAA;AAozMJ;AAjzMI;EAEE,mBAAA;EACA,cAAA;EACA,eAAA;AAkzMN;;AA1yMA;EACE,0DAAA;EACA,4BAAA;EACA,wBAAA;EACA,wBAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,QAAA;EACA,OAAA;EACA,2BAAA;EACA,UAAA;AA6yMF;;AA1yMA;EACE,0DAAA;EACA,4BAAA;EACA,wBAAA;EACA,wBAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,QAAA;EACA,OAAA;EACA,2BAAA;EACA,UAAA;AA6yMF;;AA1yMA;EACE,kBAAA;AA6yMF;;AAvyMA;EAIE,YAAA;AAuyMF;AAryME;EACE,qHAAA;EAQA,yCAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AAgyMJ;AA9xMI;EACE,gBAAA;AAgyMN;AA7xMI;EACE,UAAA;EACA,kBAAA;AA+xMN;AA3xME;EACE,UAAA;AA6xMJ;AA5xMI;EACE,UAAA;EACA,yBAAA;EACA,yBAAA;AA8xMN;AA1xME;EACE,UAAA;AA4xMJ;AAzxME;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,sHAAA;EAQA,yBC1lDS;AD82Pb;AAjxME;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EAEA,oBAAA;AAkxMJ;AA/wME;EACE,YAAA;AAixMJ;AA9wME;EACE,UAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,UAAA;AAgxMJ;;AA1wMA,uBAAA;AAEA,oBAAA;AA2GA;EA3FE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,YAAA;EAKA,eAAA;AA0vMF;AAvvME;EACE,mBAAA;AAyvMJ;AAtvME;EACE,kBAAA;EACA,4FAAA;EACA,yBAAA;EACA,UAAA;AAwvMJ;AArvME;EACE,kBAAA;EACA,4FAAA;EACA,yBAAA;EACA,UAAA;EAEA,qBAAA;AAuvMJ;AApvME;EACE,kBAAA;EACA,mECpqDgB;EDqqDhB,wHAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;AAsvMJ;AAjvME;EACE,WAAA;EACA,kBAAA;EACA,yBCprDS;EDqrDT,wHAAA;EACA,UA5Da;AA+yMjB;AAhvME;EACE,cCvrDU;EDwrDV,eAlEqD;EAmErD,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,wBCnrDS;EDorDT,WAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAkvMJ;AA9uMI;EACE,aC1sDO;AD07Pb;AA5uME;EACE,kBAAA;EACA,UAAA;EACA,QAAA;AA8uMJ;AA3uME;EACE,cCltDU;EDmtDV,eA7FqD;EA8FrD,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,oBAAA;EACA,WAAA;EACA,kBAAA;AA6uMJ;;AAluMA;EAlGE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,YAAA;EAKA,eAAA;AAo0MF;AAj0ME;EACE,mBAAA;AAm0MJ;AAh0ME;EACE,kBAAA;EACA,4FAAA;EACA,yBAAA;EACA,UAAA;AAk0MJ;AA/zME;EACE,kBAAA;EACA,4FAAA;EACA,yBAAA;EACA,UAAA;EAEA,qBAAA;AAi0MJ;AA9zME;EACE,kBAAA;EACA,mECpqDgB;EDqqDhB,wHAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;AAg0MJ;AA3zME;EACE,WAAA;EACA,kBAAA;EACA,yBCprDS;EDqrDT,wHAAA;EACA,UA5Da;AAy3MjB;AA1zME;EACE,cCvrDU;EDwrDV,eAlEqD;EAmErD,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,wBCnrDS;EDorDT,WAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA4zMJ;AAxzMI;EACE,aC1sDO;ADogQb;AAtzME;EACE,kBAAA;EACA,UAAA;EACA,QAAA;AAwzMJ;AArzME;EACE,cCltDU;EDmtDV,eA7FqD;EA8FrD,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,oBAAA;EACA,WAAA;EACA,kBAAA;AAuzMJ;AAzyME;EACE,yCAAA;AA2yMJ;AAvyMI;EACE,UAAA;AAyyMN;AAtyMI;EAznDF,6BAAA;EACA,+EAAA;AAk6PF;AAryMI;EACE,cC1vDO;ADiiQb;AApyMI;EACE,cC9vDO;ADoiQb;;AA/xMA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAkyMF;AAhyME;EACE,cC3wDU;ED4wDV,eAAA;EACA,wBCnwDS;ADqiQb;AA9xMI;EACE,cCxxDU;ADwjQhB;;AAzxMA;EAtJE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,YAAA;EAKA,eAAA;AA+6MF;AA56ME;EACE,mBAAA;AA86MJ;AA36ME;EACE,kBAAA;EACA,4FAAA;EACA,yBAAA;EACA,UAAA;AA66MJ;AA16ME;EACE,kBAAA;EACA,4FAAA;EACA,yBAAA;EACA,UAAA;EAEA,qBAAA;AA46MJ;AAz6ME;EACE,kBAAA;EACA,mECpqDgB;EDqqDhB,wHAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;AA26MJ;AAt6ME;EACE,WAAA;EACA,kBAAA;EACA,yBCprDS;EDqrDT,wHAAA;EACA,UA5Da;AAo+MjB;AAr6ME;EACE,cCvrDU;EDwrDV,eAlEqD;EAmErD,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,wBCnrDS;EDorDT,WAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAu6MJ;AAn6MI;EACE,aC1sDO;AD+mQb;AAj6ME;EACE,kBAAA;EACA,UAAA;EACA,QAAA;AAm6MJ;AAh6ME;EACE,cCltDU;EDmtDV,eA7FqD;EA8FrD,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,oBAAA;EACA,WAAA;EACA,kBAAA;AAk6MJ;AAh2ME;EACE,0CAAA;AAk2MJ;AAh2ME;EACE,yBAAA;AAk2MJ;AA/1ME;EACE,yBAAA;AAi2MJ;AA/1ME;EACE,cAAA;AAi2MJ;AA91MI;EACE,UAAA;AAg2MN;AA71MI;EACE,yBCrzDU;ADopQhB;AA51MI;EACE,cCtzDO;ADopQb;AA31MI;EACE,cC1zDO;ADupQb;;AAt1MA;EA3LE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,YAAA;EAKA,eAAA;AAihNF;AA9gNE;EACE,mBAAA;AAghNJ;AA7gNE;EACE,kBAAA;EACA,4FAAA;EACA,yBAAA;EACA,UAAA;AA+gNJ;AA5gNE;EACE,kBAAA;EACA,4FAAA;EACA,yBAAA;EACA,UAAA;EAEA,qBAAA;AA8gNJ;AA3gNE;EACE,kBAAA;EACA,mECpqDgB;EDqqDhB,wHAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;AA6gNJ;AAxgNE;EACE,WAAA;EACA,kBAAA;EACA,yBCprDS;EDqrDT,wHAAA;EACA,UA5Da;AAskNjB;AAvgNE;EACE,cCvrDU;EDwrDV,eAuIuD;EAtIvD,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,0BAkI4B;EAjI5B,WAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAygNJ;AArgNI;EACE,aC1sDO;ADitQb;AAngNE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;AAqgNJ;AAlgNE;EACE,cCltDU;EDmtDV,eA4GuD;EA3GvD,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,oBAAA;EACA,WAAA;EACA,kBAAA;AAogNJ;AA95ME;EACE,gBAAA;AAg6MJ;AA75ME;EACE,yCAAA;AA+5MJ;AA35MI;EACE,UAAA;AA65MN;AA15MI;EACE,yBCp1DU;ED8Hd,6BAAA;EACA,+EAAA;AAmnQF;AAt5MI;EACE,cC11DO;ADkvQb;;AAh5ME;EACE,yBAAA;AAm5MJ;AAh5ME;EACE,yBAAA;AAk5MJ;AA/4ME;EA/uDA,6BAAA;EACA,+EAAA;AAioQF;AA/4ME;EACE,yBAAA;AAi5MJ;AA94ME;EACE,cCh3DU;ADgwQd;AA74ME;EACE,wDCn3DgB;ADkwQpB;;AAx4ME;EACE,kBAAA;AA24MJ;AAx4ME;EACE,uBAAA;EACA,yCAAA;AA04MJ;AAz3MA;EACE,6BAAA;EACA,SAAA;EACA,kBAAA;AA23MF;AA13ME;EACE,yBC15DS;ED25DT,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cC75DU;ED85DV,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,gCAAA;AA43MJ;AAz3MI;EACE,eC96DU;ADyyQhB;AAz3MI;EACE,UAAA;EACA,UAAA;AA23MN;;AAn3MA;EACE,6BAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;AAs3MF;;AAz2MA,4BAAA;AAEA;EAGE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;AAy2MF;AAv2ME;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;EACA,sJAAA;AAy2MJ;AAt2ME;EACE,qBAAA;AAw2MJ;AAr2ME;EAEE,yBAAA;AAs2MJ;AAn2ME;EACE,kBAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AAq2MJ;AAl2ME;EACE,WAAA;EACA,kBAAA;EACA,sJAAA;EACA,0BAAA;EACA,yBCt/DS;AD01Qb;;AAh2MA,gCAAA;AAEA,wBAAA;AAmMA;EA/LE,kBAAA;AAg2MF;AA71ME;EACE,4OAAA;EAUA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AAs1MJ;AAn1ME;EAmBE,iNAAA;EAcA,yBC3jEY;ED4jEZ,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAszMJ;AAnzME;EACE,iNAAA;EAcA,yBCjlEY;EDklEZ,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,0BAAA;AAwyMJ;AAryME;EACE,WAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;EACA,QAAA;EACA,yBCjmES;ADw4Qb;AApyME;EACE,WAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,QAAA;EACA,OAAA;EACA,yBC7mES;ADm5Qb;AAnyME;EACE,WAAA;EACA,kBAAA;EAEA,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;AAoyMJ;AA/xME;EACE,kJAAA;EAUA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;AAwxMJ;AAjxMM;EACE,WAAA;EACA,YAAA;AAmxMR;AAhxMM;EACE,WAAA;EACA,UAAA;EACA,uBAAA;EACA,gBAAA;AAkxMR;AA/wMM;EACE,YAAA;EACA,YAAA;AAixMR;AA7wMI;EACE,iBAAA;AA+wMN;AA3wME;EAGE,iGAAA;EAQA,yBC1rEY;ED2rEZ,WAAA;EACA,WA1LmD;EA2LnD,YAAA;AAowMJ;;AA3vMA;EAnME,kBAAA;AAk8MF;AA/7ME;EACE,4OAAA;EAUA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AAw7MJ;AAr7ME;EAmBE,iNAAA;EAcA,yBC3jEY;ED4jEZ,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAw5MJ;AAr5ME;EACE,iNAAA;EAcA,yBCjlEY;EDklEZ,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,0BAAA;AA04MJ;AAv4ME;EACE,WAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;EACA,QAAA;EACA,yBCjmES;AD0+Qb;AAt4ME;EACE,WAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,QAAA;EACA,OAAA;EACA,yBC7mES;ADq/Qb;AAr4ME;EACE,WAAA;EACA,kBAAA;EAEA,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;AAs4MJ;AAj4ME;EACE,kJAAA;EAUA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;AA03MJ;AAn3MM;EACE,WAAA;EACA,YAAA;AAq3MR;AAl3MM;EACE,WAAA;EACA,UAAA;EACA,uBAAA;EACA,gBAAA;AAo3MR;AAj3MM;EACE,YAAA;EACA,YAAA;AAm3MR;AA/2MI;EACE,iBAAA;AAi3MN;AA72ME;EAGE,iGAAA;EAQA,yBC1rEY;ED2rEZ,WAAA;EACA,WAWuD;EAVvD,YAAA;AAs2MJ;;AAt1MA;EACE,YAAA;EACA,0DAAA;EACA,4BAAA;EACA,wBAAA;EACA,2BAAA;AAy1MF;;AAt1MA;EACE,cCntEW;EDotEX,0DAAA;EACA,4BAAA;EACA,wBAAA;EACA,2BAAA;AAy1MF;;AAt1MA;EACE,qBAAA;AAy1MF;;AAp1MA;EACE,iDAAA;AAu1MF;;AAn1ME;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAs1MJ;;AAl1MA;EAGE,YAAA;EACA,aAAA;AAm1MF;;AAh1MA;EACE,eAAA;EACA,gBAAA;EACA,mDAAA;AAm1MF;;AAh1MA;EACE,YAAA;EACA,gBAAA;EACA,mDAAA;AAm1MF;;AAh1MA;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAm1MF;AAl1ME;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAo1MJ;AAj1ME;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;AAm1MJ;AAl1MI;EACE,yBC1xEO;ED2xEP,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cC7xEQ;ED8xER,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,gCAAA;AAo1MN;AAj1MM;EACE,UAAA;AAm1MR;AAj1MM;EACE,UAAA;EACA,UAAA;AAm1MR;;AA70MA;EACE,UAAA;EASA,gBAAA;EACA,gBAAA;EAEA,kBAAA;EACA,yCAAA;EACA,8HAAA;AAu0MF;AAr0ME;EAEE,kBAAA;EACA,yBCz0ES;ED00ET,8HAAA;EAEA,UArBa;AA01MjB;AAl0ME;EACE,kBAAA;EACA,8HAAA;EACA,UA3Ba;EA4Bb,UAAA;AAo0MJ;;AA3zME;EACE,YAAA;EACA,aAAA;EACA,QAAA;EACA,eAAA;EACA,sCAAA;EACA,WAAA;EACA,gCAAA;EACA,UAAA;EACA,kBAAA;AA8zMJ;AA3zME;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,gCAAA;EACA,UAAA;EACA,kBAAA;AA6zMJ;;AAxzME;;EAEE,UAAA;EACA,mBAAA;AA2zMJ;;AArzMA;EACE,2BAAA;EACA,uBAAA;EAEA,6BAAA;AAuzMF;;AApzMA;EACE;IACE,UAAA;EAuzMF;EApzMA;IACE,UAAA;EAszMF;EAnzMA;IACE,YAAA;EAqzMF;EAlzMA;IACE,UAAA;EAozMF;AACF;AAjzMA;EACE,oCAAA;EACA,uBAAA;EAEA,6BAAA;AAkzMF;;AA/yMA;EACE;IACE,UAAA;EAkzMF;EA/yMA;IACE,UAAA;EAizMF;EA9yMA;IACE,YAAA;EAgzMF;EA7yMA;IACE,UAAA;EA+yMF;EA5yMA;IACE,UAAA;EA8yMF;AACF;AA3yMA;EACE,WAAA;EACA,wBAAA;EACA,uBAAA;EACA,kBAAA;EACA,6BAAA;AA6yMF;;AA1yMA;EACE;IACE,wBAAA;IACA,UAAA;EA6yMF;EA1yMA;IACE,wBAAA;IACA,YAAA;EA4yMF;EAzyMA;IACE,wBAAA;IACA,YAAA;EA2yMF;EAxyMA;IACE,aAAA;IACA,YAAA;EA0yMF;EAvyMA;IACE,aAAA;IACA,YAAA;EAyyMF;EAtyMA;IACE,aAAA;IACA,UAAA;EAwyMF;AACF;AAryMA;EACE,WAAA;EACA,2BAAA;EACA,uBAAA;EACA,kBAAA;EACA,6BAAA;AAuyMF;;AApyMA;EACE;IACE,uBAAA;IACA,UAAA;EAuyMF;EApyMA;IACE,uBAAA;IACA,YAAA;EAsyMF;EAnyMA;IACE,uBAAA;IACA,YAAA;EAqyMF;EAlyMA;IACE,aAAA;IACA,YAAA;EAoyMF;EAjyMA;IACE,aAAA;IACA,YAAA;EAmyMF;EAhyMA;IACE,aAAA;IACA,UAAA;EAkyMF;AACF;AA9xMA;EACE,cAAA;EACA,kBAAA;EACA,yCAAA;EACA,mBAAA;EACA,wBAAA;AAgyMF;;AA9xMA;EACE,cAAA;EACA,kBAAA;EAGA,gBAAA;AA+xMF;AA3xME;EACE,WAAA;EACA,YAAA;EACA,mBC3hFY;ED6hFZ,mBAAA;EAMA,kBAAA;EAEA,QAAA;EACA,OAAA;EACA,2BAAA;EACA,UAAA;AAsxMJ;AAnxME;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,QAAA;EACA,mBAAA;EACA,mBCljFY;ADu0RhB;;AAtvMA;EACE,oBAAA;EACA,4BAAA;EACA,yBAAA;EACA,uBAAA;EACA,wBAAA;AAyvMF;;AApvMA;EACE;IACE,UAAA;EAuvMF;EApvMA;IACE,UAAA;EAsvMF;EAnvMA;IACE,UAAA;EAqvMF;AACF;AAvrMA;EACE,qCAAA;AAquMF;;AAluMA;EACE;IACE,UAAA;EAquMF;EAluMA;IACE,YAAA;EAouMF;EAjuMA;IACE,UAAA;EAmuMF;AACF;AA7tMA;EAQE,qBAAA;AAwtMF;AA/tME;EACE,UAAA;AAiuMJ;AA/tME;EACE,UAAA;AAiuMJ;AA7tME;EACE,aAAA;AA+tMJ;AA7tME;EASE,iBAAA;AAutMJ;AA9tMI;EACE,UAAA;AAguMN;AA9tMI;EACE,UAAA;EACA,iBAAA;AAguMN;AA3tME;EACE,cAAA;AA6tMJ;;AAvtMA;EACE,YAAA;EACA,aAAA;EACA,gBAAA;AA0tMF;;AAvtMA;EACE,YAAA;EACA,YAAA;EACA,sBAAA;AA0tMF;;AAvtMA;EACE,qBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;AA0tMF;;AAntMA;EACE,kBAAA;EACA,uBAAA;EACA,YAAA;EAGA,WAAA;AAotMF;AAntME;EACE,YAAA;AAqtMJ;AAptMI;EACE,eAAA;EACA,yBAAA;AAstMN;;AAltMA;EACE,aAAA;EACA,qCAAA;EACA,0CAAA;AAqtMF;;AAjtMA;EACE,SAAA;AAotMF;;AAjtMA;EACE,UAAA;AAotMF;;AAltMA;EACE,qBAAA;AAqtMF;;AAntMA;EACE,UAAA;AAstMF;;AAntMA;EACE,qBAAA;AAstMF;;AAltME;EACE,WAAA;AAqtMJ;AAntME;;EAEE,cAAA;EACA,WAAA;EACA,mBAAA;AAqtMJ;AAntME;EACE,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AAqtMJ;AAltMI;EACE,WAAA;AAotMN;AAhtMI;EACE,YAAA;AAktMN;;AA5sME;EACE,mBAAA;EACA,iBAAA;EACA,eAAA;AA+sMJ;AA5sME;EACE,+CAAA;AA8sMJ;AA7sMI;EACE,cC/zFU;AD8gShB;AA7sMI;EACE,6DC3zFc;AD0gSpB;AA7sMI;EACE,WAAA;AA+sMN;;AAzsME;EACE,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AA4sMJ;AAzsME;EACE,gBAAA;EACA,OAAA;EACA,MAAA;EACA,uBAAA;EACA,UAAA;AA2sMJ;AAzsMI;EACE,mBAAA;EACA,cAAA;EACA,qCAAA;EACA,gBAAA;AA2sMN;AAzsMM;EACE,UAAA;AA2sMR;AAzsMM;EACE,UAAA;AA2sMR;AArsMI;EACE,kBAAA;AAusMN;AArsMM;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AAusMR;AApsMM;EACE,eAAA;AAssMR;AApsMU;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,0DAAA;EACA,4BAAA;EACA,wBAAA;EACA,2BAAA;EACA,yBAAA;AAssMZ;AAnsMU;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,0DAAA;EACA,4BAAA;EACA,wBAAA;EACA,2BAAA;AAqsMZ;;AA5rME;EACE,mBAAA;EACA,WAAA;EACA,yBAAA;AA+rMJ;AA5rME;EACE,mBAAA;EACA,kBAAA;AA8rMJ;AA3rME;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AA6rMJ;AA1rME;;EAEE,kBAAA;AA4rMJ;AAzrME;EACE,mBAAA;AA2rMJ;AAxrME;EACE,mBAAA;AA0rMJ;AAtrMI;EACE,cCt7FQ;EDu7FR,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,6BAAA;EACA,YAAA;AAwrMN;AArrMI;EACE,cCr8FU;EDs8FV,yBAAA;AAurMN;AArrMM;EA10FJ,6BAAA;EACA,+EAAA;EA40FM,cCr8FM;AD4nSd;AArrMQ;EACE,aCx8FI;EDy8FJ,eCz8FI;ADgoSd;;AA/qME;;EAEE,mBAAA;AAkrMJ;;AA7qMA;EACE,cCz9FY;ED09FZ,eAAA;AAgrMF;;AA7qMA;EACE,cC99FY;ED+9FZ,eAAA;EACA,+BAAA;EACA,kBAAA;AAgrMF;;AA3qME;EACE,UAAA;AA8qMJ;;AA1qMA;EACE,cAAA;EACA,aAAA;EACA,UAAA;EACA,8BAAA;AA6qMF;;AA1qMA;EACE,mBAAA;EACA,aAAA;AA6qMF;;AA5pMA;EACE;IACE,mBAAA;IACA,aAAA;EA+pMF;EA5pMA;IACE,cAAA;IACA,aAAA;EA8pMF;AACF;AA3pMA;EACE;IACE,cAAA;IACA,aAAA;EA6pMF;EA1pMA;IACE,mBAAA;IACA,aAAA;EA4pMF;AACF;AAzpMA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;AA2pMF;;AAxpMA;EACE,yBAAA;EACA,QAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;AA2pMF;;AAxpMA;EACE,eAAA;EACA,cCnjGc;EDojGd,0BAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AA2pMF;AA1pME;EACE,cAAA;AA4pMJ;;AAxpMA;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;EACA,kCAAA;EACA,UAAA;AA2pMF;;AAxpMA;EACE,UAAA;EACA,UAAA;AA2pMF;;AAxpMA;EACE,6DCrkGkB;ADguSpB;;AAxpMA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,0CAAA;EACA,qBAAA;AA2pMF;;AAxpMA;EACE,UAAA;EACA,kBAAA;AA2pMF;;AAxpMA;EACE,mBAAA;EACA,yCAAA;AA2pMF","sourcesContent":["@use \"./variables.scss\" as var;\n\n/* Width of the scrollbar */\n::-webkit-scrollbar {\n  width: 5px;\n}\n\n/* Track (background) */\n::-webkit-scrollbar-track {\n  border-radius: 5px;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 5px;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n/* Firefox */\nhtml {\n  scrollbar-color: #888; /* thumb */\n  scrollbar-width: thin;\n}\n\n/* Internet Explorer & Old Edge (Optional: Only works in older versions) */\nbody {\n  scrollbar-face-color: #888;\n}\n\n/** bootstrap custom config ****\n/*\n    color => ~/src/assets/scss/bootstrap/color.scss\n    margin,padding and spacing => ~/src/assets/scss/bootstrap/spacer.scss\n    width and height => ~/src/assets/scss/bootstrap/width_height.scss\n*/\n\n/** Generate custom font sizes */\n/**\n    Example Usage (you can use within 1px to 50 px)\n    eg. fs-1-px, fs-20-px ...... fs-50-px\n*/\n@for $i from 1 through 50 {\n  .fs-#{$i}-px {\n    font-size: 1px * $i !important;\n  }\n}\n@for $i from 1 through 50 {\n  .hover\\:fs-#{$i}-px {\n    &:hover {\n      font-size: 1px * $i !important;\n    }\n  }\n}\n\n@for $i from 0 through 50 {\n  .p-#{$i}-px {\n    padding: 1px * $i !important;\n  }\n\n  .pl-#{$i}-px {\n    padding-left: 1px * $i !important;\n  }\n\n  .pr-#{$i}-px {\n    padding-right: 1px * $i !important;\n  }\n\n  .pt-#{$i}-px {\n    padding-top: 1px * $i !important;\n  }\n\n  .pb-#{$i}-px {\n    padding-bottom: 1px * $i !important;\n  }\n\n  .px-#{$i}-px {\n    padding-inline: 1px * $i !important;\n  }\n\n  .py-#{$i}-px {\n    padding-block: 1px * $i !important;\n  }\n\n  .m-#{$i}-px {\n    margin: 1px * $i !important;\n  }\n\n  .ml-#{$i}-px {\n    margin-left: 1px * $i !important;\n  }\n\n  .mr-#{$i}-px {\n    margin-right: 1px * $i !important;\n  }\n\n  .mt-#{$i}-px {\n    margin-top: 1px * $i !important;\n  }\n\n  .mb-#{$i}-px {\n    margin-bottom: 1px * $i !important;\n  }\n\n  .mx-#{$i}-px {\n    margin-inline: 1px * $i !important;\n  }\n\n  .my-#{$i}-px {\n    margin-block: 1px * $i !important;\n  }\n}\n\n.ml-150-px {\n  margin-left: 150px;\n}\n\n.ml-100-px {\n  margin-left: 100px;\n}\n\n@mixin primary-gradient {\n  background: rgb(245, 151, 27);\n  background: linear-gradient(\n    90deg,\n    rgba(245, 151, 27, 1) 0%,\n    rgba(236, 77, 29, 1) 100%\n  );\n}\n\n/** End generate custom font sizes */\n\n//write your class\n.pt-1\\/2 {\n  padding-top: 0.5px !important;\n}\n.required-label {\n  position: relative;\n  right: 0;\n  top: 0.2rem;\n}\n\n%unset-input {\n  outline: none;\n  border: none;\n  background-image: none;\n  background-color: transparent;\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  box-shadow: none;\n  // -webkit-appearance: none;\n}\n\n/** font family */\n\n//notosan\n\n@font-face {\n  font-family: \"NotoSansJP\";\n  src: url(\"../fonts/notosansjp/NotoSansJP-Regular.otf\");\n}\n\n@font-face {\n  font-family: \"NotoSansJP-Medium\";\n  src: url(\"../fonts/notosansjp/NotoSansJP-Medium.otf\");\n}\n\n@font-face {\n  font-family: \"NotoSansJP-light\";\n  src: url(\"../fonts//notosansjp/NotoSansJP-Light.otf\");\n}\n\n.font-notosans-jp {\n  font-family: \"NotoSansJP\" !important;\n}\n\n.font-notosans-jp-medium {\n  font-family: \"NotoSansJP-Medium\" !important;\n}\n\n.font-notosans-jp-light {\n  font-family: \"NotoSansJP-light\" !important;\n}\n\n// font 851GKKTT\n@font-face {\n  font-family: \"851ゴチカクット\";\n  src: url(\"../fonts/851Gkktt_005.ttf\");\n}\n\n.font-gkktt {\n  font-family: \"851ゴチカクット\" !important;\n}\n\n//end notosan\n\n@font-face {\n  font-family: \"Ab-j_choki\";\n  src: url(\"../fonts/Ab-j_choki.ttf\") format(\"truetype\");\n}\n\n.font-abj-choki {\n  font-family: \"Ab-j_choki\" !important;\n}\n\n@font-face {\n  font-family: \"Ethno\";\n  src: url(\"../fonts/ethnocentric/Ethnocentric.otf\");\n}\n\n.font-ethno {\n  font-family: \"Ethno\" !important;\n  // font-weight: ;\n}\n\n// @font-face {\n//   font-family: \"ethno-light\";\n//   src: url(\"https://use.typekit.net/af/5868d5/000000000000000077359667/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n2&v=3\")\n//       format(\"woff2\"),\n//     url(\"https://use.typekit.net/af/5868d5/000000000000000077359667/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n2&v=3\")\n//       format(\"woff\"),\n//     url(\"https://use.typekit.net/af/5868d5/000000000000000077359667/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n2&v=3\")\n//       format(\"opentype\");\n//   font-display: auto;\n//   font-style: normal;\n//   font-weight: 300;\n//   font-stretch: normal;\n// }\n\n@font-face {\n  font-family: \"ethnocentric\";\n  src: url(\"https://use.typekit.net/af/03258e/000000000000000077359660/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n3&v=3\")\n      format(\"woff2\"),\n    url(\"https://use.typekit.net/af/03258e/000000000000000077359660/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n3&v=3\")\n      format(\"woff\"),\n    url(\"https://use.typekit.net/af/03258e/000000000000000077359660/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n3&v=3\")\n      format(\"opentype\");\n  font-display: auto;\n  font-style: normal;\n  font-weight: 300;\n  font-stretch: normal;\n}\n\n.font-ethno-normal {\n  font-family: \"ethnocentric\" !important;\n  font-weight: 900;\n}\n\n@font-face {\n  font-family: \"ethno-light\";\n  src: url(\"../fonts/ethnocentric/Ethnocentric\\ Light.otf\");\n}\n.font-ethno-light {\n  font-family: \"ethno-light\" !important;\n  font-weight: 300;\n}\n\n.font-ethno-bold {\n  font-family: \"ethno-light\" !important;\n  font-weight: 900;\n}\n\n@font-face {\n  font-family: \"Europa\";\n  src: url(\"//db.onlinewebfonts.com/t/23c0fcab84d99da0de762de7e220a6e1.eot\");\n  src: url(\"//db.onlinewebfonts.com/t/23c0fcab84d99da0de762de7e220a6e1.eot?#iefix\")\n      format(\"embedded-opentype\"),\n    url(\"//db.onlinewebfonts.com/t/23c0fcab84d99da0de762de7e220a6e1.woff2\")\n      format(\"woff2\"),\n    url(\"//db.onlinewebfonts.com/t/23c0fcab84d99da0de762de7e220a6e1.woff\")\n      format(\"woff\"),\n    url(\"//db.onlinewebfonts.com/t/23c0fcab84d99da0de762de7e220a6e1.ttf\")\n      format(\"truetype\"),\n    url(\"//db.onlinewebfonts.com/t/23c0fcab84d99da0de762de7e220a6e1.svg#Europa\")\n      format(\"svg\");\n}\n\n// @font-face {\n//   font-family: \"Europa\";\n//   src: url(\"../fonts/europa.ttf\");\n// }\n.font-europa-regular {\n  font-family: \"Europa\" !important;\n}\n\n@font-face {\n  font-family: \"Hiragino Sans\";\n  src: url(\"../fonts/Hiragino Sans.otf\");\n  // src: url(\"https://db.onlinewebfonts.com/t/bcf863a2d0e43d0a7d99cd7b5bdcedd5.eot\");\n  // src: url(\"https://db.onlinewebfonts.com/t/bcf863a2d0e43d0a7d99cd7b5bdcedd5.eot?#iefix\")\n  //     format(\"embedded-opentype\"),\n  //   url(\"https://db.onlinewebfonts.com/t/bcf863a2d0e43d0a7d99cd7b5bdcedd5.woff2\")\n  //     format(\"woff2\"),\n  //   url(\"https://db.onlinewebfonts.com/t/bcf863a2d0e43d0a7d99cd7b5bdcedd5.woff\")\n  //     format(\"woff\"),\n  //   url(\"https://db.onlinewebfonts.com/t/bcf863a2d0e43d0a7d99cd7b5bdcedd5.ttf\")\n  //     format(\"truetype\"),\n  //   url(\"https://db.onlinewebfonts.com/t/bcf863a2d0e43d0a7d99cd7b5bdcedd5.svg#Hiragino Sans GB W05 W4\")\n  //     format(\"svg\");\n}\n.font-hiragino-sans {\n  font-family: \"Hiragino Sans\" !important;\n}\n\n/** end font family */\n\n.hide-scroll {\n  -ms-overflow-style: none;\n  /* IE and Edge */\n  scrollbar-width: none;\n\n  /* Firefox */\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n/** colors */\n.text-gray {\n  color: #b4b4b4 !important;\n}\n.text-dark-gray {\n  color: #9a9a9a !important;\n}\n.text-highlight {\n  color: var.$highlight-color !important;\n}\n.text-light {\n  color: var.$light-color !important;\n}\n.text-light-primary {\n  color: #ff996a !important;\n}\n/** end colors */\n\n/** Menu Button Classes */\n.menu-button-container {\n  gap: 60px;\n  // @media (min-width: var.$lg-screen) {\n  //   gap: 24px;\n  // }\n  // @media (min-width: var.$xl-screen) {\n  //   gap: 30px;\n  // }\n}\n.bottom-menu-container {\n  .button-menu-gap {\n    gap: 22px;\n    @media (min-width: var.$xl-screen) {\n      gap: 36px;\n    }\n  }\n}\n\n.menu-button {\n  --path: 90% 10%, 100% 35%, 100% 70%, 90% 90%, 10% 90%, 0% 70%, 0% 35%, 10% 10%;\n  --left-path: polygon(\n    79% 9%,\n    99% 10%,\n    19% 33%,\n    18% 69%,\n    98% 91%,\n    79% 92%,\n    0% 69%,\n    -1% 32%\n  );\n\n  width: 200px;\n\n  .outside {\n    position: relative;\n    width: 173px;\n    height: 55px;\n    background: #ed753e;\n    clip-path: polygon(var(--path));\n  }\n\n  .inside {\n    position: absolute;\n    top: 1px;\n    left: 1px;\n    right: 1px;\n    bottom: 1px;\n    background: var.$dark-color;\n    clip-path: polygon(var(--path));\n  }\n\n  .left {\n    width: 20px;\n    height: 55px;\n    margin-right: -12px;\n    background: #ed753e;\n    clip-path: var(--left-path);\n  }\n\n  .right {\n    width: 20px;\n    height: 55px;\n    margin-left: -12px;\n    background: #ed753e;\n    clip-path: var(--left-path);\n    -webkit-transform: scaleX(-1);\n    transform: scaleX(-1);\n  }\n\n  .text {\n    color: white;\n  }\n}\n\n.menu-button:hover {\n  .outside {\n    background: var.$secondary-color;\n    cursor: pointer;\n  }\n\n  .left {\n    background: var.$secondary-color;\n  }\n\n  .right {\n    background: var.$secondary-color;\n  }\n\n  .text {\n    color: var.$secondary-color;\n  }\n}\n\n.outline-btn {\n  $input-path: calc(100% - 12px) 100%, 100% calc(100% - 12px), 100% 12px,\n    calc(100% - 12px) 0%, 12px 0%, 0% 12px, 0% calc(100% - 12px), 12px 100%;\n  $border-width: 1.5px;\n  // all: unset;\n  position: relative;\n  min-width: 100px;\n  height: 41px;\n  width: 230px;\n  .bg {\n    position: absolute;\n    opacity: 0.8;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(#7a7373, 0.5);\n    clip-path: polygon($input-path);\n\n    &::after {\n      content: \"\";\n      position: absolute;\n      background-color: var.$dark-color;\n      clip-path: polygon($input-path);\n      inset: $border-width;\n    }\n  }\n\n  button {\n    background-color: transparent;\n    border: 0;\n    box-sizing: border-box;\n    color: var.$highlight-color;\n    font-family: \"ethnocentric\";\n    font-size: 20px;\n    text-align: center;\n    padding: 0px 35px 0px 20px;\n    width: 100%;\n    height: 100%;\n    position: relative;\n    z-index: 2;\n  }\n\n  .right-icon {\n    position: absolute;\n    right: 10px;\n    top: 5px;\n  }\n\n  &:hover {\n    .bg {\n      background-color: #24b8c0;\n    }\n\n    path {\n      opacity: 1;\n    }\n  }\n}\n\n/** End Menu Button Classes */\n\n/** content */\n@mixin content(\n  $cb-width: 2px,\n  //content-border-width\n  $border-radius: 12px,\n\n  //corner radius\n  /* title space */ $title-width: 270px,\n\n  //317\n  $title-height: 45px,\n  $title-slop: 46px,\n  $title-slope-adjust-point: 1px,\n  /* end title space */ /*bottom space */ $bottom-space-width: 340px,\n  $bottom-space-height: 40px,\n  $bottom-space-slope: 25px,\n  $bottom-left-width: calc((100% - $bottom-space-width) / 2)\n) {\n  /* clip path variables */\n\n  // $cb-width: 2px; //content-border-width\n  // $border-radius: 12px; //corner radius\n\n  // /* title space */\n  // $title-width: 267px; //317\n\n  // $title-height: 50px;\n  // $title-slop: 50px;\n  // $title-slope-adjust-point: 1px;\n  // /* end title space */\n\n  // /*bottom space */\n  // $bottom-space-width: 340px;\n  // $bottom-space-height: 40px;\n  // $bottom-space-slope: 25px;\n  // $bottom-left-width: calc((100% - $bottom-space-width) / 2);\n\n  .content-bg-darker {\n    background-color: rgba(var.$dark-color, 0.2);\n  }\n\n  /* end clip path variables */\n  .content-border {\n    background-color: rgba(var.$primary-color, 0.5);\n    min-height: 200px;\n    width: 100%;\n    height: 100%;\n    z-index: -1;\n\n    /* Content Border Path */\n    clip-path: polygon(\n      evenodd,\n      /**\n        //origin clip path\n        clip-path: polygon(evenodd, 0% 0%, 21.26% 0%, 32.24% 13.98%, 95.63% 13.98%, 100% 28.27%, 100% 89.74%, 95.63% 100%, 62.63% 100%, 53.9% 92.23%, 39.51% 92.3%, 32.24% 100%, 4% 100%, 7.8% 94.72%, 3.76% 84.99%, 3.9% 6.5%, 19.88% 6.5%, 30.02% 20.22%, 92.74% 20.22%, 95.75% 28.27%, 95.83% 88.04%, 92.74% 93.72%, 62.49% 94.72%, 54.62% 86.02%, 39.32% 85.71%, 32.24% 94.72%, 7.8% 94.72%, 4% 100%, 0% 88.99%);\n        background-color: #6beb47;\n\n        */\n        /*Outer Path */ 0% 0%,\n      /* 1 outer left start point*/ $title-width 0%,\n      /* 2 outer (Title Width) */\n        calc($title-width + $title-slop - $title-slope-adjust-point)\n        $title-height + $title-slope-adjust-point,\n      /* 3 outer Title Height */ calc(100% - $border-radius) $title-height,\n      /* 4 outer right top width to end*/ 100%\n        calc($title-height + $border-radius),\n      /* 5 outer right top height*/ 100% calc(100% - $border-radius),\n      /* 6 outer bottom height*/ calc(100% - $border-radius) 100%,\n      /* 7 outer bottom width*/ calc(100% - $bottom-left-width) 100%,\n      /* 8 outer bottom space*/\n        calc(100% - $bottom-left-width - $bottom-space-slope - $cb-width)\n        calc(100% - $bottom-space-height),\n      /* 9 outer bottom space*/\n        calc($bottom-left-width + $bottom-space-slope + $cb-width)\n        calc(100% - $bottom-space-height),\n      /* 10 outer bottom space*/ calc((100% - $bottom-space-width) / 2) 100%,\n      /* 11 outer bottom space*/ $border-radius 100%,\n      /* outer junction point */ calc($border-radius + $cb-width)\n        calc(100% - $cb-width),\n      /* inner junction point */ calc($cb-width)\n        calc(100% - $border-radius - $cb-width),\n      /* end point */ /*Inner Path*/ $cb-width $cb-width,\n      /* 1 inner left start point*/\n        ($title-width - $cb-width + $title-slope-adjust-point) $cb-width,\n      /* 2 inner (300px,Title Width */\n        (calc($title-width + $title-slop) - $cb-width)\n        ($title-height + $cb-width),\n      /* 3 inner Title Height */ calc((100% - $cb-width) - $border-radius)\n        ($title-height + $cb-width),\n      /* 4 inner right top width to end*/ calc(100% - $cb-width)\n        calc(($title-height + $cb-width) + $border-radius),\n      /* 5 inner right top height*/ calc(100% - $cb-width)\n        calc((100% - $border-radius) - $cb-width),\n      /* 6 inner bottom height*/ calc(100% - $border-radius - $cb-width)\n        calc(100% - $cb-width),\n      /* 7 inner bottom width*/ calc(100% - $bottom-left-width + $cb-width)\n        calc(100% - $cb-width),\n      /* 8 inner bottom space*/\n        calc(100% - $bottom-left-width - $bottom-space-slope)\n        calc(100% - calc($bottom-space-height + $cb-width)),\n      /* 9 inner bottom space*/ calc($bottom-left-width + $bottom-space-slope)\n        calc(100% - calc($bottom-space-height + $cb-width)),\n      /* 10 inner bottom space*/ calc($bottom-left-width - $cb-width)\n        calc(100% - $cb-width),\n      /* 11 inner bottom space*/ calc($border-radius + $cb-width)\n        calc(100% - $cb-width),\n      /* inner junction point */ $border-radius 100%,\n      /* outer junction point */ 0% calc(100% - $border-radius) /* end point */\n    );\n    /*End Content Border Path */\n  }\n  .content-border-none-bt-space {\n    background-color: rgba(var.$primary-color, 0.5);\n    min-height: 200px;\n    width: 100%;\n    height: calc(100% + 3px);\n    z-index: -1;\n\n    /* Content Border Path */\n    clip-path: polygon(\n      evenodd,\n      /**\n        //origin clip path\n        clip-path: polygon(evenodd, 0% 0%, 21.26% 0%, 32.24% 13.98%, 95.63% 13.98%, 100% 28.27%, 100% 89.74%, 95.63% 100%, 62.63% 100%, 53.9% 92.23%, 39.51% 92.3%, 32.24% 100%, 4% 100%, 7.8% 94.72%, 3.76% 84.99%, 3.9% 6.5%, 19.88% 6.5%, 30.02% 20.22%, 92.74% 20.22%, 95.75% 28.27%, 95.83% 88.04%, 92.74% 93.72%, 62.49% 94.72%, 54.62% 86.02%, 39.32% 85.71%, 32.24% 94.72%, 7.8% 94.72%, 4% 100%, 0% 88.99%);\n        background-color: #6beb47;\n\n        */\n        /*Outer Path */ 0% 0%,\n      /* 1 outer left start point*/ $title-width 0%,\n      /* 2 outer (Title Width) */\n        calc($title-width + $title-slop - $title-slope-adjust-point)\n        $title-height + $title-slope-adjust-point,\n      /* 3 outer Title Height */ calc(100% - $border-radius) $title-height,\n      /* 4 outer right top width to end*/ 100%\n        calc($title-height + $border-radius),\n      /* 5 outer right top height*/ 100% calc(100% - $border-radius),\n      /* 6 outer bottom height*/ calc(100% - $border-radius) 100%,\n      /* 7 outer bottom width*/ $border-radius 100%,\n      /* outer junction point */ calc($border-radius + $cb-width)\n        calc(100% - $cb-width),\n      /* inner junction point */ calc($cb-width)\n        calc(100% - $border-radius - $cb-width),\n      /* end point */ /*Inner Path*/ $cb-width $cb-width,\n      /* 1 inner left start point*/\n        ($title-width - $cb-width + $title-slope-adjust-point) $cb-width,\n      /* 2 inner (300px,Title Width */\n        (calc($title-width + $title-slop) - $cb-width)\n        ($title-height + $cb-width),\n      /* 3 inner Title Height */ calc((100% - $cb-width) - $border-radius)\n        ($title-height + $cb-width),\n      /* 4 inner right top width to end*/ calc(100% - $cb-width)\n        calc(($title-height + $cb-width) + $border-radius),\n      /* 5 inner right top height*/ calc(100% - $cb-width)\n        calc((100% - $border-radius) - $cb-width),\n      /* 6 inner bottom height*/ calc(100% - $border-radius - $cb-width)\n        calc(100% - $cb-width),\n      /* 7 inner bottom width*/ calc($border-radius + $cb-width)\n        calc(100% - $cb-width),\n      /* inner junction point */ $border-radius 100%,\n      /* outer junction point */ 0% calc(100% - $border-radius) /* end point */\n    );\n    /*End Content Border Path */\n  }\n\n  .title {\n    $font-size: 29px;\n\n    .font-size {\n      font-size: $font-size;\n    }\n\n    width: $title-width;\n    font-size: $font-size;\n    color: white;\n    // font-weight: 200;\n    font-family: var.$font-gkktt;\n    // background-color: red;\n    // margin-left: 5px;\n    // margin-top: 3px;\n    // background-color: rgba(var.$dark-color, 0.3);\n  }\n\n  .wide-top-space {\n    width: calc(100% - 160px) !important;\n    height: $title-height;\n  }\n  .top-space {\n    width: calc(100% - $title-width);\n    height: $title-height;\n  }\n  .body {\n    // background-color: rgba(var.$dark-color, 0.3);\n\n    .header-font {\n      font-size: 20px;\n      text-align: center;\n      // font-weight: 800;\n      // font-family: \"NotoSansJP\";\n    }\n\n    .body-font {\n      font-size: 18px;\n      font-family: \"NotoSansJP\";\n      line-height: 22px;\n    }\n\n    .publish-icon {\n      width: 28px;\n      height: 9px;\n      background-image: url(\"../icons/publish.svg\");\n      background-repeat: no-repeat;\n      cursor: pointer;\n      z-index: 1;\n      margin-top: 4px;\n      position: relative;\n\n      .publish-up-arrow {\n        transition: all 0.5s ease;\n      }\n\n      // background-color: red;\n      &:hover .publish-up-arrow1 {\n        margin-top: -18px;\n      }\n\n      &:hover .publish-up-arrow2 {\n        margin-top: -10px;\n      }\n    }\n\n    %publish-up-arrow {\n      width: 14px;\n      height: 8px;\n      background-image: url(\"../icons/publish_up_arrow.svg\");\n      background-repeat: no-repeat;\n      cursor: pointer;\n      z-index: 1;\n      position: absolute;\n      left: 7px;\n      top: 1px;\n    }\n\n    .publish-up-arrow1 {\n      @extend %publish-up-arrow;\n    }\n\n    .publish-up-arrow2 {\n      @extend %publish-up-arrow;\n    }\n\n    .edit-icon {\n      width: 38px;\n      height: 32px;\n      // margin-top: 2px;\n      position: relative;\n      background-image: url(\"../icons/edit.svg\");\n      background-repeat: no-repeat;\n      cursor: pointer;\n      &:hover {\n        // margin-top: 2px;\n        background-image: url(\"../icons/settings_icon_hover.svg\");\n      }\n    }\n\n    .pen-icon {\n      width: 50px;\n      height: 40px;\n      background-repeat: no-repeat;\n      cursor: pointer;\n      &:hover {\n        .PenToSquareSolid1 {\n          transition: 0.3s;\n          transform: translate(7px, -62%);\n        }\n\n        &::after {\n          z-index: 2;\n          opacity: 1;\n        }\n      }\n    }\n\n    .detail-more-icon {\n      width: 20px;\n      height: 20px;\n      background-image: url(\"../icons/detail_more.svg\");\n      background-repeat: no-repeat;\n      cursor: pointer;\n      &:hover {\n        transition-delay: 0.2s;\n        background-image: url(\"../icons/detail_more_hover.svg\");\n      }\n    }\n\n    .delete-icon {\n      display: inline-block;\n      width: 30px;\n      height: 40px;\n      margin-top: 3px;\n      //background-image: url(\"../icons/delete.svg\");\n      background-repeat: no-repeat;\n      cursor: pointer;\n      z-index: 1;\n      position: relative;\n      &::after {\n        background-color: var.$dark-color;\n        content: \"削除\";\n        width: max-content;\n        padding: 2px 5px;\n        border: 1px solid var.$primary-color;\n        position: absolute;\n        color: var.$light-color;\n        font-size: 11px;\n        text-align: center;\n        left: -37px;\n        bottom: 40px;\n        z-index: 0;\n        opacity: 0;\n        transition: all 0.5s ease-in-out;\n      }\n      &:hover {\n        .trash-can-solid-2 {\n          margin-top: 3px;\n          transition: 0.3s;\n          transform: matrix(0.829, -0.545, 0.545, 0.829, -1, 0.878);\n          fill: var.$primary-color;\n        }\n        .trash-can-solid {\n          fill: var.$primary-color;\n        }\n        &::after {\n          z-index: 2;\n          opacity: 1;\n        }\n      }\n\n      // background-color: red;\n    }\n\n    .parameter-delete-icon {\n      cursor: pointer;\n      z-index: 1;\n      position: relative;\n\n      &::after {\n        background-color: var.$dark-color;\n        content: \"削除\";\n        width: max-content;\n        padding: 2px 5px;\n        border: 1px solid var.$primary-color;\n        position: absolute;\n        color: var.$light-color;\n        font-size: 11px;\n        text-align: center;\n        left: -20px;\n        bottom: 30px;\n        z-index: 0;\n        opacity: 0;\n        transition: all 0.5s ease-in-out;\n      }\n      &:hover {\n        .trash-can-solid-2 {\n          z-index: 5;\n          margin-top: 3px;\n          transition: 0.3s;\n          transform: matrix(0.829, -0.545, 0.545, 0.829, -1, 0.878);\n          fill: var.$primary-color;\n        }\n        .trash-can-solid {\n          fill: var.$primary-color;\n        }\n        &::after {\n          z-index: 2;\n          opacity: 1;\n        }\n      }\n    }\n\n    .arrow-icon {\n      width: 16px;\n      height: 18px;\n      background-image: url(\"../icons/arrow.svg\");\n      background-repeat: no-repeat;\n      cursor: pointer;\n      z-index: 1;\n      // background-color: red;\n    }\n\n    .uncheck-icon {\n      width: 25px;\n      height: 25px;\n      background-image: url(\"../icons/uncheck.svg\");\n      background-repeat: no-repeat;\n      cursor: pointer;\n      z-index: 1;\n      // background-color: red;\n    }\n\n    .check-icon {\n      width: 25px;\n      height: 25px;\n      background-image: url(\"../icons/check.svg\");\n      background-repeat: no-repeat;\n      cursor: pointer;\n      z-index: 1;\n      // background-color: red;\n    }\n\n    .dropdown-icon {\n      width: 16px;\n      height: 16px;\n      background-image: url(\"../icons/dropdown.svg\");\n      background-repeat: no-repeat;\n      cursor: pointer;\n      z-index: 1;\n      // background-color: red;\n    }\n\n    .copy-icon {\n      width: 20px;\n      height: 20px;\n      background-image: url(\"../icons/copy.svg\");\n      background-repeat: no-repeat;\n      cursor: pointer;\n      z-index: 1;\n      // background-color: red;\n    }\n\n    .plus-icon {\n      width: 20px;\n      height: 20px;\n      background-image: url(\"../icons/plus.svg\");\n      background-repeat: no-repeat;\n      cursor: pointer;\n      z-index: 1;\n      // background-color: red;\n    }\n\n    .minus-icon {\n      width: 20px;\n      height: 20px;\n      background-image: url(\"../icons/minus.svg\");\n      background-repeat: no-repeat;\n      cursor: pointer;\n      z-index: 1;\n      // background-color: red;\n    }\n    .close-icon {\n      width: 20px;\n      height: 20px;\n      background-image: url(\"../icons/plus.svg\");\n      background-repeat: no-repeat;\n      cursor: pointer;\n      z-index: 1;\n      rotate: 45deg;\n    }\n    .grey-minus-icon {\n      width: 20px;\n      height: 20px;\n      background-image: url(\"../icons/grey_minus.svg\");\n      background-repeat: no-repeat;\n      cursor: pointer;\n      z-index: 1;\n      // background-color: red;\n    }\n\n    .pink-plus-icon {\n      width: 20px;\n      height: 20px;\n      background-image: url(\"../icons/pink-plus.svg\");\n      background-repeat: no-repeat;\n      cursor: pointer;\n      z-index: 1;\n      // background-color: red;\n    }\n\n    .random-plus {\n      width: 30px;\n      height: 30px;\n      background-image: url(\"../icons/random-plus.svg\");\n      background-repeat: no-repeat;\n      cursor: pointer;\n      z-index: 1;\n      &:hover {\n        background-image: url(\"../icons/random-plus-hover.svg\");\n      }\n    }\n    .random-plus-disable {\n      width: 30px;\n      height: 30px;\n      background-image: url(\"../icons/random-plus-disable.svg\");\n      background-repeat: no-repeat;\n      cursor: pointer;\n      z-index: 1;\n    }\n  }\n\n  .bottom {\n    .space-width {\n      width: $bottom-space-width;\n    }\n\n    .font-size {\n      font-size: 25px;\n    }\n\n    .left-arrow {\n      width: 50px;\n      height: 15px;\n      background-image: url(\"../icons/left-arrow.svg\");\n      background-repeat: no-repeat;\n      margin-top: 27px;\n      cursor: pointer;\n      // background-color: red;\n    }\n\n    .left-arrow:hover {\n      background-image: url(\"../icons/left-arrow-filled.svg\");\n    }\n\n    .right-arrow {\n      width: 50px;\n      height: 15px;\n      background-image: url(\"../icons/left-arrow.svg\");\n      background-repeat: no-repeat;\n      -webkit-transform: scaleX(-1);\n      transform: scaleX(-1);\n      margin-top: 27px;\n      cursor: pointer;\n      // background-color: red;\n    }\n\n    .right-arrow:hover {\n      background-image: url(\"../icons/left-arrow-filled.svg\");\n      -webkit-transform: scaleX(-1);\n      transform: scaleX(-1);\n    }\n  }\n}\n\n.content {\n  @include content();\n}\n\n.marketplace-content {\n  @include content($title-width: 370px);\n}\n\n.persona-market-content {\n  @include content($title-width: 420px);\n}\n\n.persona-up-content {\n  @include content($title-width: 310px);\n}\n\n.drawchain-create-content {\n  @include content($title-width: 370px);\n}\n\n.content-wide-title {\n  @include content($title-width: 320px);\n}\n.content-wider-title {\n  @include content($title-width: 380px);\n}\n\n.update-history-content {\n  @include content($title-width: 264.12px);\n}\n\n.users-content {\n  @include content(2px, 12px, 275.56px);\n}\n\n.setting-content {\n  @include content(2px, 12px, 270px);\n}\n/** end content */\n.login-box {\n  width: 910px;\n  height: 510px;\n  // background-color: var.$dark-color;\n  // border: 1px solid rgba(36, 184, 192, 0.5);\n  margin: auto;\n\n  // @media (max-width: 1024px) {\n  //     height: 100%;\n  //     width: 85%;\n  //     margin-bottom: auto;\n  // }\n}\n\n/** Input Classes */\n.activate-on-hover:hover {\n  opacity: 1;\n\n  .text-box {\n    opacity: 1;\n  }\n}\n\n.hide-placeholder:focus::placeholder {\n  color: transparent !important;\n}\n\n.smaller-placeholder::placeholder {\n  font-size: 15px !important;\n  // color: rgba(white, 0.6) !important;\n  color: #9a9a9a;\n}\n\n.large-placeholder::placeholder {\n  font-size: 17px !important;\n}\n\n.lighter-placeholder::placeholder {\n  color: rgba(white, 0.4) !important;\n}\n\n.center-placeholder {\n  padding-bottom: 0.5% !important;\n}\n.center-placeholder::placeholder {\n  text-align: center !important;\n}\n\n.left-placeholder::placeholder {\n  text-align: left !important;\n}\n\n.inherit-placeholder::placeholder {\n  color: inherit !important;\n  font-size: inherit !important;\n}\n\n.hiragino-sans-placeholder::placeholder {\n  font-family: \"Hiragino Sans\" !important;\n}\n// These classes were written because I do not know how to set minus margin with\n// bootstrap clases, please forgive me for sinning.\n.font-18px-impt {\n  font-size: 18px !important;\n}\n.minus-margin {\n  margin-top: -7px;\n}\n\n.person-icon {\n  background-color: transparent;\n  border: 0;\n  position: relative;\n  z-index: 1;\n\n  &::after {\n    background-color: var.$dark-color;\n    content: \"ペルリア追加発行\";\n    width: max-content;\n    padding: 2px 5px;\n    border: 1px solid var.$primary-color;\n    position: absolute;\n    color: var.$light-color;\n    font-size: 11px;\n    text-align: center;\n    left: -55px;\n    bottom: 25px;\n    z-index: 1;\n    opacity: 0;\n    transition: all 0.5s ease-in-out;\n  }\n  &:hover {\n    path {\n      opacity: 1;\n    }\n    &::after {\n      z-index: 2;\n      opacity: 1;\n    }\n  }\n}\n\n.upload-icon {\n  background-color: transparent;\n  border: 0;\n  position: relative;\n  z-index: 1;\n\n  &::after {\n    background-color: var.$dark-color;\n    content: \"売り出し設定\";\n    width: max-content;\n    padding: 2px 5px;\n    border: 1px solid var.$primary-color;\n    position: absolute;\n    color: var.$light-color;\n    font-size: 11px;\n    text-align: center;\n    left: -55px;\n    bottom: 25px;\n    z-index: 1;\n    opacity: 0;\n    transition: all 0.5s ease-in-out;\n  }\n  &:hover {\n    path {\n      opacity: 1;\n    }\n    &::after {\n      z-index: 2;\n      opacity: 1;\n    }\n  }\n}\n\n// text box\n@mixin text-input($radius: 12px, $border-width: 1.5px) {\n  // $input-path: calc(100% - $radius) 100%, 100% 75%, 100% 25%,\n  //   calc(100% - $radius) 0%, $radius 0%, 0% 25%, 0% 75%, $radius 100%;\n  $input-path: calc(100% - 12px) 100%, 100% calc(100% - 12px), 100% 12px,\n    calc(100% - 12px) 0%, 12px 0%, 0% 12px, 0% calc(100% - 12px), 12px 100%;\n  // all: unset;\n  position: relative;\n  min-width: 100px;\n  height: 40px;\n\n  &:focus-within {\n    opacity: 1;\n    .text-box {\n      background-color: #24b8c0;\n    }\n  }\n\n  &:hover {\n    opacity: 1;\n    .text-box:not(.disabled) {\n      background-color: #24b8c0;\n    }\n    path {\n      opacity: 1;\n    }\n  }\n\n  &:has(input:valid) {\n    opacity: 1;\n  }\n\n  .text-box {\n    position: absolute;\n    top: 0px;\n    opacity: 0.8;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(var.$primary-color, 0.8);\n    clip-path: polygon($input-path);\n\n    &::after {\n      content: \"\";\n      position: absolute;\n      background-color: var.$dark-color;\n      clip-path: polygon($input-path);\n      inset: $border-width;\n    }\n  }\n\n  .error-border {\n    background-color: rgba(var.$danger-color, 0.4); //border opacity\n  }\n  .inactive {\n    background-color: rgba(#7a7373, 0.5);\n  }\n  .input {\n    position: relative;\n    color: white;\n    // font-size: 20px;\n  }\n\n  .textarea {\n    position: absolute;\n    color: white;\n    left: 0;\n    resize: none;\n    padding-block: 10px;\n  }\n\n  .text-form-control-value {\n    box-sizing: border-box;\n    color: var.$highlight-color;\n    font-family: \"ethnocentric\";\n    font-size: 20px;\n    text-align: center;\n    padding: 0px 20px;\n  }\n\n  .text-form-control {\n    box-sizing: border-box;\n    font-size: 20px;\n    padding: 0px 20px;\n  }\n\n  .form-control-right-icon {\n    position: absolute;\n    right: 12px;\n    top: 5px;\n  }\n\n  .form-control-left-icon {\n    position: absolute;\n    left: 15px;\n    top: 7px;\n  }\n\n  .text-form-control-border {\n    background-color: #020202;\n  }\n\n  %error {\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n    color: var.$danger-color;\n    position: absolute;\n    right: 0;\n    bottom: -22px;\n    font-family: \"NotoSansJP\";\n  }\n\n  .error {\n    @extend %error;\n  }\n\n  .error-without-right {\n    @extend %error;\n    right: unset;\n    bottom: -25px;\n  }\n\n  .error-left-align {\n    @extend %error;\n    left: 0;\n    overflow: visible;\n  }\n\n  input,\n  textarea {\n    // all: unset;\n    @extend %unset-input;\n    caret-color: #24b8c0;\n    height: 100%;\n    width: 100%;\n    z-index: 1;\n    padding: 0 16px;\n    font-family: \"Europa\";\n    font-size: 14px;\n    // background-color: antiquewhite;\n    // font-size: 20px;\n    // text-align: center;\n    &::placeholder {\n      font-size: 14px;\n      color: #9a9a9a;\n      vertical-align: middle;\n      font-family: inherit;\n\n      // height: 100%;\n      // line-height: normal;\n    }\n    &:focus::placeholder {\n      color: transparent;\n    }\n  }\n\n  .form-control-left-icon ~ input,\n  .form-control-left-icon ~ textarea {\n    padding-left: 40px;\n  }\n\n  .form-control-right-icon ~ input,\n  .form-control-right-icon ~ textarea {\n    padding-right: 40px;\n  }\n}\n\ninput[type=\"number\"]::-webkit-outer-spin-button,\ninput[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.text-input {\n  @include text-input();\n}\n.text-input-lesser-radius {\n  @include text-input($radius: 10px);\n}\n.text-input-bigger-border {\n  @include text-input($radius: 10px, $border-width: 2.5px);\n}\n.text-input-big-border {\n  @include text-input($radius: 16px, $border-width: 2px);\n}\n.text-input-lesser-opacity {\n  @include text-input();\n\n  opacity: 0.6;\n  input {\n    caret-color: rgba(var.$primary-color, 0.6);\n  }\n}\n.text-input-white-caret {\n  @include text-input();\n\n  input {\n    caret-color: white;\n  }\n}\n\n.button-input {\n  @include text-input();\n\n  &:focus-within {\n    opacity: 1;\n    .text-box {\n      background-color: rgba(#7a7373, 0.5);\n    }\n  }\n\n  &:hover {\n    opacity: 1;\n    .text-box:not(.disabled) {\n      background-color: rgba(#7a7373, 0.5);\n    }\n    path {\n      opacity: 1;\n    }\n  }\n\n  &:active {\n    opacity: 1;\n    .text-box:not(.disabled) {\n      background-color: rgba(#a8a1a1, 0.5);\n    }\n  }\n  input[data-exist=\"0\"] {\n    font-family: \"NotoSansJP-light\" !important;\n  }\n\n  input[data-exist=\"1\"] {\n    font-family: \"ethno-light\" !important;\n    font-weight: 300;\n  }\n}\n\n//end text box\n\n//Login Input\n.login-input {\n  $radius: 16px;\n  $border-width: 1px;\n  $input-path: calc(100% - $radius) 100%, 100% 75%, 100% 25%,\n    calc(100% - $radius) 0%, $radius 0%, 0% 25%, 0% 75%, $radius 100%;\n\n  $button-radius: 16px;\n  $wrapper-border-width: 3.5px;\n  $left-wrapper: calc($button-radius + $wrapper-border-width) 100%,\n    $wrapper-border-width 75%, $wrapper-border-width 25%,\n    calc($button-radius + $wrapper-border-width) 0%, $button-radius 0%, 0% 22%,\n    0% 78%, $button-radius 100%;\n  // all: unset;\n  position: relative;\n  min-width: 100px;\n  min-height: 30px;\n  opacity: 0.6;\n\n  &:focus-within {\n    opacity: 1;\n  }\n\n  &:has(input:valid) {\n    opacity: 1;\n  }\n\n  .left-wrapper {\n    position: absolute;\n    width: 25px;\n    height: 55px;\n    clip-path: polygon($left-wrapper);\n    background-color: var.$primary-color;\n    margin-left: -6px;\n  }\n\n  .text-box {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(var.$primary-color, 0.5);\n    clip-path: polygon($input-path);\n\n    &::after {\n      content: \"\";\n      position: absolute;\n      background-color: var.$dark-color;\n      clip-path: polygon($input-path);\n      inset: $border-width;\n    }\n  }\n\n  .right-wrapper {\n    position: absolute;\n    width: 25px;\n    height: 55px;\n    clip-path: polygon($left-wrapper);\n    background-color: var.$primary-color;\n    margin-left: 95%;\n    transform: scaleX(-1);\n  }\n\n  .input {\n    position: absolute;\n    color: white;\n  }\n\n  input {\n    // all: unset;\n    @extend %unset-input;\n\n    height: 100%;\n    width: 100%;\n    z-index: 1;\n    // padding: 0 70px 0;\n    padding-left: 50px;\n    // text-align: center;\n\n    &::placeholder {\n      // text-align: center;\n      letter-spacing: 0px;\n      color: #9a9a9a;\n      font-size: 17px;\n    }\n  }\n}\n\n//End Login input\n\n//input icon\n.icon {\n  background-image: url(../images/user-solid.png);\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-position: 20%;\n  padding: 10px;\n  position: absolute;\n  box-sizing: border-box;\n  top: 50%;\n  left: 0;\n  transform: translateY(-50%);\n  z-index: 1;\n}\n\n.icon-lock {\n  background-image: url(../images/lock-solid.png);\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-position: 20%;\n  padding: 13px;\n  position: absolute;\n  box-sizing: border-box;\n  top: 50%;\n  left: 0;\n  transform: translateY(-50%);\n  z-index: 1;\n}\n\n.input-row {\n  position: relative;\n}\n\n//end input icon\n\n// search input box\n.search-input {\n  $radius: 10px;\n  $slope: 40px;\n  $inner-start-point: 3px;\n  opacity: 0.7;\n\n  .search-box {\n    clip-path: polygon(\n      calc(100% - $radius) 100%,\n      100% calc(100% - $radius),\n      100% $radius,\n      calc(100% - $radius) 0%,\n      0% 0%,\n      $slope 100%\n    );\n    background-color: rgba(var.$primary-color, 0.5);\n    min-width: 100px;\n    min-height: 30px;\n    width: 100%;\n    height: 100%;\n    position: relative;\n    padding-left: 50px;\n\n    .input {\n      position: static;\n    }\n\n    .search-icon {\n      z-index: 1;\n      margin-right: 10px;\n    }\n  }\n\n  &:focus-within {\n    opacity: 1;\n    .search-box {\n      opacity: 1;\n      background-color: #24b8c0;\n      background-color: #24b8c0;\n    }\n  }\n\n  &:has(input:valid) {\n    opacity: 1;\n  }\n\n  .search-box::after {\n    content: \"\";\n    position: absolute;\n    inset: 2px;\n    clip-path: polygon(\n      calc(100% - $radius) 100%,\n      100% calc(100% - $radius),\n      100% $radius,\n      calc(100% - $radius) 0%,\n      $inner-start-point 0%,\n      $slope 100%\n    );\n    background-color: var.$dark-color;\n  }\n\n  .input {\n    height: 95%;\n    position: absolute;\n    color: white;\n    // caret-color: rgba(var.$primary-color, 1);\n    caret-color: #24b8c0;\n  }\n\n  .input::placeholder {\n    color: white;\n  }\n\n  input {\n    all: unset;\n    height: 100%;\n    width: 100%;\n    padding-left: 0px;\n    z-index: 1;\n  }\n}\n\n// end search input box\n\n/** End Input Classes */\n\n/** Button Classes */\n\n//base button\n@mixin button($font-family: var.$font-gkktt, $font-size: 18px) {\n  $border-width: 1px;\n  $button-radius: 12px;\n  $button-path: calc(100% - $button-radius) 100%, 100% 75%, 100% 25%,\n    calc(100% - $button-radius) 0%, $button-radius 0%, 0% 25%, 0% 75%,\n    $button-radius 100%;\n\n  $wrapper-border-width: 4px;\n  $button-wrapper-path: calc($button-radius + $wrapper-border-width) 100%,\n    $wrapper-border-width 75%, $wrapper-border-width 25%,\n    calc($button-radius + $wrapper-border-width) 0%, $button-radius 0%, 0% 22%,\n    0% 78%, $button-radius 100%;\n\n  position: relative;\n  min-width: 100px;\n  min-height: 20px;\n  background-color: transparent;\n  border: none;\n\n  // width: 100%;\n  // height: 100%;\n\n  cursor: pointer;\n  // background-color: red;\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n\n  .left-wrapper {\n    position: absolute;\n    clip-path: polygon($button-wrapper-path);\n    background-color: #e45a1b;\n    inset: 1px;\n  }\n\n  .right-wrapper {\n    position: absolute;\n    clip-path: polygon($button-wrapper-path);\n    background-color: #e45a1b;\n    inset: 1px;\n    -webkit-transform: scaleX(-1);\n    transform: scaleX(-1);\n  }\n\n  .inner {\n    position: absolute;\n    background-color: var.$btn-primary-color;\n    clip-path: polygon($button-path);\n    inset: 1px;\n    margin-left: 7px;\n    margin-right: 7px;\n    // left: 8px;\n    // right: 8px;\n  }\n\n  .inner::after {\n    content: \"\";\n    position: absolute;\n    background-color: var.$dark-color;\n    clip-path: polygon($button-path);\n    inset: $border-width;\n  }\n\n  .text {\n    color: var.$light-color;\n    font-size: $font-size;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    font-family: $font-family;\n    width: 100%;\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  &:hover {\n    path {\n      fill: var.$dark-color;\n    }\n  }\n\n  .left-icon {\n    position: absolute;\n    left: 20px;\n    top: 3px;\n  }\n\n  .box-button {\n    color: var.$light-color;\n    font-size: $font-size;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    font-family: \"Ethno\";\n    width: 100%;\n    text-align: center;\n  }\n}\n\n%button {\n  @include button();\n}\n\n//end base button\n\n//primary button\n.button-primary {\n  @include button();\n\n  .inner {\n    background-color: rgba(var.$primary-color, 0.5);\n  }\n\n  &:hover {\n    .inner {\n      opacity: 1;\n    }\n\n    .inner::after {\n      // background-color: var.$primary-color;\n      @include primary-gradient;\n    }\n\n    .text {\n      color: var.$dark-color;\n    }\n\n    .box-button {\n      color: var.$dark-color;\n    }\n  }\n}\n//end primary button\n\n//cancel button\n.button-cancel {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  gap: 15px;\n  cursor: pointer;\n\n  .text {\n    color: var.$light-color;\n    font-size: 16px;\n    font-family: var.$font-gkktt;\n  }\n\n  &:hover {\n    .text {\n      color: var.$primary-color;\n    }\n  }\n}\n//end cancel button\n\n//grey (disabled?) button\n.button-grey {\n  @include button();\n\n  .inner {\n    background-color: rgba(#7a7373, 0.5);\n  }\n  .left-wrapper {\n    background-color: #7a7373;\n  }\n\n  .right-wrapper {\n    background-color: #7a7373;\n  }\n  .text {\n    color: #7a7373;\n  }\n  &:hover {\n    .inner {\n      opacity: 1;\n    }\n\n    .inner::after {\n      background-color: var.$primary-color;\n    }\n\n    .text {\n      color: var.$dark-color;\n    }\n\n    .box-button {\n      color: var.$dark-color;\n    }\n  }\n}\n//end grey button\n\n//primary button\n.button-dialog {\n  @include button($font-family: \"ethno-light\", $font-size: 15px);\n  .text {\n    margin-top: -3px;\n  }\n\n  .inner {\n    background-color: rgba(var.$primary-color, 0.3);\n  }\n\n  &:hover {\n    .inner {\n      opacity: 1;\n    }\n\n    .inner::after {\n      background-color: var.$primary-color;\n      @include primary-gradient();\n    }\n\n    // .text {\n    //   color: var.$dark-color;\n    // }\n\n    .box-button {\n      color: var.$dark-color;\n    }\n  }\n}\n//end primary button\n\n//menu button\n%button-menu-state {\n  .left-wrapper {\n    background-color: #e45a1b;\n  }\n\n  .inner {\n    background-color: #e45a1b;\n  }\n\n  .inner::after {\n    @include primary-gradient;\n  }\n\n  .right-wrapper {\n    background-color: #e45a1b;\n  }\n\n  .text {\n    color: var.$light-color;\n  }\n\n  .box-button {\n    color: var.$btn-primary-color;\n  }\n}\n\n.button-menu {\n  @extend %button;\n\n  .text {\n    font-size: inherit;\n  }\n\n  .inner {\n    box-sizing: content-box;\n    background-color: rgba(var.$primary-color, 0.3);\n  }\n\n  &:hover {\n    @extend %button-menu-state;\n  }\n}\n\n.selected-button-menu {\n  @extend %button;\n  @extend %button-menu-state;\n}\n\n//end menu button\n\n// plus button\n\n.button-plus {\n  background-color: transparent;\n  border: 0;\n  position: relative;\n  &::after {\n    background-color: var.$dark-color;\n    content: \"追加\";\n    width: max-content;\n    padding: 2px 5px;\n    border: 1px solid var.$primary-color;\n    position: absolute;\n    color: var.$light-color;\n    font-size: 11px;\n    text-align: center;\n    left: -30px;\n    bottom: 20px;\n    z-index: 0;\n    opacity: 0;\n    transition: all 0.5s ease-in-out;\n  }\n  &:hover {\n    path {\n      stroke: var.$primary-color;\n    }\n    &::after {\n      z-index: 2;\n      opacity: 1;\n    }\n  }\n}\n\n// end plus button\n\n// increase and decrease buttons\n.in-de-btn {\n  background-color: transparent;\n  border: 0;\n  margin: 0;\n  padding: 0;\n\n  // &:hover {\n  //   path {\n  //     stroke: var.$primary-color;\n  //   }\n  //   .path {\n  //     fill: var.$primary-color;\n  //   }\n  // }\n}\n// end increase and decrease buttons\n\n/** select persona button **/\n\n.button-select-persona {\n  $input-path: calc(100% - 12px) 100%, 100% calc(100% - 12px), 100% 12px,\n    calc(100% - 12px) 0%, 12px 0%, 0% 12px, 0% calc(100% - 12px), 12px 100%;\n  min-width: 196px;\n  width: 296px;\n  height: 40px;\n  position: relative;\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(#7a7373, 0.5);\n    clip-path: polygon($input-path);\n  }\n\n  &:disabled {\n    background-color: red;\n  }\n\n  &:not(.disabled):hover:before,\n  &:not(.disabled):focus::before {\n    background-color: #24b8c0;\n  }\n\n  button {\n    position: absolute;\n    border: none;\n    background-color: transparent;\n    padding: 10px 16px;\n    text-align: center;\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n  }\n\n  &::after {\n    content: \"\";\n    position: absolute;\n    clip-path: polygon($input-path);\n    inset: 1.5px 1px 1.5px 2px;\n    background-color: var.$dark-color;\n  }\n}\n\n/** end select persona button **/\n\n/** End Button Classes */\n\n//box\n@mixin message-box($box-slope: 24px, $side-path-width: 38px) {\n  position: relative;\n  $slope: $box-slope;\n\n  .container {\n    clip-path: polygon(\n      calc(5% + 2px) 3px,\n      calc(95% - 2px) 3px,\n      calc(100% - 4px) calc(10% + 2px),\n      calc(100% - 4px) calc(90% + -2px),\n      calc(95% - 3px) calc(100% - 3px),\n      calc(5% + 2px) calc(100% - 3px),\n      3px calc(90% - 2px),\n      3px calc(10% + 2px)\n    );\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background-color: black;\n    width: 100%;\n    height: 100%;\n  }\n\n  .outside-box-top {\n    // clip-path: polygon(\n    //   $slope 0,\n    //   calc(100% - $slope) 0,\n    //   100% $slope,\n    //   100% calc(100% - $slope),\n    //   calc(100% - $slope) 100%,\n    //   $slope 100%,\n    //   0 calc(100% - $slope),\n    //   0 $slope\n    // );\n    // position: absolute;\n    // // overflow: visible;\n    // width: 100%;\n    // height: 100%;\n    // // background-color: rgba(var.$primary-color, 0.7);\n    // z-index: -1;\n\n    // clip-path: polygon(5% 0px, 95% 0px, 100% 10%, calc(99% + 2px) 10%, calc(95% - 1px) 1%, calc(5% + 1px) 1%, calc(1% - 2px) 10%, 0px 10%);\n    clip-path: polygon(\n      0px 40%,\n      0px 10%,\n      5% 0%,\n      95% 0%,\n      100% 10%,\n      100% 40%,\n      calc(100% - 3px) 40%,\n      calc(100% - 3px) calc(10% + 2px),\n      calc(95% - 2px) 3px,\n      calc(5% + 2px) 3px,\n      3px calc(10% + 2px),\n      calc(0% + 3px) 40%\n    );\n    background-color: var.$primary-color;\n    height: 100%;\n    width: 100%;\n    opacity: 0.7;\n    position: absolute;\n  }\n\n  .outside-box-bottom {\n    clip-path: polygon(\n      0px 40%,\n      0px 10%,\n      5% 0%,\n      95% 0%,\n      100% 10%,\n      100% 40%,\n      calc(100% - 3px) 40%,\n      calc(100% - 3px) calc(10% + 2px),\n      calc(95% - 2px) 3px,\n      calc(5% + 2px) 3px,\n      3px calc(10% + 2px),\n      calc(0% + 3px) 40%\n    );\n    background-color: var.$primary-color;\n    height: 100%;\n    width: 100%;\n    opacity: 0.7;\n    position: absolute;\n    top: 0;\n    left: 0;\n    transform: rotateX(180deg);\n  }\n\n  .middle-choose-group-right-box {\n    content: \"\";\n    position: absolute;\n    display: block;\n    width: 50%;\n    height: 27%;\n    z-index: 0;\n    top: 33.5%;\n    right: 0;\n    background-color: var.$dark-color;\n  }\n\n  .middle-choose-group-left-box {\n    content: \"\";\n    position: absolute;\n    display: block;\n    width: 50%;\n    height: 15%;\n    z-index: 0;\n    top: 46%;\n    left: 0;\n    background-color: var.$dark-color;\n  }\n\n  .middle-box {\n    content: \"\";\n    position: absolute;\n\n    display: block;\n    width: calc(100% + 2px);\n    margin-left: -0.6px;\n    height: 20%;\n    z-index: 0;\n    top: 38%;\n    left: 0;\n    right: 0;\n    // background-color: var.$dark-color;\n    // background-color: red;\n  }\n\n  .inside-box {\n    clip-path: polygon(\n      $slope 0,\n      calc(100% - $slope) 0,\n      100% $slope,\n      100% calc(100% - $slope),\n      calc(100% - $slope) 100%,\n      $slope 100%,\n      0 calc(100% - $slope),\n      0 $slope\n    );\n    content: \"\";\n    position: absolute;\n    display: block;\n    inset: 3px;\n    // background-color: var.$dark-color;\n  }\n\n  .save-box {\n    .body {\n      // width: 100%;\n      .container-box {\n        width: 100%;\n        height: 100%;\n      }\n\n      .button-row {\n        width: 100%;\n        padding: 0;\n        justify-content: center;\n        margin-top: 70px;\n      }\n\n      .con-button {\n        width: 182px;\n        height: 40px;\n      }\n    }\n\n    .path {\n      margin-top: 155px;\n    }\n  }\n\n  .side-path {\n    $border-width: 2px;\n    $slope: 25px;\n    clip-path: polygon(\n      0% $border-width,\n      0% 0%,\n      calc(60% + $border-width) $slope,\n      calc(60% + $border-width) 100%,\n      60% 100%,\n      60% calc($slope + $border-width)\n    );\n    background-color: var.$primary-color;\n    height: 40%;\n    width: $side-path-width;\n    opacity: 0.7;\n    // z-index: 0;\n  }\n}\n\n.message-box {\n  @include message-box();\n}\n\n.group-select-message-box {\n  @include message-box($box-slope: 35px, $side-path-width: 50px);\n}\n\n//end box\n\n//Login Button\n.button-text {\n  color: black;\n  background-image: url(\"../images/btn-hover.svg\");\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-position: center;\n}\n\n.button-text:hover {\n  color: var.$dark-color;\n  background-image: url(\"../images/btn-hover.svg\");\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-position: center;\n}\n\n.link {\n  text-decoration: none;\n}\n\n//End Login Button\n\n.error-border {\n  background-color: rgba(var.$danger-color, 0.4) !important; //border opacity\n}\n\n.img-container {\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n}\n\n.persona-img-container {\n  // width: 262px;\n  // height: 350px;\n  width: 284px;\n  height: 325px;\n}\n\n.drawchain-thumbnail-container {\n  width: 349.95px;\n  height: 232.68px;\n  border: 1px solid #7a73738f;\n}\n\n.drawchain-v-thumbnail-container {\n  width: 155px;\n  height: 232.68px;\n  border: 1px solid #7a73738f;\n}\n\n.marketplace-img-container {\n  width: 120px;\n  height: 40px;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  img {\n    width: 64px;\n    height: 34px;\n    object-fit: contain;\n  }\n\n  .icon-container {\n    position: absolute;\n    right: -20px;\n    bottom: -14px;\n    background-color: #3d3939;\n    width: 28px;\n    height: 28px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 100%;\n    border: 0;\n    z-index: 1;\n    &::after {\n      background-color: var.$dark-color;\n      content: \"画像設定\";\n      width: max-content;\n      padding: 2px 5px;\n      border: 1px solid var.$primary-color;\n      position: absolute;\n      color: var.$light-color;\n      font-size: 11px;\n      text-align: center;\n      left: -20px;\n      bottom: 30px;\n      z-index: 1;\n      opacity: 1;\n      transition: all 0.5s ease-in-out;\n    }\n    &:hover {\n      path {\n        opacity: 1;\n      }\n      &::after {\n        z-index: 2;\n        opacity: 1;\n      }\n    }\n  }\n}\n\n.image-box {\n  z-index: 0;\n  $border-width: 1px;\n  $button-radius: 10px;\n  $path: calc(100% - $button-radius) 100%, 100% 97.5%, 100% 2.5%,\n    calc(100% - $button-radius) 0%, $button-radius 0%, 0% 2.5%, 0% 97.5%,\n    $button-radius 100%;\n\n  // clip-path: polygon($path);\n  // background-color: var.$primary-color;\n  min-width: 100px;\n  min-height: 20px;\n\n  position: relative;\n  background-color: rgba(var.$primary-color, 0.5);\n  clip-path: polygon($path);\n\n  .dark-bg {\n    // content: \"\";\n    position: absolute;\n    background-color: var.$dark-color;\n    clip-path: polygon($path);\n    // background-image: url(\"../images/input_name.png\");\n    inset: $border-width;\n  }\n\n  .upload-image {\n    position: absolute;\n    clip-path: polygon($path);\n    inset: $border-width;\n    z-index: 2;\n    // inset: $border-width;\n    // background-image: url(\"../images/input_name.png\");\n    // background-repeat: no-repeat;\n    // background-size: cover;\n  }\n}\n\n.cust-modal {\n  .overlay {\n    width: 100vw;\n    height: 100vh;\n    inset: 0;\n    position: fixed;\n    background-color: rgba(1, 1, 1, 0.852);\n    z-index: 10;\n    transition: all 0.5s ease-in-out;\n    opacity: 0;\n    visibility: hidden;\n  }\n\n  .modal-content {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 10;\n    transition: all 0.5s ease-in-out;\n    opacity: 0;\n    visibility: hidden;\n  }\n}\n\n.show-modal {\n  .overlay,\n  .modal-content {\n    opacity: 1;\n    visibility: visible;\n  }\n}\n\n//loading modal\n\n.loading-text {\n  animation: loading forwards;\n  animation-duration: 10s;\n  // position: relative;\n  animation-fill-mode: forwards;\n}\n\n@keyframes loading {\n  0% {\n    opacity: 1;\n  }\n\n  20% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0.2;\n  }\n\n  100% {\n    opacity: 0;\n  }\n}\n\n.loading-complete-text {\n  animation: loading_complete forwards;\n  animation-duration: 10s;\n  // position: relative;\n  animation-fill-mode: forwards;\n}\n\n@keyframes loading_complete {\n  0% {\n    opacity: 0;\n  }\n\n  20% {\n    opacity: 0;\n  }\n\n  50% {\n    opacity: 0.5;\n  }\n\n  75% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n.app-text::after {\n  content: \"\";\n  animation: spin forwards;\n  animation-duration: 10s;\n  position: relative;\n  animation-fill-mode: forwards;\n}\n\n@keyframes spin {\n  0% {\n    content: \"ローディング. . . .\";\n    opacity: 1;\n  }\n\n  20% {\n    content: \"ローディング. . . .\";\n    opacity: 0.5;\n  }\n\n  40% {\n    content: \"ローディング. . . .\";\n    opacity: 0.1;\n  }\n\n  50% {\n    content: \"完了\";\n    opacity: 0.1;\n  }\n\n  70% {\n    content: \"完了\";\n    opacity: 0.7;\n  }\n\n  100% {\n    content: \"完了\";\n    opacity: 1;\n  }\n}\n\n.re-text::after {\n  content: \"\";\n  animation: animate forwards;\n  animation-duration: 10s;\n  position: relative;\n  animation-fill-mode: forwards;\n}\n\n@keyframes animate {\n  0% {\n    content: \"発行中. . . . .\";\n    opacity: 1;\n  }\n\n  20% {\n    content: \"発行中. . . . .\";\n    opacity: 0.5;\n  }\n\n  40% {\n    content: \"発行中. . . . .\";\n    opacity: 0.1;\n  }\n\n  50% {\n    content: \"完了\";\n    opacity: 0.1;\n  }\n\n  70% {\n    content: \"完了\";\n    opacity: 0.7;\n  }\n\n  100% {\n    content: \"完了\";\n    opacity: 1;\n  }\n}\n\n//Progress Bar\n.loader-border {\n  display: block;\n  position: relative;\n  border: 1px solid rgba(var.$primary-color, 0.8);\n  border-radius: 10px;\n  padding: 1px 1px 1px 1px;\n}\n.loader {\n  display: block;\n  position: relative;\n  // border: 1px solid var.$primary-color;\n  // border-radius: 10px;\n  overflow: hidden;\n  // animation-fill-mode: forwards;\n  // padding: 2px 2px 2px 2px;\n\n  .circle {\n    width: 20px;\n    height: 100%;\n    background: var.$primary-color;\n    // background-color: red;\n    border-radius: 10px;\n    // background-image: url(../icons/elements/progress_bar.svg);\n    // background-repeat: no-repeat;\n    // background-size: contain;\n    // background-position: 20%;\n    // padding: 13px;\n    position: absolute;\n    // box-sizing: border-box;\n    top: 50%;\n    left: 0;\n    transform: translateY(-50%);\n    z-index: 1;\n  }\n\n  .progress {\n    position: absolute;\n    left: 1;\n    top: 1;\n    height: 100%;\n    width: 0;\n    border-radius: 10px;\n    background: var.$primary-color;\n    // animation: prog 10s forwards;\n    // transition: width 2s;\n  }\n}\n\n// .loader:after {\n//   content: \"\";\n//   position: absolute;\n//   left: 1;\n//   top: 1;\n//   height: 100%;\n//   width: 0;\n//   border-radius: 10px;\n//   background: var.$primary-color;\n//   animation: prog 10s forwards;\n// }\n\n// @keyframes prog {\n//   0% {\n//     width: 5%;\n//   }\n\n//   100% {\n//     width: 100%;\n//   }\n// }\n\n//End Progress Bar\n\n//Button Opacity\n.opacity-button {\n  animation: fadeIn 5s;\n  -webkit-animation: fadeIn 5s;\n  -moz-animation: fadeIn 5s;\n  -o-animation: fadeIn 5s;\n  -ms-animation: fadeIn 5s;\n}\n\n//End Button Opacity\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n\n  50% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n@-moz-keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n\n  50% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n@-webkit-keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n\n  50% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n@-o-keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n\n  50% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n@-ms-keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n\n  50% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n//End loading modal\n\n//blink animation\n.blink {\n  animation: blink 0.5s linear infinite;\n}\n\n@keyframes blink {\n  0% {\n    opacity: 0;\n  }\n\n  50% {\n    opacity: 0.5;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n//End blink animation\n\n//choose group\n.choose-group-list {\n  .name {\n    width: 50%;\n  }\n  .groupno {\n    width: 50%;\n  }\n  //transition: all 0.3s ease-in-out;\n  font-family: \"Europa\";\n  .choose-arrow {\n    display: none;\n  }\n  &:hover {\n    // background-color: red;\n    .name {\n      width: 40%;\n    }\n    .groupno {\n      width: 40%;\n      text-align: right;\n    }\n    padding: 0 20px 0;\n  }\n\n  &:hover .choose-arrow {\n    display: block;\n  }\n}\n//end choose group\n\n// Login Mask Cropping\n.crop {\n  width: 300px;\n  height: 300px;\n  overflow: hidden;\n}\n\n.crop img {\n  width: 430px;\n  height: auto;\n  margin: 15px 0 0 -60px;\n}\n\n.error-valid-login {\n  font-family: \"Europa\";\n  color: #ff0000;\n  font-size: 18px;\n  line-height: 22px;\n  text-align: right;\n}\n\n// .login-container {\n//   height: 96px;\n// }\n\n.select-box {\n  border-radius: 5px;\n  background-color: white;\n  width: 100px;\n  // display: none;\n  // height: 80px;\n  z-index: 10;\n  .select-row {\n    color: black;\n    &:hover {\n      cursor: pointer;\n      background-color: #7a7373;\n    }\n  }\n}\n.dynamic-grid-container {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  grid-template-rows: repeat(5, min-content);\n  //grid-auto-flow: column;\n}\n\n.w-2 {\n  width: 2%;\n}\n\n.w-80 {\n  width: 80%;\n}\n.w-87 {\n  width: 87% !important;\n}\n.w-90 {\n  width: 90%;\n}\n\n.text-word-wrap {\n  word-wrap: break-word;\n}\n\n.gird-table {\n  table {\n    width: 100%;\n  }\n  thead,\n  tbody tr {\n    display: table;\n    width: 100%;\n    table-layout: fixed;\n  }\n  tbody {\n    overflow: hidden;\n    display: block;\n    overflow-y: auto;\n    table-layout: fixed;\n    max-height: 440px;\n  }\n  .grid-table-body {\n    td {\n      height: 80%;\n    }\n  }\n  .grid-table-header {\n    th {\n      height: 40px;\n    }\n  }\n}\n\n.table-row {\n  .tr-btn {\n    border-radius: 20px;\n    padding: 6px 15px;\n    cursor: pointer;\n  }\n\n  &:hover {\n    background: #262626 0% 0% no-repeat padding-box;\n    .text {\n      color: var.$primary-color;\n    }\n    .tr-btn {\n      background: var.$btn-primary-color;\n    }\n    .tr-icon {\n      fill: white;\n    }\n  }\n}\n\n.choose-perria-table {\n  table {\n    table-layout: fixed;\n    width: 400px;\n    border-collapse: collapse;\n    text-align: center;\n    font-size: 20px;\n    position: relative;\n  }\n\n  thead {\n    position: sticky;\n    left: 0;\n    top: 0;\n    background-color: black;\n    z-index: 2;\n\n    th {\n      padding-block: 10px;\n      color: #e8723c;\n      font-family: \"ethno-light\" !important;\n      font-weight: 300;\n\n      &:first-child {\n        width: 40%;\n      }\n      &:last-child {\n        width: 60%;\n      }\n    }\n  }\n\n  tbody {\n    tr {\n      position: relative;\n\n      td {\n        padding-block: 6px;\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        width: 50%;\n      }\n\n      &:hover {\n        cursor: pointer;\n        td {\n          &:first-child::before {\n            content: \"\";\n            position: absolute;\n            left: 0;\n            top: 50%;\n            width: 12px;\n            height: 6px;\n            background-image: url(\"../icons/arrow.svg\");\n            background-repeat: no-repeat;\n            background-size: contain;\n            background-position: center;\n            transform: rotate(180deg);\n          }\n\n          &:last-child::after {\n            content: \"\";\n            position: absolute;\n            right: 0;\n            top: 50%;\n            width: 12px;\n            height: 6px;\n            background-image: url(\"../icons/arrow.svg\");\n            background-repeat: no-repeat;\n            background-size: contain;\n            background-position: center;\n          }\n        }\n      }\n    }\n  }\n}\n\n.custom-table {\n  table {\n    table-layout: fixed;\n    width: 100%;\n    border-collapse: collapse;\n  }\n\n  th {\n    padding-block: 10px;\n    padding-left: 10px;\n  }\n\n  td {\n    padding-block: 6px;\n    padding-left: 20px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n\n  th:first-child,\n  td:first-child {\n    padding-left: 30px;\n  }\n\n  td:last-child {\n    padding-right: 30px;\n  }\n\n  th:last-child {\n    padding-right: 40px;\n  }\n\n  tbody > tr {\n    .action-btn {\n      color: var.$light-color;\n      text-decoration: none;\n      padding: 5px 10px;\n      border-radius: 35px;\n      background-color: transparent;\n      border: none;\n    }\n\n    &:hover {\n      color: var.$primary-color;\n      background-color: #262626;\n\n      .action-btn {\n        @include primary-gradient;\n\n        color: var.$light-color;\n\n        path {\n          fill: var.$light-color;\n          stroke: var.$light-color;\n        }\n      }\n    }\n  }\n}\n\n.drawchain-table {\n  th:last-child,\n  td:last-child {\n    padding-right: 20px;\n  }\n}\n\n// text\n.label-text {\n  color: var.$light-color;\n  font-size: 18px;\n}\n\n.parameter-label-text {\n  color: var.$light-color;\n  font-size: 14px;\n  font-family: \"NotoSansJP-light\";\n  text-align: center;\n}\n// end text\n\n.op-1 {\n  path {\n    opacity: 1;\n  }\n}\n\n.side-bar-container {\n  translate: 0 0;\n  scale: 100% 1;\n  z-index: 2;\n  transition: all 1s ease-in-out;\n}\n\n.side-bar-out {\n  translate: -100vw 0;\n  scale: 200% 1;\n}\n\n// .side-bar-in {\n//   animation-duration: 3s;\n//   animation-name: slidein;\n//   animation-timing-function: ease-in;\n//   animation-fill-mode: forwards;\n// }\n\n// .side-bar-out {\n//   animation-duration: 3s;\n//   animation-name: slideout;\n//   animation-timing-function: ease-out;\n//   animation-fill-mode: forwards;\n// }\n\n@keyframes slidein {\n  from {\n    translate: -100vw 0;\n    scale: 200% 1;\n  }\n\n  to {\n    translate: 0 0;\n    scale: 100% 1;\n  }\n}\n\n@keyframes slideout {\n  from {\n    translate: 0 0;\n    scale: 100% 1;\n  }\n\n  to {\n    translate: -100vw 0;\n    scale: 200% 1;\n  }\n}\n\n.vertical-text-container {\n  width: 40px;\n  height: auto;\n  writing-mode: vertical-lr;\n}\n\n.vertical-text {\n  transform: rotate(-90deg);\n  width: 0;\n  height: auto;\n  direction: rtl;\n  letter-spacing: 0.23em;\n}\n\n.vertical-en-text {\n  font-size: 47px;\n  color: var.$primary-color;\n  font-family: \"ethno-light\";\n  font-weight: 300;\n  line-height: 43px;\n  text-align: center;\n  span {\n    display: block;\n  }\n}\n\n.side-text-container {\n  position: absolute;\n  left: 0;\n  top: 0;\n  opacity: 0;\n  transition: opacity 1s ease-in-out;\n  z-index: 0;\n}\n\n.side-text-container.show {\n  z-index: 1;\n  opacity: 1;\n}\n\n.bg-btn-primary-color {\n  background: var.$btn-primary-color;\n}\n\n.center-vertical-line {\n  position: absolute;\n  width: 2px;\n  height: 30px;\n  background-color: rgba(122, 115, 115, 0.5);\n  left: calc(50% - 1px);\n}\n\n.fade-in-out {\n  opacity: 0;\n  visibility: hidden;\n}\n\n.fade-in-out.show {\n  visibility: visible;\n  animation: fadeIn 1s ease-in-out forwards;\n}\n","$primary-color: #f27a43; //#24b8c0\n$secondary-color: #afafaf; //#f634f2\n$danger-color: #ff0000;\n$dark-color: #000000;\n$highlight-color: #dcc97e;\n\n$light-color: #ffffff;\n$btn-primary-color: linear-gradient(270deg, #ed541d 0%, #f4901b 100%);\n\n$sm-screen: '640px';\n$md-screen: '768px';\n$lg-screen: '1024px';\n$xl-screen: '1280px';\n$xxl-screen: '1536px';\n\n//fonts\n$font-gkktt: '851ゴチカクット';\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
